var SHTHelper = window.SHTHelper || {};

var TRAP_FOCUS_HANDLERS = {};

SHTHelper.fetchConfigHTTP = {
  method: "POST",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    Accept: "application/javascript",
  },
};

SHTHelper.fetchConfigJSON = {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
};

SHTHelper.debounce = function (fn, delay) {
  let id = null;
  return function (args) {
    clearTimeout(id);
    id = null;
    id = setTimeout(function () {
      fn.call(this, args);
    }, delay);
  };
};

SHTHelper.removeTrapFocus = function (elementToFocus = null) {
  document.removeEventListener("focusin", TRAP_FOCUS_HANDLERS.focusin);
  document.removeEventListener("focusout", TRAP_FOCUS_HANDLERS.focusout);
  document.removeEventListener("keydown", TRAP_FOCUS_HANDLERS.keydown);

  if (elementToFocus) elementToFocus.focus();
};

SHTHelper.trapFocus = function (element, elementToFocus = element) {
  let headerLogoLink = SHTHelper.qs(".js-header-logo-link");
  let focusableEls = element.querySelectorAll(`a[href]:not([disabled]), [tabindex]:not([tabindex^='-']), summary, button:not([disabled]), textarea:not([disabled]), input:not([type=hidden]):enabled, input[type="text"]:not([disabled]), object, iframe, input[type="search"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])`);

  let firstFocusableEl = focusableEls[0];

  let lastFocusableEl = focusableEls[focusableEls.length - 1];

  if (focusableEls.length === 1 && headerLogoLink) {
    lastFocusableEl = headerLogoLink;
  }

  let KEYCODE_TAB = 9;

  SHTHelper.removeTrapFocus();

  TRAP_FOCUS_HANDLERS.focusin = event => {
    if (event.target !== element && event.target !== lastFocusableEl && event.target !== firstFocusableEl) return;

    document.addEventListener("keydown", TRAP_FOCUS_HANDLERS.keydown);
  };

  TRAP_FOCUS_HANDLERS.focusout = function () {
    document.removeEventListener("keydown", TRAP_FOCUS_HANDLERS.keydown);
  };

  TRAP_FOCUS_HANDLERS.keydown = function (e) {
    let isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB;

    if (!isTabPressed) {
      return;
    }
    if (e.shiftKey) {
      if (e.target === element || e.target === firstFocusableEl) {
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } else {
      if (e.target === lastFocusableEl) {
        firstFocusableEl.focus();
        e.preventDefault();
      }
    }
  };

  document.addEventListener("focusout", TRAP_FOCUS_HANDLERS.focusout);
  document.addEventListener("focusin", TRAP_FOCUS_HANDLERS.focusin);

  elementToFocus.focus();
};

SHTHelper.isColor = function (strColor) {
  let s = new Option().style;
  s.color = strColor;
  return s.color == strColor;
};

SHTHelper.isHexColor = function (color) {
  return /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/.test(color);
};

SHTHelper.isImage = function (url) {
  return /(\/\/)([^\s(["<,>/]*)(\/)[^\s[",><]*(.png|.jpg|.webp|.heic|.gif|.svg)(\?[^\s[",><]*)?/gi.test(url);
};

SHTHelper.preventStickyHeaderReveal = function () {
  let stickyHeader = SHTHelper.qs("sht-sticky-header");
  stickyHeader && stickyHeader.dispatchEvent(new Event("preventStickyHeaderReveal"));
};

SHTHelper.formatMoney = function (cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || window.theme_variables.settings.money_format;

  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = SHTHelper.formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = SHTHelper.formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = SHTHelper.formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = SHTHelper.formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = SHTHelper.formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = SHTHelper.formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = SHTHelper.formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = SHTHelper.formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
};

SHTHelper.defaultTo = function (value2, defaultValue) {
  return value2 == null || value2 !== value2 ? defaultValue : value2;
};

SHTHelper.formatWithDelimiters = function (number, precision, thousands, decimal) {
  precision = SHTHelper.defaultTo(precision, 2);
  thousands = SHTHelper.defaultTo(thousands, ",");
  decimal = SHTHelper.defaultTo(decimal, ".");
  if (isNaN(number) || number == null) {
    return 0;
  }
  number = (number / 100).toFixed(precision);
  let parts = number.split("."),
    dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
    centsAmount = parts[1] ? decimal + parts[1] : "";
  return dollarsAmount + centsAmount;
};

SHTHelper.loadScript = function (id, file, callback) {
  if (!SHTHelper.qs(`#${id}`)) {
    let script = document.createElement("script");
    script.setAttribute("src", `${file}`);
    script.setAttribute("id", `${id}`);
    script.onload = function () {
      callback();
    };
    script.onreadystatechange = function () {
      if (this.readyState == "complete" || this.readyState == "loaded") {
        callback();
      }
    };
    script.onerror = function (event) {
      console.log("Failed to load script file " + file, event);
      callback();
    };
    document.body.appendChild(script);
  } else {
    callback();
  }
};

SHTHelper.forceUpdateCartStatus = function (res) {
  let sections = [
    { section: "cart-drawer", selector: `.js-cart-drawer-wrapper`, space_selector: `.js-cart-drawer-wrapper` },
    {
      section: "header-cart-status",
      space_selector: `.shopify-section`,
      selector: `#headerCartStatus`,
      cart_notification: false,
    },
    {
      section: "main-cart",
      space_selector: `#mainCartContainer`,
      selector: `#mainCartContainer`,
      cart_notification: false,
    },
    {
      section: "cart-notification-panel-product",
      space_selector: `.js-cart-notification-panel-item-count`,
      selector: `.js-cart-notification-panel-item-count-content`,
      cart_notification: false,
    },
    {
      section: "cart-notification-panel-product",
      space_selector: `.js-cart-notification-panel-product-${res?.id}`,
      selector: `.js-cart-notification-panel-content`,
      cart_notification: true,
    },
  ];

  let cartNotification = SHTHelper.qs("sht-cart-noti");
  let stickyHeader = SHTHelper.qs("sht-sticky-header");

  let sectionsToStr = sections.map(section => section.section).join(",");

  fetch(`${window.location.pathname}?sections=${sectionsToStr}`)
    .then(response => {
      return response.json();
    })
    .then(json => {
      if (stickyHeader) {
        if (stickyHeader.dataset.isEnabled) {
          stickyHeader.reveal();
        }
      }
      sections.forEach(e => {
        let sectionHtml = json[e.section];
        let shouldBeUpdateElm = SHTHelper.qs(e.selector);
        if (sectionHtml && shouldBeUpdateElm) {
          let newElm = new DOMParser().parseFromString(sectionHtml, "text/html").querySelector(e.space_selector);
          if (newElm) {
            shouldBeUpdateElm.innerHTML = newElm.innerHTML;
          }

          if (e.cart_notification && cartNotification) {
            cartNotification.open();
          }
        }
      });
    })
    .catch(e => {
      console.log("Cannot force Update Cart Status");
    });
};

/**
 * Helper class to handle popup visibility in Shopify editor
 */
class SHTPopupEditorHelper {
  constructor(popupSource, sectionId) {
    this.popupSource = popupSource;
    this.sectionId = sectionId;
    this.boundHandler = this.handleSectionEvent.bind(this);
    this.isSectionSelected = false; // Track if section is currently selected

    // helper để luôn lấy element mới nhất
    this.getPopupElement = () => {
      return (typeof this.popupSource === 'function')
        ? this.popupSource()
        : this.popupSource;
    };

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      this.bindEditorEvents();
    }
  }

  bindEditorEvents() {
    document.addEventListener('shopify:section:select', this.boundHandler);
    document.addEventListener('shopify:section:deselect', this.boundHandler);
    document.addEventListener('shopify:section:load', this.boundHandler);
  }

  destroy() {
    document.removeEventListener('shopify:section:select', this.boundHandler);
    document.removeEventListener('shopify:section:deselect', this.boundHandler);
    document.removeEventListener('shopify:section:load', this.boundHandler);
  }

  handleSectionEvent(event) {
    const detail = event?.detail;
    if (!detail?.sectionId) return;

    const isTargetSection = detail.sectionId === this.sectionId;

    if (event.type === 'shopify:section:select' && isTargetSection) {
      this.isSectionSelected = true;
      this.getPopupElement(); // Refresh element reference
      this.showPopup();
    } else if (event.type === 'shopify:section:deselect' && isTargetSection) {
      this.isSectionSelected = false;
      this.hidePopup();
    } else if (event.type === 'shopify:section:load' && isTargetSection) {
      this.getPopupElement();

      setTimeout(() => {
        if (this.isSectionSelected) {
          this.showPopup();
        }
      }, 150);
    }
  }

  showPopup() {
    const el = this.getPopupElement();
    if (!el) return;

    if (typeof el.togglePopup === 'function') {
      el.togglePopup(true);
    } else {
      el.toggleAttribute('open', true);
    }
  }

  hidePopup() {
    const el = this.getPopupElement();
    if (!el) return;

    if (typeof el.togglePopup === 'function') {
      el.togglePopup(false);
    } else {
      el.toggleAttribute('open', false);
    }
  }
}

class SHTPredictiveSearchEditorHelper extends SHTPopupEditorHelper {
  /**
   * Get notification message from component
   * @returns {string} - Notification message
   */
  getNotificationMessage() {
    const comp = this.getPopupElement() || document.querySelector('sht-predictive-srch');
    if (comp && comp.dataset.noti) {
      return comp.dataset.noti;
    }
    // Fallback message
    return 'Quick Search section is currently hidden. Please enable the Quick Search section in the theme editor to use this feature.';
  }

  /**
   * Check if a section element is visible in the DOM
   * @param {HTMLElement} element - The section element to check
   * @returns {boolean} - True if element is visible, false otherwise
   */
  isSectionVisible(element) {
    if (!element) return false;
    
    // Check if element has hidden attribute
    if (element.hasAttribute('hidden')) return false;
    
    // Check computed style
    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
      return false;
    }
    
    // Check if element is in the document flow (offsetParent check)
    // Note: offsetParent can be null for fixed/absolute positioned elements, so we check both
    if (element.offsetParent === null && style.position !== 'fixed' && style.position !== 'absolute') {
      return false;
    }
    
    return true;
  }

  showPopup() {
    // Check if the section exists in the DOM
    const sectionElement = this.sectionId ? document.querySelector(`#shopify-section-${this.sectionId}`) : null;
    const comp = this.getPopupElement() || document.querySelector('sht-predictive-srch');
    
    // Check if section is visible (not hidden, even if not saved yet)
    const isSectionVisible = this.isSectionVisible(sectionElement);
    
    // If section is hidden or component doesn't exist, show alert
    if (!sectionElement || !isSectionVisible || !comp) {
      if (Shopify.designMode) {
        alert(this.getNotificationMessage());
      }
      return;
    }

    comp.toggleAttribute('open', true);
    document.body.classList.add('header--predictive-search-open', 'o-hidden');

    this.predictiveSearchElm = document.querySelector('.js-predictive-search');
    this.predictiveSearchInputElm = document.querySelector('.js-predictive-search-input');


    if (Shopify.designMode) {
      if (typeof SHTHelper?.removeTrapFocus === 'function') {
        SHTHelper.removeTrapFocus();
      }
      return;
    }

    setTimeout(() => {
      try {
        if (this.predictiveSearchElm && this.predictiveSearchInputElm && typeof SHTHelper?.trapFocus === 'function') {
          SHTHelper.trapFocus(this.predictiveSearchElm, this.predictiveSearchInputElm);
        }
      } catch (e) {
        console.warn('[PredictiveSearch] trapFocus failed:', e);
      }
    }, 300);
  }

  hidePopup() {
    const comp = this.getPopupElement() || document.querySelector('sht-predictive-srch');
    if (comp) comp.toggleAttribute('open', false);
    document.body.classList.remove('header--predictive-search-open', 'o-hidden');

    try {
      if (typeof SHTHelper?.releaseTrapFocus === 'function') {
        SHTHelper.releaseTrapFocus();
      }
    } catch (e) {
    }
  }
}

class SHTElementLazyLoad {
  constructor() {
    this.elements = SHTHelper.qsa(".js-main-body .js-animate");
    this.sequential_elements = SHTHelper.qsa(".js-main-body .js-seq-animate");
    //this.index = 1;
    this.setupEventListeners();
  }

  setupEventListeners() {
    let observer = new IntersectionObserver((entries, observer) => {
      for (let i = 0, n = entries.length; i < n; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add("animated");
          observer.unobserve(entries[i].target);
        }
      }
    });

    for (let i = 0, n = this.elements.length; i < n; i++) {
      observer.observe(this.elements[i]);
    }

    let sequentialObserver = new IntersectionObserver(
      (entries, observer) => {
        for (let i = 0, n = entries.length; i < n; i++) {
          let index = i * 100;
          if (entries[i].isIntersecting) {
            setTimeout(() => {
              entries[i].target.classList.add("animated");
            }, index);
            observer.unobserve(entries[i].target);
          }
        }
      },
      {
        threshold: 0.2,
      }
    );

    for (let i = 0, n = this.sequential_elements.length; i < n; i++) {
      sequentialObserver.observe(this.sequential_elements[i]);
    }
  }
}
setTimeout(() => {
  typeof SHTElementLazyLoad !== "undefined" && new SHTElementLazyLoad();
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", function (event) {
    typeof SHTElementLazyLoad !== "undefined" && new SHTElementLazyLoad();
  });
}

/*HELPER*/

class SHTCustomComponent extends HTMLElement {
  constructor() {
    super();
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
  }

  static initGlobalFeatures() {
    if (!SHTCustomComponent.globalFeaturesInitialized) {
      SHTCustomComponent.globalFeaturesInitialized = true;
      SHTCustomComponent.initPaymentButtonEnhancement();
    }
  }

  static enhancePaymentButton(button) {
    if (!button) return;
    
    // Always add classes - they might have been removed by Shopify re-init
    if (!button.classList.contains('btn')) {
      button.classList.add('btn');
    }
    if (!button.classList.contains('btn-primary--animate')) {
      button.classList.add('btn-primary--animate');
    }
    
    // Check if already has the wrapper structure
    const hasWrapper = button.querySelector('.btn-primary__content');
    
    if (!hasWrapper) {
      // Create outer wrapper span
      const outerWrapper = document.createElement('span');
      outerWrapper.className = 'd-block o-hidden p-relative';
      
      // Create inner content span
      const innerWrapper = document.createElement('span');
      innerWrapper.className = 'btn-primary__content';
      
      // Move all button children to inner wrapper
      while (button.firstChild) {
        innerWrapper.appendChild(button.firstChild);
      }
      
      // Append inner wrapper to outer wrapper
      outerWrapper.appendChild(innerWrapper);
      
      // Append outer wrapper to button
      button.appendChild(outerWrapper);
      
      // Mark as enhanced
      button.dataset.enhanced = 'true';
    } else if (!button.dataset.enhanced) {
      // Has wrapper but not marked - just mark it
      button.dataset.enhanced = 'true';
    }
  }

  static enhancePaymentButtons(container = document) {
    const buttons = container.querySelectorAll('.shopify-payment-button__button--unbranded');
    buttons.forEach(button => {
      SHTCustomComponent.enhancePaymentButton(button);
    });
    return buttons.length > 0;
  }

  static waitForPaymentButtons(container, timeout = 2000) {
    return new Promise((resolve) => {
      const checkAndEnhance = () => {
        const buttons = container.querySelectorAll('.shopify-payment-button__button--unbranded');
        if (buttons.length > 0) {
          buttons.forEach(button => SHTCustomComponent.enhancePaymentButton(button));
          return true;
        }
        return false;
      };

      // Try immediately
      if (checkAndEnhance()) {
        resolve();
        return;
      }

      // Setup observer for dynamic buttons
      const observer = new MutationObserver(() => {
        if (checkAndEnhance()) {
          observer.disconnect();
          resolve();
        }
      });

      observer.observe(container, { childList: true, subtree: true });
      
      // Timeout fallback
      setTimeout(() => {
        observer.disconnect();
        checkAndEnhance();
        resolve();
      }, timeout);
    });
  }

  static initPaymentButtonEnhancement() {
    SHTCustomComponent.enhancePaymentButtons();
    
    const observeContainers = () => {
      document.querySelectorAll('.shopify-payment-button').forEach(container => {
        if (container.dataset.observed === 'true') return;
        
        // Use debounced enhancement to handle rapid DOM updates
        let enhancementTimer = null;
        const debouncedEnhance = () => {
          clearTimeout(enhancementTimer);
          enhancementTimer = setTimeout(() => {
            SHTCustomComponent.enhancePaymentButtons(container);
          }, 100);
        };
        
        const observer = new MutationObserver((mutations) => {
          // Check if buttons were added or modified
          const hasButtonChanges = mutations.some(mutation => {
            return Array.from(mutation.addedNodes).some(node => {
              return node.nodeType === 1 && (
                node.classList?.contains('shopify-payment-button__button--unbranded') ||
                node.querySelector?.('.shopify-payment-button__button--unbranded')
              );
            });
          });
          
          if (hasButtonChanges) {
            debouncedEnhance();
          }
        });
        
        observer.observe(container, { 
          childList: true, 
          subtree: true,
          attributes: false 
        });
        container.dataset.observed = 'true';
      });
    };
    
    observeContainers();
    document.addEventListener('shopify:section:load', observeContainers);
    document.addEventListener('shopify:section:select', observeContainers);
  }
}

class LoadingBar extends HTMLElement {
  constructor() {
    super();

    this.bindEventHandlers();
  }

  bindEventHandlers() {
    document.addEventListener('page:loaded', this.handleLoaded.bind(this), { once: true });
    window.addEventListener('load', this.handleLoaded.bind(this), { once: true });
  }

  handleLoaded() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.style.display = 'none';
      return;
    }

    requestAnimationFrame(() => {
      this.classList.add('is-hidden');
    });
  }
}
customElements.define('loading-bar', LoadingBar);

class SHTHeader extends SHTCustomComponent {
  /**
   * Constructor
   */
  constructor() {
    super();

    this.searchHeaderOpenBtn = this.$$(".js-search-open-trigger");
    this.predictiveSearchElm = document.querySelector(".js-predictive-search");
    this.predictiveSearchInputElm = document.querySelector(".js-predictive-search-input");
    this.headerNavigation = this.$(".js-header-navigation");
    this.bodyElement = document.body;
    this.toggleNavItemBtn = this.$$(".js-toggle-nav-item");
    this.headerBounds = {};
    this.searchHeaderOpenBtn.forEach(btn => btn.addEventListener("click", this.openPredictiveSearch.bind(this)));
  }

  /**
   * Get notification message from component
   * @returns {string} - Notification message
   */
  getPredictiveSearchNotificationMessage() {
    const comp = document.querySelector('sht-predictive-srch');
    if (comp && comp.dataset.noti) {
      return comp.dataset.noti;
    }
    // Fallback message
    return 'Quick Search section is currently hidden. Please enable the Quick Search section in the theme editor to use this feature.';
  }

  /**
   * Check if predictive search section is visible
   * @returns {boolean} - True if section is visible, false otherwise
   */
  isPredictiveSearchVisible() {
    // Find the section element by looking for the component's section ID
    const comp = document.querySelector('sht-predictive-srch');
    if (!comp) return false;
    
    const sectionId = comp.dataset.sectionId;
    if (!sectionId) return false;
    
    const sectionElement = document.querySelector(`#shopify-section-${sectionId}`);
    if (!sectionElement) return false;
    
    // Check if section is visible
    if (sectionElement.hasAttribute('hidden')) return false;
    
    const style = window.getComputedStyle(sectionElement);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
      return false;
    }
    
    if (sectionElement.offsetParent === null && style.position !== 'fixed' && style.position !== 'absolute') {
      return false;
    }
    
    return true;
  }

  openPredictiveSearch(e) {
    // Check if the predictive search section is visible first (even if not saved yet)
    // This catches the case where section is hidden in editor before saving
    const isVisible = this.isPredictiveSearchVisible();
    
    if (!isVisible) {
      if (Shopify.designMode) {
        alert(this.getPredictiveSearchNotificationMessage());
      }
      return;
    }

    // Try to refresh element references in case section was loaded after header initialization
    if (!this.predictiveSearchElm || !this.predictiveSearchInputElm) {
      this.predictiveSearchElm = document.querySelector(".js-predictive-search");
      this.predictiveSearchInputElm = document.querySelector(".js-predictive-search-input");
    }

    // Check if the predictive search component elements exist
    if (!this.predictiveSearchElm || !this.predictiveSearchInputElm) {
      if (Shopify.designMode) {
        alert(this.getPredictiveSearchNotificationMessage());
      }
      return;
    }

    document.body.classList.add("header--predictive-search-open");
    this.bodyElement.classList.add("o-hidden");

    setTimeout(() => {
      SHTHelper.trapFocus(this.predictiveSearchElm, this.predictiveSearchInputElm);
    }, 650);
  }
}
customElements.define("sht-header", SHTHeader);

class SHTMenuHeader extends SHTCustomComponent {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.header = SHTHelper.qs(`sht-header`);
    this.enableDrawerDesk = this.header.dataset.enableDrawer === 'true';
    this.isHover = this.header.dataset.enableHover === 'hover';
    this.details = this.$("details");
    this.summaries = this.$$("summary");
    this.summary = this.details.querySelector("summary");
    this.content = this.summary.nextElementSibling;
    this.content_animations = null;
    this.isMegaMenu = this.dataset.menuDropdownType === 'Megamenu';
    this.isDesktop = window.matchMedia("(min-width: 1024px)").matches;
    this.bindEventHandlers();
    if (this.isMegaMenu) {
      this.onWindowResizeBound = this.onWindowResize.bind(this);
      window.addEventListener('resize', this.onWindowResizeBound);
    }
    if (this.isMegaMenu === false && this.isDesktop) {
      this.initSubmenuPositioning();
    }
  }

  disconnectedCallback() {
    if (this.onWindowResizeBound) {
      window.removeEventListener('resize', this.onWindowResizeBound);
    }
    if (this.megaMenuResizeObserver) {
      try { this.megaMenuResizeObserver.disconnect(); } catch(e) {}
      this.megaMenuResizeObserver = null;
      this.megaMenuWrapper = null;
    }
  }

  initSubmenuPositioning() {
    this.resizeObserver = new ResizeObserver(this.checkSubmenuPositions.bind(this));
    this.resizeObserver.observe(document.body);

    this.checkSubmenuPositions();
  }

  checkSubmenuPositions() {
    const dropdowns = this.$$('.menu-dropdown-lv2');

    dropdowns.forEach(dropdown => {
      const parentItem = dropdown.closest('.menu__item');
      if (!parentItem) return;

      const parentRect = parentItem.getBoundingClientRect();
      const viewportWidth = window.innerWidth;

      const spaceRight = viewportWidth - parentRect.right;

      const dropdownWidth = dropdown.offsetWidth;

      const nestedDropdown = dropdown.querySelector('.menu-dropdown-lv3');
      const nestedDropdownWidth = nestedDropdown ? nestedDropdown.offsetWidth : 0;

      const totalRequiredWidth = dropdownWidth + nestedDropdownWidth;

      dropdown.classList.remove('menu-dropdown--right');

      if (spaceRight <= totalRequiredWidth) {
        dropdown.classList.add('menu-dropdown--right');
      }
    });
  }

  bindEventHandlers() {

    this.mobileBreakpoint = window.matchMedia("(max-width: 1025px)");
    this.details.addEventListener("focusout", this.onFocusOutEvent.bind(this));

    // Fix Safari: clicking inside the component (e.g. summary elements) doesn't auto-focus,
    // which causes focusout to incorrectly close the menu. Track mousedown to prevent this.
    this.addEventListener("mousedown", () => {
      this._mouseDownInside = true;
    });

    if (!this.isHover) {
      this.handleMenuClick();
      return;
    }

    if (this.enableDrawerDesk || this.mobileBreakpoint.matches) {
      this.handleMenuClick();
    } else {
      this.handleMenuHover();
    }
  }

  isAnyMegaMenuOpen() {
    const openMegaMenu = document.querySelector(
      'sht-menu-header[data-menu-dropdown-type="Megamenu"] details[data-level="1"][open]'
    );
    return Boolean(openMegaMenu);
  }

  ensureHeaderMegaClass() {
    if (this.dataset.menuDropdownType === 'Megamenu') {
      this.header.classList.add('header-mega--open');
    }
  }

  updateHeaderMegaClassOnClose() {
    if (!this.isAnyMegaMenuOpen()) {
      this.header.classList.remove('header-mega--open');
    }
  }

  getMegaMenuHeight(details) {
    const wrapper = details?.querySelector('.js-mega-menu-wrapper');
    if (!wrapper) return 0;
    return wrapper.offsetHeight;
  }

  measureAndEmitMegaMenuHeight(details) {
    if (this.dataset.menuDropdownType !== 'Megamenu' || details?.dataset.level !== '1') return;

    requestAnimationFrame(() => {
      const height = this.getMegaMenuHeight(details);
      this.currentMegaMenuHeight = height;
      this.header?.style?.setProperty('--mega-menu-height', `${height}px`);

      const event = new CustomEvent('sht:mega-menu:height', {
        bubbles: true,
        detail: { height, details }
      });
      this.dispatchEvent(event);
    });
  }

  observeMegaMenu(details) {
    if (!details) return;
    const wrapper = details.querySelector('.js-mega-menu-wrapper');
    if (!wrapper) return;

    if (!this.megaMenuResizeObserver) {
      this.megaMenuResizeObserver = new ResizeObserver(() => {
        this.measureAndEmitMegaMenuHeight(details);
      });
    }

    if (this.megaMenuWrapper && this.megaMenuWrapper !== wrapper) {
      try { this.megaMenuResizeObserver.unobserve(this.megaMenuWrapper); } catch(e) {}
    }

    this.megaMenuWrapper = wrapper;
    try { this.megaMenuResizeObserver.observe(wrapper); } catch(e) {}
  }

  unobserveMegaMenu(details) {
    const wrapper = details ? details.querySelector('.js-mega-menu-wrapper') : this.megaMenuWrapper;
    if (this.megaMenuResizeObserver && wrapper) {
      try { this.megaMenuResizeObserver.unobserve(wrapper); } catch(e) {}
    }
    if (details && this.megaMenuWrapper === wrapper) {
      this.megaMenuWrapper = null;
    }
  }

  onWindowResize() {
    if (!this.isMegaMenu) return;
    if (!this.details) return;
    if (this.details.dataset.level !== '1') return;
    if (!this.details.hasAttribute('open')) return;
    this.measureAndEmitMegaMenuHeight(this.details);
  }


  handleMenuClick() {
    for (let i = 0, n = this.summaries.length; i < n; i++) {
      let summary = this.summaries[i];
      summary.addEventListener("click", (event) => {
        let details = event.currentTarget.closest("details");
        event.preventDefault();

        if (!details.hasAttribute("open")) {
          // Opening menu
          if (details.dataset.level == "1") {
            this.closeOtherLevel1Menus(details);
          } else if (details.dataset.level == "2") {
            this.closeOtherLevel2Menus(details);
          }
          
          // Ensure class is removed first for reflow
          details.classList.remove("is-open");
          event.currentTarget.setAttribute("aria-expanded", true);
          details.open = true;
          
          // Force reflow to ensure animation triggers
          void details.offsetHeight;
          
          // Add class in next frame to trigger animation
          requestAnimationFrame(() => {
            details.classList.add("is-open");
          });
          
          if (details.dataset.level == "1") {
            this.header.classList.add("header-menu--open");
            this.ensureHeaderMegaClass();
            this.measureAndEmitMegaMenuHeight(details);
            this.observeMegaMenu(details);
          }
        } else {
          // Closing menu - trigger animation, then close after animation completes
          event.currentTarget.setAttribute("aria-expanded", false);
          details.classList.remove("is-open");
          
          // Wait for CSS animation to complete (300ms) before removing open attribute
          setTimeout(() => {
            details.open = false;
            
            if (details.dataset.level == "1") {
              this.header.classList.remove("header-menu--open");
              this.updateHeaderMegaClassOnClose();
              this.unobserveMegaMenu(details);
            }
          }, 300);
        }
      });
      summary.addEventListener("keyup", this.onKeyUpEscEvent.bind(this));
    }
  }

  closeOtherLevel1Menus(currentDetails) {
    const allLevel1Details = this.querySelectorAll('details[data-level="1"]');

    allLevel1Details.forEach(details => {
      if (details !== currentDetails && details.hasAttribute("open")) {
        const summary = details.querySelector("summary");
        details.classList.remove("is-open");
        summary.setAttribute("aria-expanded", false);
        
        // Wait for animation before closing
        setTimeout(() => {
          details.open = false;
          this.unobserveMegaMenu(details);
        }, 300);
      }
    });
  }

  closeOtherLevel1MenusImmediate(currentDetails) {
    const allLevel1Details = this.querySelectorAll('details[data-level="1"]');

    allLevel1Details.forEach(details => {
      if (details !== currentDetails && details.hasAttribute("open")) {
        const summary = details.querySelector("summary");
        
        details.classList.add("hover-no-animation");
        details.classList.remove("is-open");
        summary.setAttribute("aria-expanded", false);
        details.open = false;
        this.unobserveMegaMenu(details);
        
        setTimeout(() => {
          details.classList.remove("hover-no-animation");
        }, 10);
      }
    });
  }

  closeOtherLevel2Menus(currentDetails) {
    const parentLevel1 = currentDetails.closest('details[data-level="1"]');
    if (!parentLevel1) return;

    const allLevel2Details = parentLevel1.querySelectorAll('details[data-level="2"]');

    allLevel2Details.forEach(details => {
      if (details !== currentDetails && details.hasAttribute("open")) {
        const summary = details.querySelector("summary");
        details.classList.remove("is-open");
        summary.setAttribute("aria-expanded", false);
        
        // Wait for animation before closing
        setTimeout(() => {
          details.open = false;
        }, 300);
      }
    });
  }

  closeOtherLevel2MenusImmediate(currentDetails) {
    const parentLevel1 = currentDetails.closest('details[data-level="1"]');
    if (!parentLevel1) return;

    const allLevel2Details = parentLevel1.querySelectorAll('details[data-level="2"]');

    allLevel2Details.forEach(details => {
      if (details !== currentDetails && details.hasAttribute("open")) {
        const summary = details.querySelector("summary");
        
        details.classList.add("hover-no-animation");
        details.classList.remove("is-open");
        summary.setAttribute("aria-expanded", false);
        details.open = false;
        
        setTimeout(() => {
          details.classList.remove("hover-no-animation");
        }, 10);
      }
    });
  }
  onKeyUpEscEvent(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    let openedDetails = event.target.closest("details[open]");
    if (!openedDetails) return;

    let summary = openedDetails.querySelector("summary");

    // Remove is-open class to trigger animation
    openedDetails.classList.remove("is-open");
    summary.setAttribute("aria-expanded", false);
    
    // Wait for animation before closing
    setTimeout(() => {
      openedDetails.removeAttribute("open");

      if (openedDetails.dataset.level == "1") {
        this.header.classList.remove("header-menu--open");
        this.updateHeaderMegaClassOnClose();
        
        if (this.dataset.menuDropdownType === 'Megamenu') {
          this.unobserveMegaMenu(openedDetails);
        }
      }
    }, 300);

    summary.focus();
  }

  onFocusOutEvent() {
    setTimeout(() => {
      // Safari fix: if mousedown happened inside this component, don't close
      if (this._mouseDownInside) {
        this._mouseDownInside = false;
        return;
      }
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  handleMenuHover() {
    this.hoverTimeout = null;
    this.level2HoverTimeouts = new Map();
    this.entryDelayTimeouts = new Map();
    this.currentOpenMenu = null;
    this.currentOpenLevel2Menus = new Set();

    for (let i = 0, n = this.summaries.length; i < n; i++) {
      let summary = this.summaries[i];
      let details = summary.closest("details");

      if (details.dataset.level === "1") {
        const isMegaMenu = this.dataset.menuDropdownType === 'Megamenu';
        
        if (isMegaMenu) {
          this.addEventListener("mouseenter", (event) => {
            this.onMenuHover(details, true);
          });

          this.addEventListener("mouseleave", (event) => {
            this.onMenuHover(details, false);
          });
        } else {
          let menuItem = details.closest('.menu__item');
          if (!menuItem) return;

          menuItem.addEventListener("mouseenter", (event) => {
            this.onMenuHover(details, true);
          });

          menuItem.addEventListener("mouseleave", (event) => {
            this.onMenuHover(details, false);
          });
        }
      }

      if (details.dataset.level === "2") {
        let parentLevel1 = details.closest('details[data-level="1"]');
        let isMegaMenu = parentLevel1 && parentLevel1.closest('.menu__item-megamenu');

        if (!isMegaMenu) {
          let submenuItem = details.closest('.submenu__item');

          if (!submenuItem) return;

          submenuItem.addEventListener("mouseenter", (event) => {
            this.onLevel2MenuHover(details, true);
          });

          submenuItem.addEventListener("mouseleave", (event) => {
            this.onLevel2MenuHover(details, false);
          });
        }
      }
    }

    for (let i = 0, n = this.summaries.length; i < n; i++) {
      let summary = this.summaries[i];
      summary.addEventListener("keyup", this.onKeyUpEscEvent.bind(this));
    }
  }

  onMenuHover(details, isEntering) {
    clearTimeout(this.hoverTimeout);
    
    if (this.entryDelayTimeouts.has(details)) {
      clearTimeout(this.entryDelayTimeouts.get(details));
      this.entryDelayTimeouts.delete(details);
    }

    const isMegaMenu = this.dataset.menuDropdownType === 'Megamenu';
    const HOVER_ENTRY_DELAY = 250;
    const HOVER_EXIT_DELAY = 300;

    if (isEntering) {
      const hasOtherOpenMenu = this.currentOpenMenu && this.currentOpenMenu !== details;

      if (hasOtherOpenMenu) {
        this.closeOtherLevel1MenusImmediate(details);
        this.openHoverMenu(details);
        this.currentOpenMenu = details;
      } else if (isMegaMenu && !this.currentOpenMenu) {
        const entryDelayId = setTimeout(() => {
          this.closeOtherLevel1MenusImmediate(details);
          this.openHoverMenu(details);
          this.currentOpenMenu = details;
          this.entryDelayTimeouts.delete(details);
        }, HOVER_ENTRY_DELAY);
        
        this.entryDelayTimeouts.set(details, entryDelayId);
      } else {
        this.closeOtherLevel1MenusImmediate(details);
        this.openHoverMenu(details);
        this.currentOpenMenu = details;
      }

    } else {
      if (isMegaMenu) {
        this.hoverTimeout = setTimeout(() => {
          this.closeHoverMenu(details);
          if (this.currentOpenMenu === details) {
            this.currentOpenMenu = null;
          }
        }, HOVER_EXIT_DELAY);
      } else {
        this.closeHoverMenu(details);
        if (this.currentOpenMenu === details) {
          this.currentOpenMenu = null;
        }
      }
    }
  }

  onLevel2MenuHover(details, isEntering) {
    const parentLevel1 = details.closest('details[data-level="1"]');
    const HOVER_DELAY_LEVEL_2 = 150;

    if (this.level2HoverTimeouts.has(details)) {
      clearTimeout(this.level2HoverTimeouts.get(details));
      this.level2HoverTimeouts.delete(details);
    }

    if (this.entryDelayTimeouts.has(details)) {
      clearTimeout(this.entryDelayTimeouts.get(details));
      this.entryDelayTimeouts.delete(details);
    }

    if (isEntering) {
      const hasOtherOpenLevel2 = Array.from(this.currentOpenLevel2Menus)
        .some(openMenu => openMenu !== details && 
              openMenu.closest('details[data-level="1"]') === parentLevel1);
      
      if (hasOtherOpenLevel2) {
        const entryDelayId = setTimeout(() => {
          this.closeOtherLevel2MenusImmediate(details);
          this.openHoverMenu(details);
          this.currentOpenLevel2Menus.add(details);
          this.entryDelayTimeouts.delete(details);
        }, HOVER_DELAY_LEVEL_2);
        
        this.entryDelayTimeouts.set(details, entryDelayId);
      } else {
        this.closeOtherLevel2MenusImmediate(details);
        this.openHoverMenu(details);
        this.currentOpenLevel2Menus.add(details);
      }

    } else {
      const timeoutId = setTimeout(() => {
        this.closeHoverMenu(details);
        this.currentOpenLevel2Menus.delete(details);
        this.level2HoverTimeouts.delete(details);
      }, 50);

      this.level2HoverTimeouts.set(details, timeoutId);
    }
  }

  openHoverMenu(details) {
    if (!details.hasAttribute("open")) {
      // Set details open first
      details.open = true;
      let summary = details.querySelector("summary");
      summary.setAttribute("aria-expanded", true);

      // Force reflow to ensure the browser registers the state change
      void details.offsetHeight;

      // Add is-open class in the next animation frame for smooth transition
      requestAnimationFrame(() => {
        details.classList.add("is-open");
      });

      if (details.dataset.level === "1") {
        this.header.classList.add("header-menu--open");
        this.ensureHeaderMegaClass();
        this.measureAndEmitMegaMenuHeight(details);
        this.observeMegaMenu(details);
      }
    }
  }

  closeHoverMenu(details) {
    if (details.hasAttribute("open")) {
      // Remove is-open class first to trigger CSS closing animation
      details.classList.remove("is-open");
      let summary = details.querySelector("summary");
      summary.setAttribute("aria-expanded", false);

      // Wait for CSS animation to complete (300ms) before actually closing
      setTimeout(() => {
        details.open = false;
        
        if (details.dataset.level === "1") {
          this.header.classList.remove("header-menu--open");
        }
        this.updateHeaderMegaClassOnClose();
        if (details.dataset.level === "1") {
          this.unobserveMegaMenu(details);
        }
      }, 300);
    }
  }

  close() {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }

    if (this.level2HoverTimeouts) {
      this.level2HoverTimeouts.forEach(timeoutId => clearTimeout(timeoutId));
      this.level2HoverTimeouts.clear();
    }

    if (this.entryDelayTimeouts) {
      this.entryDelayTimeouts.forEach(timeoutId => clearTimeout(timeoutId));
      this.entryDelayTimeouts.clear();
    }

    const shouldRemoveHeaderClass = this.details.dataset.level == "1" && this.details.hasAttribute("open");

    for (let i = 0, n = this.summaries.length; i < n; i++) {
      let summary = this.summaries[i];
      let details = summary.closest("details");

      if (details.hasAttribute("open")) {
        details.classList.remove("is-open");
        summary.setAttribute("aria-expanded", false);
        
        // Wait for animation before closing
        setTimeout(() => {
          details.removeAttribute("open");
        }, 300);
      }
    }

    if (shouldRemoveHeaderClass) {
      setTimeout(() => {
        this.header.classList.remove("header-menu--open");
      }, 300);
    }

    this.currentOpenMenu = null;
    if (this.currentOpenLevel2Menus) {
      this.currentOpenLevel2Menus.clear();
    }

    setTimeout(() => {
      this.updateHeaderMegaClassOnClose();
    }, 300);
  }

  disconnectedCallback() {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }

    if (this.level2HoverTimeouts) {
      this.level2HoverTimeouts.forEach(timeoutId => clearTimeout(timeoutId));
      this.level2HoverTimeouts.clear();
    }

    if (this.entryDelayTimeouts) {
      this.entryDelayTimeouts.forEach(timeoutId => clearTimeout(timeoutId));
      this.entryDelayTimeouts.clear();
    }
  }
}
customElements.define("sht-menu-header", SHTMenuHeader);

class SHTStickyHeader extends SHTCustomComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header_sticky = this.dataset.headerSticky;

    this.prevent_reveal = false;
    this.css_ary = ["top-0", "zi-4", "header--sticky", "is-header-hide"];

    this.header = SHTHelper.qs(".js-section-header");
    this.cartNotificationPanel = this.$('.js-cartNotificationPanel');
    this.currentScrollTop = 0;
    this.headerBounds = {};

    this.bindEventHandlers();

    if (this.header_sticky == "disable") {
      return false;
    } else if (this.header_sticky == "always") {
      this.header.classList.add("header--sticky-always");
      this._checkStickyAlwaysPosition();
      this._bindStickyAlwaysScrollHandler();
    } else {
      this.createObserver();
    }
  }

  bindEventHandlers() {
    if (this.header_sticky == "disable") return false;

    this.preventStickyHeaderReveal = () => (this.prevent_reveal = true);
    this.addEventListener("preventStickyHeaderReveal", this.preventStickyHeaderReveal);

    window.addEventListener("scroll", this.onScrollHandle.bind(this), false);
  }

  /**
   * Check header position and add/remove is-sticky-always class
   * @private
   */
  _checkStickyAlwaysPosition() {
    if (!this.header) return;

    const headerRect = this.header.getBoundingClientRect();
    const headerTop = headerRect.top;

    if (headerTop > 0.5) {
      this.header.classList.remove("header--sticky-always");
    } else {
      this.header.classList.add("header--sticky-always");
    }
  }

  /**
   * Bind scroll handler specifically for sticky always mode
   * @private
   */
  _bindStickyAlwaysScrollHandler() {
    this.stickyAlwaysScrollHandler = () => {
      this._checkStickyAlwaysPosition();
    };

    window.addEventListener("scroll", this.stickyAlwaysScrollHandler, false);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.header_bounds = entries[0].intersectionRect;

      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScrollHandle() {

    if (!this.header_bounds) return;

    let scrollTop = window.pageYOffset || SHTHelper.qde.scrollTop;
    if (scrollTop > this.currentScrollTop && scrollTop > this.header_bounds.bottom) {
      if (this.prevent_reveal) {
        window.clearTimeout(this.is_scrolling);
        this.is_scrolling = setTimeout(() => {
          this.prevent_reveal = false;
        }, 20);
        return;
      }

      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.header_bounds.bottom) {
      if (this.prevent_reveal) {
        requestAnimationFrame(this.hide.bind(this));
        window.clearTimeout(this.is_scrolling);
        this.is_scrolling = setTimeout(() => {
          this.prevent_reveal = false;
        }, 20);
        return;
      }
      requestAnimationFrame(this.reveal.bind(this));
    } else if (scrollTop <= this.header_bounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    } else {
      //do nothing
    }

    this.currentScrollTop = scrollTop;
  }
  hide() {
    this.header.classList.add("is-header-hide", "p-sticky", "top-0", "zi-4", "header--sticky");
    this.cartNotificationPanel.hidden = true;
    this.closeMenu();
  }
  reveal() {
    this.header.classList.add("top-0", "animate", "zi-4", "p-sticky", "header--sticky");
    this.header.classList.remove("is-header-hide");
  }
  reset() {
    this.header.classList.remove("is-header-hide", "top-0", "animate", "header--sticky", "p-sticky");
  }

  closeMenu() {
    this.menus = this.header.querySelectorAll("sht-menu-header");

    for (let i = 0, n = this.menus.length; i < n; i++) {
      this.menus[i].close();
    }
  }

  disconnectedCallback() {
    this.removeEventListener("preventStickyHeaderReveal", this.preventStickyHeaderReveal);
    window.removeEventListener("scroll", this.onScrollHandle.bind(this));
  }
}
customElements.define("sht-sticky-header", SHTStickyHeader);

class SHTCartNotificationPanel extends SHTCustomComponent {
  constructor() {
    super();
    this.elms = {
      notification_wrapper: this.$(`.js-cart-notification-panel-wrapper`),
      notification_container: this.$(`.js-cart-notification-panel-container`),
      close_buttons: this.$$(".js-cart-notification-panel-close-btn"),
      sticky_header: SHTHelper.qs("sht-sticky-header"),
    };
    this.dismiss_timeout = null;

    for (let i = 0, n = this.elms.close_buttons.length; i < n; i++) {
      this.elms.close_buttons[i].addEventListener("click", this.close.bind(this));
    }
  }

  async open() {
    this.togglePanel(true);
    await this.animationsComplete();
    this.elms.notification_container.focus();
    this.addEventListener("mouseover", this.onMouseOverHandle.bind(this));
    this.addEventListener("mouseout", this.onMouseOutHandle.bind(this));
    this.setDismissTimeout();
    SHTHelper.trapFocus(this);
  }

  async close() {
    this.clearDismissTimeout();
    this.togglePanel(false);
    await this.animationsComplete();

    this.dispatchEvent(new Event("closed"));
    if (this.element_to_focus) {
      SHTHelper.removeTrapFocus(this.element_to_focus);
      this.element_to_focus = null;
    } else {
      SHTHelper.removeTrapFocus();
    }
  }

  animationsComplete() {
    return Promise.allSettled(
      this.getAnimations().map(animation => animation.finished)
    );
  }

  clearDismissTimeout() {
    clearTimeout(this.dismiss_timeout);
  }

  renderContents(response, isOpenNoti = true, elementToFocus = null) {
    this.element_to_focus = elementToFocus;
    this.productId = response.id;
    let sections = this.getSectionsToRender();
    for (let i = 0, n = sections.length; i < n; i++) {
      let element = SHTHelper.qs(sections[i].space_selector);
      if (element) {
        if (sections[i].space_selector == "#headerCartStatus") {
          element.classList.add("header-cart-status--animate");
        }
        element.innerHTML = this.getSectionInnerHTML(response.sections[sections[i].id], sections[i].selector);
      }
    }
    if (isOpenNoti) {
      this.open();
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-panel-product",
        selector: `.js-cart-notification-panel-product-${this.productId}`,
        space_selector: `.js-cart-notification-panel-content`,
      },
      {
        id: "free-shipping-notification",
        selector: `.js-free-shipping-notification`,
        space_selector: `.js-cart-notification-free-shipping`,
      },
      {
        id: "header-cart-status",
        section: "header-cart-status",
        space_selector: `#headerCartStatus`,
      },
      {
        id: "cart-notification-panel-product",
        selector: `.js-cart-notification-panel-item-count`,
        space_selector: `.js-cart-notification-panel-item-count-content`,
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  onMouseOverHandle(evt) {
    this.clearDismissTimeout();
  }

  onMouseOutHandle(evt) {
    this.setDismissTimeout();
  }

  togglePanel(toggle) {
    if (toggle) {
      this.toggleAttribute("hidden", false);
    } else {
      this.setAttribute("hidden", true);
    }
    return;
  }

  setDismissTimeout() {
    this.dismiss_timeout = setTimeout(
      function () {
        this.close();
      }.bind(this),
      5000
    );
    if (this.elms.sticky_header.dataset.isEnabled == 'false') {
      setTimeout(() => {
        this.elms.sticky_header.reset();
      }, 6000);
    }
  }
}

customElements.define("sht-cart-noti", SHTCartNotificationPanel);

class SHTCarousel extends SHTCustomComponent {
  constructor() {
    super();
    this.carousels = this.$$(".js-carousel-item");
    this.container = this.$(".js-carousel-items");
    this.totalItems = this.carousels.length;
    this.prevBtnElement = this.$(".js-carousel-prev-btn");
    this.nextBtnElement = this.$(".js-carousel-next-btn");
    this.currentElement = this.$(".js-carousel-counter-current");
    this.totalElement = this.$(".js-carousel-counter-total");
    this.paginationElement = this.$(".js-carousel-pagination");
    this.init();
    this.bindEventHandlers();
  }
  init() {
    if (this.dataset.enable == "false") return;
    this.itemsToShow = Array.from(this.carousels).filter(element => element.clientWidth > 0);
    if (this.itemsToShow.length < 2) {
      this.togglePagination(false);
      return;
    }
    this.gutter = parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-left")) + parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-right"));
    this.itemOffset = this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft;
    this.itemsPerPage = Math.floor((this.container.clientWidth - this.itemsToShow[0].offsetLeft) / this.itemOffset);
    // this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1;
    this.updateCarousel();
  }
  updateCarousel() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.container.scrollLeft / this.itemOffset) + 1;
    if (this.currentPage > 0 && this.totalPages > 0) {
      if (this.totalElement) {
        this.totalElement.textContent = this.totalPages;
      }
      if (this.currentElement) {
        this.currentElement.innerHTML = this.currentPage;
      }
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("itemChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.itemsToShow[this.currentPage - 1],
            container: this,
          },
        })
      );
    }
    if (this.isItemVisible(this.itemsToShow[0]) && this.container.scrollLeft === 0) {
      this.prevBtnElement?.setAttribute("disabled", "disabled");
    } else {
      this.prevBtnElement?.removeAttribute("disabled");
    }
    if (this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      this.nextBtnElement?.setAttribute("disabled", "disabled");
    } else {
      this.nextBtnElement?.removeAttribute("disabled");
    }

    if (this.totalPages > 1) {
      this.togglePagination(true);
    }

    if (this.totalPages <= 1) {
      this.togglePagination(false);
    }
  }

  togglePagination(flag) {
    if (flag) {
      this.paginationElement?.classList.remove("d-none-important");
    } else {
      this.paginationElement?.classList.add("d-none-important");
    }
  }
  isItemVisible(element, offset = 0) {
    const lastVisibleItem = this.container.clientWidth + this.container.scrollLeft - offset + 1;
    return element.offsetLeft + element.clientWidth <= lastVisibleItem && element.offsetLeft >= this.container.scrollLeft - 1;
  }
  onButtonClick(event) {
    event.preventDefault();
    let step = 1;
    let gutter = 0;
    const mediaQuery = window.matchMedia("(min-width: 459px)");
    if (mediaQuery.matches) {
      step = event.currentTarget.dataset.step;
    }
    if (this.container.scrollLeft == 0 || this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      gutter = this.gutter;
    }
    this.itemScrollPosition = event.currentTarget.name === "next" ? this.container.scrollLeft - gutter + step * this.itemOffset : this.container.scrollLeft + gutter - step * this.itemOffset;
    window.requestAnimationFrame(() =>
      this.container.scrollTo({
        left: this.itemScrollPosition,
        behavior: "smooth",
      })
    );
  }
  bindEventHandlers() {
    if (this.dataset.enable == "false") return;
    const resizeObserver = new ResizeObserver(entries => this.init());
    resizeObserver.observe(this.container);

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      this.init();
      observer.unobserve(this);
    };
    new IntersectionObserver(handleIntersection.bind(this)).observe(this);

    this.prevBtnElement?.addEventListener("click", this.onButtonClick.bind(this));
    this.nextBtnElement?.addEventListener("click", this.onButtonClick.bind(this));
    this.container?.addEventListener("scroll", SHTHelper.debounce(this.updateCarousel.bind(this), 100));
  }
}
customElements.define("sht-carousel", SHTCarousel);

class SHTCarouselTrigger extends SHTCustomComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      setTimeout(() => {
        this.init();
      }, 1000);
    } else {
      this.init();
    }
  }

  init() {
    this.trigger = this.$$(".js-carousel-trigger");
    this.carouselWebElement = SHTHelper.qs(`#${this.dataset.carouselTarget}`);
    this.carousel = this.carouselWebElement.querySelector(`.js-carousel-items`);

    this.bindEventHandlers();
  }

  bindEventHandlers() {
    for (let i = 0, n = this.trigger.length; i < n; i++) {
      this.trigger[i].addEventListener("click", event => {
        this.setActiveCarouselElement(event.currentTarget);
      });
    }

    this.carouselWebElement.addEventListener("itemChanged", e => {
      this.setButtonVisibility(false);
      let buttonElement = this.$(`[aria-describedby="${e.detail.currentElement.id}"]`);

      buttonElement.setAttribute("aria-current", "true");
      buttonElement.classList.add("hotspot-item--active");
    });
  }

  setActiveCarouselElement(el) {
    let carouselItem = this.carousel.querySelector(`#${el.getAttribute("aria-describedby", "")}`);

    if (carouselItem) {
      this.carousel.scrollTo({
        left: carouselItem.offsetLeft,
        behavior: "smooth",
      });
    }
  }

  setButtonVisibility(flag) {
    if (this.trigger) {

      for (let i = 0, n = this.trigger.length; i < n; i++) {
        if (flag) {
          this.trigger[i].setAttribute("aria-current", "true");
          this.trigger[i].classList.add("hotspot-item--active");
        } else {
          this.trigger[i].removeAttribute("aria-current");
          this.trigger[i].classList.remove("hotspot-item--active");
        }
      }
    }
  }
}
customElements.define("sht-carousel-trig", SHTCarouselTrigger);

class SHTCoreDrawer extends SHTCustomComponent {
  constructor() {
    super();
    this.drawerWrapperElement = this.$(".js-drawer-wrapper");
    this.drawerOverlayElement = this.$(".js-drawer-overlay");
    this.closeBtnElement = this.$(".js-drawer-btn-close");
    this.opener = null;
    this.bodyElement = document.body;
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.drawerOverlayElement.addEventListener("click", this.closeDrawer.bind(this));

    this.closeBtnElement.addEventListener("click", this.closeDrawer.bind(this));
    window.addEventListener("load", () => {
      this.removeAttribute("hidden");
    });

    this.addEventListener("keyup", evt => evt.code.toUpperCase() === "ESCAPE" && this.closeDrawer());
    this.drawerAttrObserve();
  }

  drawerAttrObserve() {
    let drawerAttrObserver = new MutationObserver((mutations, observer) => {
      mutations.forEach(async mutation => {
        if (mutation.attributeName == "open") {
          const isOpen = this.hasAttribute("open");
          if (isOpen) {
            this.opener?.removeAttribute("disabled");
            this.opener?.setAttribute("aria-expanded", "true");
            this.setAttribute("aria-hidden", "false");
            this.dispatchEvent(new Event("opening"));
            this.bodyElement.classList.add("o-hidden");
            this.classList.add("active");
            await this.animationsComplete();
            this.dispatchEvent(new Event("opened"));
            SHTHelper.trapFocus(this);
          } else {
            SHTHelper.removeTrapFocus(this.opener);
            this.setAttribute("aria-hidden", "true");
            this.opener?.setAttribute("aria-expanded", "false");
            this.opener?.removeAttribute("disabled");
            this.dispatchEvent(new Event("closing"));
            this.bodyElement.classList.remove("o-hidden");
            this.classList.remove("active");
            await this.animationsComplete();
            this.dispatchEvent(new Event("closed"));
          }
        }
      });
    });

    drawerAttrObserver.observe(this, {
      attributes: true,
    });
  }

  animationsComplete() {
    return Promise.allSettled(this.drawerWrapperElement.getAnimations().map(animation => animation.finished));
  }

  openDrawer(opener) {
    SHTHelper.preventStickyHeaderReveal();
    this.opener = opener;
    this.removeAttribute("hidden");
    this.toggleAttribute("open", true);
  }

  closeDrawer() {
    this.toggleAttribute("open", false);
  }
}

class SHTDrawer extends SHTCoreDrawer {}
customElements.define("sht-drwr", SHTDrawer);

class SHTDrawerTrigger extends SHTCustomComponent {
  constructor() {
    super();
  }

  init() {
    this.triggerBtnElement = this.$(".js-drawer-trigger");
    this.drawerElement = SHTHelper.qs(`sht-drwr#${this.dataset.drawerId}`);

    if (!this.triggerBtnElement || !this.drawerElement) return;

    this.mediaElement = this.$(".js-drawer-trigger-media");
    this.headingElement = this.$(".js-drawer-trigger-heading");
    this.contentElements = this.$$(".js-drawer-trigger-content");
    this.footerElement = this.$(".js-drawer-trigger-footer");
    this.bindEventHandlers();
  }

  bindDataToDrawer() {
    let drawerContent = "";

    this.drawerElement.querySelector(".js-drawer-media").innerHTML = this.mediaElement.innerHTML;

    this.drawerElement.querySelector(".js-drawer-heading").innerHTML = this.headingElement.innerHTML;

    this.drawerElement.querySelector(".js-drawer-wrapper").setAttribute("aria-label", this.headingElement.innerHTML);

    this.contentElements.forEach(element => {
      drawerContent = drawerContent + element.innerHTML;
    });

    this.drawerElement.querySelector(".js-drawer-content").innerHTML = drawerContent;

    if (this.footerElement) {
      this.drawerElement.querySelector(".js-drawer-footer").innerHTML = this.footerElement.innerHTML;
      let footerButtons = this.drawerElement.querySelector(".js-drawer-footer").querySelectorAll(".js-drawer-trigger-footer-btn");

      footerButtons.forEach(e => {
        e.classList.add("btn-drawer");
      });
    }
  }

  bindEventHandlers() {
    this.triggerBtnElement.addEventListener("click", e => {
      setTimeout(() => {
        this.bindDataToDrawer();
        this.drawerElement.openDrawer(e.target);
      }, 100);
    });
  }

  connectedCallback() {
    if (Shopify.designMode) {
      setTimeout(() => {
        this.init();
      }, 1000);
    } else {
      this.init();
    }
  }
}
customElements.define("sht-drwr-trg", SHTDrawerTrigger);

class SHTCartDrawer extends SHTCoreDrawer {
  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        section: "cart-drawer",
        space_selector: `#cartDrawer`,
      },
    ];
  }
}
customElements.define("sht-cart-drwr", SHTCartDrawer);

class SHTCartDrawerCartNote extends SHTCustomComponent {
  constructor() {
    super();
    this.addEventListener(
      "change",
      SHTHelper.debounce(event => {
        const body = JSON.stringify({
          note: event.target.value,
        });
        fetch(`${window.routes.cart_update_url}`, {
          ...SHTHelper.fetchConfigJSON,
          ...{
            body,
          },
        });
      }, 300)
    );
  }
}
customElements.define("sht-cart-drwr-note", SHTCartDrawerCartNote);

class SHTCartDrawerQuantityInput extends SHTCustomComponent {
  constructor() {
    super();
    this.input = this.$(`.js-cart-drawer-quantity-input`);
    this.changeEvent = new Event("change", {
      bubbles: true,
    });
    this.button = this.$$(".js-cart-drawer-quantity-btn");
    for (let i = 0, n = this.button.length; i < n; i++) {
      this.button[i].addEventListener("click", this.onButtonClickHandler.bind(this));
    }
  }
  onButtonClickHandler(event) {
    event.preventDefault();

    let previousValue = this.input.value;
    event.currentTarget.dataset.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
}
customElements.define("sht-cart-drwr-qty-inp", SHTCartDrawerQuantityInput);
class SHTCartDrawerRemoveButton extends SHTCustomComponent {
  constructor() {
    super();
    this.addEventListener("click", event => {
      event.preventDefault();
      this.closest("sht-cart-drwr-frm").updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define("sht-cart-drwr-rmv-btn", SHTCartDrawerRemoveButton);

class SHTCartDrawerForm extends SHTCustomComponent {
  constructor() {
    super();
    this.totalItems = Array.from(this.$$(".js-cart-drawer-quantity-input")).reduce((total, ele) => total + parseInt(ele.value), 0);
    this.drawerCartElement = SHTHelper.qs("sht-cart-drwr");
    this.wrapperElement = this.drawerCartElement.querySelector(".js-cart-drawer-wrapper");
    this.cartNotification = SHTHelper.qs("sht-cart-noti");
    this.isProcessingCartUpdate = false;

    this.addEventListener(
      "change",
      SHTHelper.debounce(event => {
        this.onChange(event);
      }, 300)
    );

    // Listen for cart:update events (e.g. from SHTCartDiscount)
    document.addEventListener('cart:update', this.handleCartUpdate.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.dataset.name);
  }

  renderContents(parsedState) {
    this.wrapperElement.classList.contains("is-empty") && this.wrapperElement.classList.remove("is-empty");
    this.getSectionsToRender().forEach(section => {
      section.selectors?.forEach(e => {
        let tmpElement = SHTHelper.qid(section.id);

        if (tmpElement && parsedState.sections[section.section]) {
          let shouldBeReplacedElm = tmpElement.querySelector(e) || tmpElement;
          shouldBeReplacedElm.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], e);
        }
      });
    });
  }

  handleCartUpdate(event) {
    if (this.isProcessingCartUpdate) return;

    this.isProcessingCartUpdate = true;

    let sections = this.getSectionsToRender();
    if (this.cartNotification) {
      sections = [...sections, ...this.cartNotification.getSectionsToRender()];
    }

    fetch(`${window.routes.cart_url}`, {
      ...SHTHelper.fetchConfig,
      headers: {
        'Accept': 'application/json',
      }
    })
    .then(response => response.json())
    .then(cart => {
      if (cart.item_count === 0) {
        let cartEmpty = SHTHelper.qs(".js-drawer-empty");
        let cartDrawer = SHTHelper.qs(".js-cart-drawer-wrapper");
        let cartCountNumber = SHTHelper.qs(".js-cart-count-number");
        cartDrawer.innerHTML = cartEmpty.innerHTML;
        cartCountNumber.innerHTML = 0;
      } else {
        fetch(`?sections=${sections.map(section => section.section).join(',')}`)
          .then(response => response.text())
          .then(state => {
            const parsedState = JSON.parse(state);
            this.renderContentsDiscount({ sections: parsedState });
          })
          .catch(error => {
            console.error("Error fetching cart sections:", error);
          });
      }
    })
    .catch(error => {
      console.error("Error fetching cart:", error);
    })
    .finally(() => {
      setTimeout(() => {
        this.isProcessingCartUpdate = false;
      }, 500);
    });
  }

  renderContentsDiscount(parsedState) {
    this.wrapperElement.classList.contains("is-empty") && this.wrapperElement.classList.remove("is-empty");
    this.getSectionsToRenderDiscount().forEach(section => {
      section.selectors?.forEach(e => {
        let tmpElement = SHTHelper.qid(section.id);
        if (tmpElement && parsedState.sections[section.section]) {
          let shouldBeReplacedElm = tmpElement.querySelector(e);
          shouldBeReplacedElm.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], e);
        }
      });
    });
  }

  getSectionsToRenderDiscount() {
    return [
      {
        id: "cartDrawer",
        section: "cart-drawer",
        selectors: [".js-cart-items", ".js-discount-pills", ".js-cart-total", ".js-free-shipping-notification-message", ".js-cart-level-discount-applications"],
      },
      {
        id: "mainCart",
        section: "main-cart",
        selectors: [".js-cart-items", ".js-discount-pills", ".js-cart-total", ".js-free-shipping-notification-message", ".js-cart-level-discount-applications"],
      }
    ];
  }

  getSectionsToRender() {
    return [
      {
        id: "cartDrawer",
        section: "cart-drawer",
        selectors: [".js-cart-drawer-wrapper"],
      },
      {
        id: "mainCart",
        section: "main-cart",
        selectors: ["#mainCartContainer"],
      }
    ];
  }
  updateQuantity(line, quantity, name) {
    let sections = this.getSectionsToRender();
    let parsedState = {};
    if (this.cartNotification) {
      sections = [...sections, ...this.cartNotification.getSectionsToRender()];
    }

    let body = JSON.stringify({
      line,
      quantity,
      sections: sections.map(section => section.section),
      sections_url: window.location.pathname,
    });
    this.updateButtonState(true);
    fetch(`${window.routes.cart_change_url}`, {
      ...SHTHelper.fetchConfigJSON,
      ...{
        body,
      },
    })
      .then(response => {
        return response.text();
      })
      .then(state => {
        parsedState = JSON.parse(state);

        console.log(parsedState);

        if (parsedState.errors) {
          setTimeout(() => {
            this.updateErrorRegions(line, parsedState.errors);
          }, 100);
        } else {
          this.closest(".js-cart-drawer-wrapper").classList.toggle("is-empty", parsedState.item_count === 0);

          this.getSectionsToRender().forEach(section => {
            section.selectors.forEach(e => {
              let tepItem = SHTHelper.qid(section.id);
              if (tepItem) {
                let shouldBeReplacedElm = tepItem.querySelector(e) || tepItem;

                shouldBeReplacedElm.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], e);
              }
            });
          });

          let lineItem = SHTHelper.qid(`cartDrawerItem-${line}`);

          if (lineItem) {
            let quantityBtn = lineItem.querySelector(`.js-cart-drawer-quantity-btn-${name}`);
            quantityBtn && quantityBtn.focus();
          }

          if (this.cartNotification) {
            this.cartNotification.getSectionsToRender().forEach(section => {
              if (section.id == "header-cart-status") {
                SHTHelper.qs(section.space_selector).innerHTML = this.cartNotification.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
              }
            });
          }
        }
      })
      .catch(e => {
        this.$(".js-cart-drawer-errors").textContent = SHTLanguage.cart.ERROR;
        console.log(e.message, e.stack);
      })
      .finally(() => {
        this.updateButtonState(false);
      });
  }

  updateErrorRegions(line, error) {
    let item_line = SHTHelper.qs(`#cart-drawer-line-item-error-${line}`);
    item_line.querySelector(".js-cart-drawer-form-item-error-message").innerHTML = error;

    item_line.classList.remove("d-none-important");
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }
  updateButtonState(disabled) {
    let btn = this.$$(".js-cart-drawer-btn");
    let btnSubmit = this.drawerCartElement.querySelector(".js-cart-drawer-submit-btn");
    if (disabled) {
      for (let i = 0, n = btn.length; i < n; i++) {
        btn[i].setAttribute("disabled", "disabled");
      }
      btnSubmit && btnSubmit.setAttribute("disabled", "disabled");
    } else {
      for (let i = 0, n = btn.length; i < n; i++) {
        btn[i].removeAttribute("disabled", "disabled");
      }
      btnSubmit && btnSubmit.removeAttribute("disabled");
    }
  }
}
customElements.define("sht-cart-drwr-frm", SHTCartDrawerForm);

class SHTMenuDrawer extends SHTCoreDrawer {}

customElements.define("sht-menu-drwer", SHTMenuDrawer);

class SHTMenuDrawerOpener extends SHTCustomComponent {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.triggerBtnElement = this.$(".js-menu-drawer-trigger");
    this.menuDrawerElement = SHTHelper.qs("sht-menu-drwer");
    this.triggerBtnElement.addEventListener("click", e => {
      this.menuDrawerElement?.openDrawer(e.target);
    });
  }
}

customElements.define("sht-menu-drwer-opner", SHTMenuDrawerOpener);

class SHTMegaMenuDrawer extends SHTCoreDrawer {
  constructor() {
    super();
  }
}

customElements.define("sht-mega-menu-drawer", SHTMegaMenuDrawer);

class SHTColorSwatch extends SHTCustomComponent {
  constructor() {
    super();

    this.json = null;
    this.jsonDataElement = SHTHelper.qs(`#colorSwatchData[type="application/json"]`) || null;

    this.variantSwatchItems = this.$$(".js-variant-swatch-item") || [];
    if (!this.jsonDataElement || this.variantSwatchItems.length == 0) {
      return;
    }

    this.bindEventHandlers();
  }

  onObserverHandler() {
    let observe = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.init();

          observer.unobserve(this);
        }
      });
    });
    observe.observe(this);
  }

  init() {
    this.json = JSON.parse(this.jsonDataElement.textContent);
    this.processJsonData();

    for (let i = 0, n = this.variantSwatchItems.length; i < n; i++) {
      let e = this.variantSwatchItems[i];
      let jsonData = this.json[`${e.dataset.optionValue}`];
      let classSwatchType = "";
      const optionValue = e.dataset.optionValue;
      const swatchOptionValue = e.dataset.swatchOptionValue;

      const applyStyles = (type, color = "", image = "") => {
        classSwatchType = type;
        e.style.backgroundColor = color;
        e.style.backgroundImage = image ? `url("${image}")` : "";
        e.style.backgroundSize = image ? "cover" : "";
        e.style.backgroundRepeat = image ? "no-repeat" : "";
      };

      if (jsonData !== undefined) {
        const isHexColor = SHTHelper.isHexColor(jsonData);
        const isImage = SHTHelper.isImage(jsonData);

        if (isImage) {
          applyStyles("image", "", jsonData);
        } else if (isHexColor) {
          applyStyles("color", jsonData);
        }
      } else if (SHTHelper.isColor(optionValue)) {
        applyStyles("color", optionValue);
      }

      if (swatchOptionValue) {
        const swatchHexColor = SHTHelper.isHexColor(swatchOptionValue);
        const swatchImage = SHTHelper.isImage(swatchOptionValue);

        if (swatchImage) {
          applyStyles("image", "", swatchOptionValue);
        } else if (swatchHexColor) {
          applyStyles("color", swatchOptionValue);
        }
      }

      if (e.style.backgroundImage || e.style.backgroundColor) {
        if (classSwatchType) e.classList.add(`clr-swh__type--${classSwatchType}`);
        e.classList.add("clr-swh__has-value");
      } else {
        e.querySelector(".js-variant-option-label")?.classList.remove("opacity-0");
      }
    }
  }

  processJsonData() {
    if (this.json) {
      this.json = Object.assign.apply(
        {},
        this.json.color_swatch_name.map((v, i) => ({
          [v]: this.json.color_swatch_value[i],
        }))
      );
    }
  }

  bindEventHandlers() {
    this.onObserverHandler();
  }
}

class SHTMainProductVariantSwatch extends SHTColorSwatch {}

customElements.define("sht-prd-variant-swtch", SHTMainProductVariantSwatch);

class SHTMainProductVariantSwatchWSelect extends SHTColorSwatch {}

customElements.define("sht-prd-variant-swtch-w-select", SHTMainProductVariantSwatchWSelect);

class SHTProductQuickViewVariantSwatch extends SHTColorSwatch {}

customElements.define("sht-prd-qck-vw-variant-swtch", SHTProductQuickViewVariantSwatch);

class SHTMainCollectionProductVariantSwatch extends SHTColorSwatch {}

customElements.define("sht-coll-prd-variant-swtch", SHTMainCollectionProductVariantSwatch);

class SHTFeaturedProductVariantSwatch extends SHTColorSwatch {}

customElements.define("sht-featured-prd-variant-swtch", SHTFeaturedProductVariantSwatch);

class SHTMainSearchVariantSwatch extends SHTColorSwatch {}

customElements.define("sht-srch-variant-swtch", SHTMainSearchVariantSwatch);

class SHTVariantSwatch extends SHTColorSwatch {
  bindEventHandlers() {
    this.onObserverHandler();
    this.variantSwatchItems.forEach(e => {
      e.addEventListener("click", subEvent => {
        this.changeVariantImage(subEvent.currentTarget);
      });
    });
  }

  changeVariantImage(ele) {
    let mainImage = SHTHelper.qs(`#${ele.dataset.productImageId}`);
    let mainImageLink = SHTHelper.qsa(`.${ele.dataset.productLinkClass}`);
    let variantImageTemplate = ele.querySelector("template");

    if (mainImage && variantImageTemplate) {
      this.setButtonVisibility(false);
      let variantImage = variantImageTemplate.content.firstElementChild.cloneNode(true);
      if (mainImage.src) {
        mainImage.src = variantImage.src;
      }

      if (mainImage.srcset) {
        if (variantImageTemplate.srcset) {
          mainImage.srcset = variantImage.srcset;
        } else {
          mainImage.srcset = variantImage.src;
        }
      }
      if (mainImageLink) {
        mainImageLink.forEach(e => {
          e.href = variantImage.getAttribute("data_url");
        });
      }
      ele.setAttribute("aria-current", "true");
      ele.classList.add("btn-active");
      ele.focus();
    }
  }

  setButtonVisibility(flag) {
    if (this.variantSwatchItems) {
      this.variantSwatchItems.forEach(e => {
        if (flag) {
          e.setAttribute("aria-current", "true");
          e.classList.add("btn-active");
        } else {
          e.removeAttribute("aria-current");
          e.classList.remove("btn-active");
        }
      });
    }
  }
}

customElements.define("sht-variant-swtch", SHTVariantSwatch);

class SHTDialogCore extends SHTCustomComponent {
  constructor() {
    super();
    this.dialog = this.$(".dialog");
    this.closeBtn = this.$$(".js-dialog-close-btn");
    this.body = this.$(".js-dialog-body");
    this.closeModalOnOverlayClick = this.dataset.closeModalOnOverlay || "true";

    this.opener = null;
    this.bodyElement = document.body;
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.closeBtn.forEach(btn => {
      btn.addEventListener("click", event => {
        this.closeModal();
      });
    });

    this.addEventListener("click", event => {
      if (event.target.nodeName === this.tagName && this.closeModalOnOverlayClick === "true") this.closeModal();
    });

    this.addEventListener("keyup", evt => evt.code.toUpperCase() === "ESCAPE" && this.closeModal());
    this.dialogAttrObserve();
  }

  dialogAttrObserve() {
    let dialogAttrObserver = new MutationObserver((mutations, observer) => {
      mutations.forEach(async mutation => {
        if (mutation.attributeName == "hidden") {
          const isOpen = !this.hasAttribute("hidden");
          if (isOpen) {
            this.dispatchEvent(
              new CustomEvent("opening", {
                detail: {
                  opener: this.opener,
                  dialog: this,
                },
              })
            );

            await this.animationsComplete();
            this.dispatchEvent(
              new CustomEvent("opened", {
                detail: {
                  opener: this.opener,
                  dialog: this,
                },
              })
            );
            SHTHelper.trapFocus(this);
            this.bodyElement.classList.add("o-hidden");
          } else {
            SHTHelper.removeTrapFocus(this.opener);
            this.dispatchEvent(
              new CustomEvent("closing", {
                detail: {
                  opener: this.opener,
                  dialog: this,
                },
              })
            );
            await this.animationsComplete();
            this.dispatchEvent(
              new CustomEvent("closed", {
                detail: {
                  opener: this.opener,
                  dialog: this,
                },
              })
            );
            this.bodyElement.classList.remove("o-hidden");
          }
        }
      });
    });

    dialogAttrObserver.observe(this, {
      attributes: true,
    });
  }

  animationsComplete() {
    return Promise.allSettled(this.dialog.getAnimations({ subtree: true }).map(animation => animation.finished));
  }

  processBodyContent() {
    this.template = this.$("template");

    if (!this.template) return;
    let content = this.template.content;
    this.body.appendChild(content);
  }

  showModal(opener, template = false) {
    SHTHelper.preventStickyHeaderReveal();

    if (template) {
      this.processBodyContent();
    }
    this.opener = opener;
    this.toggleAttribute("hidden", false);
  }

  closeModal() {
    this.setAttribute("hidden", true);
  }
}

class SHTDialog extends SHTDialogCore {
  constructor() {
    super();
  }
}
customElements.define("sht-dialog", SHTDialog);

class SHTDialogQuickShop extends SHTDialogCore {
  constructor() {
    super();
  }

  showModal(opener) {
    SHTHelper.preventStickyHeaderReveal();
    this.opener = opener;
    this.opener?.setAttribute("disabled", "disabled");
    this.processData(opener);
  }

  processData(opener) {
    this.productElement = null;
    fetch(opener.getAttribute("data-product-url"))
      .then(response => response.text())
      .then(responseText => {
        const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
        this.productElement = responseHTML.querySelector(".section-product-quick-view");
        this.body.innerHTML = this.productElement.innerHTML;
        this.executeScriptElements(this.body);
        SHTCustomComponent.waitForPaymentButtons(this.body);
        if (window.Shopify?.PaymentButton) Shopify.PaymentButton.init();
        this.setupPaymentButtonObserver();
      })
      .finally(() => {
        this.toggleAttribute("hidden", false);
        this.opener?.removeAttribute("disabled");
        // Ensure body overflow is hidden in both live view and editor
        this.bodyElement.classList.add("o-hidden");
      });
  }

  setupPaymentButtonObserver() {
    requestAnimationFrame(() => {
      const containers = this.body.querySelectorAll('.shopify-payment-button');
      if (containers.length === 0) {
        const observer = new MutationObserver(() => {
          const newContainers = this.body.querySelectorAll('.shopify-payment-button:not([data-observed="true"])');
          if (newContainers.length > 0) this.observePaymentContainers(newContainers);
        });
        observer.observe(this.body, { childList: true, subtree: true });
        setTimeout(() => observer.disconnect(), 3000);
      } else {
        this.observePaymentContainers(containers);
      }
    });
  }

  observePaymentContainers(containers) {
    containers.forEach(container => {
      if (container.dataset.observed === 'true') return;
      SHTCustomComponent.enhancePaymentButtons(container);
      const observer = new MutationObserver(() => SHTCustomComponent.enhancePaymentButtons(container));
      observer.observe(container, { childList: true, subtree: true });
      container.dataset.observed = 'true';
    });
  }

  closeModal() {
    this.setAttribute("hidden", true);
    // Ensure body overflow is restored in both live view and editor
    this.bodyElement.classList.remove("o-hidden");
    setTimeout(() => {
      this.body.innerHTML = "";
    }, 300);
  }

  executeScriptElements(containerElement) {
    const scriptElements = containerElement.querySelectorAll("script");

    Array.from(scriptElements).forEach(scriptElement => {
      const clonedElement = document.createElement("script");

      Array.from(scriptElement.attributes).forEach(attribute => {
        clonedElement.setAttribute(attribute.name, attribute.value);
      });

      clonedElement.appendChild(document.createTextNode(scriptElement.innerHTML));

      scriptElement.parentNode.replaceChild(clonedElement, scriptElement);
    });
  }
}
customElements.define("sht-dialog-quickshop", SHTDialogQuickShop);

// Initialize global dialogQuickShop reference
document.addEventListener('DOMContentLoaded', function() {
  window.dialogQuickShop = document.getElementById('dialogQuickShop');
});

class SHTDetailsExposal extends SHTCustomComponent {
  constructor() {
    super();

    this.detailsElm = this.$("details");
    this.content = this.detailsElm.querySelector("summary").nextElementSibling;

    this.detailsElm.addEventListener("focusout", this.onFocusOutHandler.bind(this));
    this.detailsElm.addEventListener("toggle", this.onToggleHandler.bind(this));
  }

  onFocusOutHandler() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggleHandler() {
    if (this.detailsElm.hasAttribute("open")) {
      this.detailsElm.querySelector("summary").setAttribute("aria-expanded", true);
    } else {
      this.detailsElm.querySelector("summary").setAttribute("aria-expanded", false);
    }
  }

  close() {
    this.detailsElm.removeAttribute("open");
    this.detailsElm.querySelector("summary").setAttribute("aria-expanded", false);
  }
}

customElements.define("sht-dtl-exposal", SHTDetailsExposal);

class SHTShareProductButton extends SHTCustomComponent {
  constructor() {
    super();

    this.webShareApiContainer = this.$(`.js-web-share-api-container`);
    this.webShareApiButton = this.$(`.js-web-share-api-btn`);

    this.noneWebShareApiContainer = this.$(`.js-none-web-share-api-container`);
    this.noneWebShareApiButton = this.$(`.js-none-web-share-api-btn`);

    this.copyLinkButton = this.$(`.js-social-share-copy-link`);
    this.init();
  }

  init() {

    if (navigator.share) {
      this.webShareApiContainer.removeAttribute("hidden");
      this.noneWebShareApiContainer.setAttribute("hidden", true);
      this.webShareApiButton.addEventListener("click", () => {
        navigator
          .share({
            url: this.dataset.productUrl,
            title: document.title,
          })
          .then(() => {
            console.log("Thanks for sharing!");
          })
          .catch(console.error);
      });
    } else {
      this.noneWebShareApiContainer.removeAttribute("hidden");
      this.webShareApiContainer.setAttribute("hidden", true);
      this.copyLinkButton.addEventListener("click", e => {
        this.copyToClipboard(e.currentTarget);
      });
    }
  }

  copyToClipboard(e) {
    navigator.clipboard.writeText(this.dataset.productUrl).then(() => {
      e.querySelector(".js-social-share-copy-link-label").textContent = e.dataset.linkCopiedToClipboard;
    });
  }
}
customElements.define("sht-share-prd-btn", SHTShareProductButton);

class SHTCollapsibleRegion extends SHTCustomComponent {
  constructor() {
    super();

    this.properties = this.dataset.properties ? JSON.parse(this.dataset.properties) : {};

    this.triggers = this.$$(".js-collapsible-region-trigger");
    this.contents = this.$$(".js-collapsible-region-content");

    this.bodyWidth = document.body.clientWidth;

    this.isCollapsibleOnDesktop = this.properties.isCollapsibleOnDesktop;
    this.isCollapsibleOnMobile = this.properties.isCollapsibleOnMobile;

    this.init();
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    if (!this.isCollapsibleOnDesktop || !this.isCollapsibleOnMobile) {
      window.addEventListener("resize", e => {
        this.bodyWidth = Math.floor(document.body.clientWidth);
        this.init();
      });
    }
    this.triggers.forEach(ele => {
      ele.addEventListener("click", e => {
        this.onTriggerClick(e.currentTarget);
      });
    });
  }

  init() {
    if ((!this.isCollapsibleOnDesktop && this.bodyWidth > 769) || (!this.isCollapsibleOnMobile && this.bodyWidth <= 769)) {
      this.removeAriaProps();
    }

    if ((this.isCollapsibleOnDesktop && this.bodyWidth > 769) || (this.isCollapsibleOnMobile && this.bodyWidth <= 769)) {
      this.restoreAriaProps();
    }
  }

  removeAriaProps() {
    this.triggers.forEach(ele => {
      ele.style.pointerEvents = "none";
      ele.setAttribute("tabindex", -1);
      ele.removeAttribute("aria-controls");
      ele.removeAttribute("aria-expanded");
    });

    this.contents.forEach(ele => {
      ele.removeAttribute("aria-describedby");
      ele.removeAttribute("role");
      ele.removeAttribute("hidden");
    });
  }

  restoreAriaProps() {
    this.triggers.forEach(ele => {
      ele.style.pointerEvents = "auto";
      ele.setAttribute("aria-controls", this.properties.ariaControls);
      ele.setAttribute("aria-expanded", "false");
      ele.removeAttribute("tabindex");
    });

    this.contents.forEach(ele => {
      ele.setAttribute("aria-describedby", this.properties.ariaDescribedby);
      ele.setAttribute("role", "region");
      ele.setAttribute("hidden", "");
    });
  }
  onTriggerClick(e) {
    let open = e.getAttribute("aria-expanded") === "true";

    this.toggle(!open, e);
  }

  toggle(open, e) {
    e.setAttribute("aria-expanded", `${open}`);
    let content = this.$(`#${e.getAttribute("aria-controls")}`);

    if (open) {
      e.classList.add("open");
      content.removeAttribute("hidden");
    } else {
      e.classList.remove("open");
      content.setAttribute("hidden", "");
    }
  }

  open() {
    this.toggle(true);
  }

  close() {
    this.toggle(false);
  }
}
customElements.define("sht-clps-rgn", SHTCollapsibleRegion);

class SHTQuantityInput extends SHTCustomComponent {
  constructor() {
    super();

    this.input = this.$(`.js-quantity-input`);
    this.changeEvent = new Event("change", { bubbles: true });
    this.$$(".js-quantity-btn").forEach(button => button.addEventListener("click", this.onButtonClickHandler.bind(this)));
  }

  onButtonClickHandler(event) {
    event.preventDefault();
    let previousValue = this.input.value;
    event.currentTarget.dataset.name === "plus" ? this.input.stepUp() : this.input.stepDown();

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
}
customElements.define("sht-qty-inp", SHTQuantityInput);

class SHTAccordion extends SHTCustomComponent {
  constructor() {
    super();

    this.properties = this.dataset.properties ? JSON.parse(this.dataset.properties) : {};

    this.accordionItems = this.$$(".js-accordion-item");
    this.accordionTriggers = this.$$(".js-accordion-trigger");
    this.accordionTrigger = this.$(".js-accordion-trigger");
    this.accordionContents = this.$$(".js-accordion-content");

    this.bindEventHandlers();
  }

  connectedCallback() {
    if (this.properties && this.properties.default_open) {
      if (!this.properties.multiple && this.accordionTrigger) {
        this.toggle(true, this.accordionTrigger);
      } else if (this.accordionTriggers && this.accordionTriggers.length) {
        this.accordionTriggers.forEach((trigger) => this.toggle(true, trigger));
      }
    }
  }

  bindEventHandlers() {
    this.accordionTriggers.forEach(ele => {
      ele.addEventListener("click", e => {
        e.preventDefault();
        this.onTriggerClick(e.currentTarget);
      });
    });
  }

  onTriggerClick(e) {
    let open = e.getAttribute("aria-expanded") === "true";
    if (!this.properties.multiple) {
      this.toggleAll();
    }
    this.toggle(!open, e);
  }

  toggle(open, e) {
    e.setAttribute("aria-expanded", `${open}`);
    if (open) {
      e.classList.add("open");
    } else {
      e.classList.remove("open");
    }

    let content = this.$(`#${e.getAttribute("aria-controls")}`);

    if (open) {
      content.classList.add("open");
      content.style.maxHeight = `${this.calculateMaxHeightContent(content)}px`;
    } else {
      content.classList.remove("open");
      content.style.maxHeight = `0px`;
    }
  }

  open() {
    this.toggle(true);
  }

  close() {
    this.toggle(false);
  }

  toggleAll() {
    this.accordionTriggers.forEach(ele => {
      ele.setAttribute("aria-expanded", `false`);
      ele.classList.remove(`open`);
    });

    this.accordionContents.forEach(ele => {
      ele.classList.remove("open");
      ele.style.maxHeight = `0px`;
    });
  }

  calculateMaxHeightContent(target) {
    return target.scrollHeight;
  }
}

customElements.define("sht-accordion", SHTAccordion);

class SHTLazyLoadingVideo extends SHTCustomComponent {
  constructor() {
    super();
    this.video = this.$("iframe");
    this.isLoaded = false;
    this.isPlaying = false;
    this.addObserver();
  }

  loadVideo() {
    if (this.video && !this.isLoaded) {
      this.video.setAttribute("src", this.video.getAttribute("data-src"));
      this.isLoaded = true;

      this.video.addEventListener("load", () => {
        this.dispatchEvent(
          new CustomEvent("loadingEnd", {
            detail: {
              ele: this.video,
              parent: this,
            },
          })
        );
      });
    }

    if (this.dataVideoType == "local_video" && !this.isLoaded) {
      this.local_video = this.$("video");
      if (this.local_video) {
        let video_src = this.local_video.querySelector("source").getAttribute("data-src");
        this.local_video.src = video_src;
      }

      this.isLoaded = true;
    }
  }

  playVideo() {
    if (!this.isPlaying && this.isLoaded) {
      if (this.dataVideoType == "youtube") {
        this.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
      } else if (this.dataVideoType == "vimeo") {
        this.video.contentWindow.postMessage('{"method":"play"}', "*");
      } else if (this.dataVideoType == "local_video") {
        this.local_video?.play();
      }
      this.isPlaying = true;
    }
  }

  execute() {
    this.addObserver();
  }

  addObserver() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadVideo();
          this.playVideo();
        } else {
          this.pauseVideo();
          this.isPlaying = false;
        }
      });
    }, { rootMargin: '0px 0px 200px 0px' });

    observer.observe(this);
  }

  pauseVideo() {
    if (this.isPlaying) {
      this.$(".js-media-item-youtube")?.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
      this.$(".js-media-item-vimeo")?.contentWindow.postMessage('{"method":"pause"}', "*");
      this.$(".js-media-item-video")?.pause();
      this.isPlaying = false;
    }
  }

  static get observedAttributes() {
    return ["data-video-type", "data-video-id"];
  }

  set dataVideoType(newValue) {
    this.setAttribute("data-video-type", newValue);
  }

  get dataVideoType() {
    return this.getAttribute("data-video-type");
  }

  set dataVideoId(newValue) {
    this.setAttribute("data-video-id", newValue);
  }

  get dataVideoId() {
    return this.getAttribute("data-video-id");
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.execute();
    }
  }

  connectedCallback() {
    this.execute();
  }

  disconnectedCallback() {}
}
customElements.define("sht-load-video", SHTLazyLoadingVideo);

class SHTTabs extends SHTCustomComponent {
  constructor() {
    super();

    this.tabLinks = this.$$(".js-tab-link");
    this.tabPanels = this.$$(".js-tab-panel");
    this.tabHeader = this.$('.js-mega-menu-drawer-tabs-header');
    this.tabHeaderWrap = this.$('.js-drawer-tabs-header');
    this.isRTL = SHTHelper.isRTL;
    this.bindEventHandlers();
    // Initialize drag-to-slide for level 1 tab header in drawer menu
    this.initializeDragToSlide();
    this.initializeOnLoad();
  }

  initializeOnLoad() {
    if (this.tabLinks && this.tabLinks.length > 0) {
      const defaultTabLink = this.$('.js-tab-link.tab__link--active') || this.tabLinks[0];
      if (defaultTabLink) {
        const href = defaultTabLink.getAttribute('href');
        if (href && href.includes('#')) {
          this.tabLinkEventHandler(defaultTabLink);
        }
        this.tabPanelMegaMenuPromotionEventHandler(defaultTabLink);
      }
    }
    this.updateHeaderMasks();
  }

  bindEventHandlers() {
    this.tabLinks?.forEach((element) => {
      element.addEventListener("click", (evt) => {
        // If there was just a drag action, block click to prevent unintended navigation
        if (this.dragBlockUntil && Date.now() < this.dragBlockUntil) {
          evt.preventDefault();
          return;
        }
        const href = element.getAttribute("href");

        if (this.classList.contains('js-mega-menu-drawer-tabs') && this.tabHeader) {
          this.revealInHeader(element);
        }
        if (href && href.includes("#")) {
          evt.preventDefault();
          this.tabLinkEventHandler(element);
          this.tabPanelMegaMenuPromotionEventHandler(element);
          return;
        }

        if (this.classList.contains('js-mega-menu-drawer-tabs') && this.tabHeader) {
          const isFullyVisible = this.isElementFullyVisibleInContainer(element, this.tabHeader);
          if (!isFullyVisible) {
            evt.preventDefault();
            this.scrollTabHeaderTo(element).then(() => {
              try { element.focus({ preventScroll: true }); } catch (e) {}
              const hrefNav = element.getAttribute('href');
              const targetAttr = element.getAttribute('target');
              if (hrefNav && !hrefNav.includes('#')) {
                if (targetAttr === '_blank') {
                  window.open(hrefNav, '_blank');
                } else {
                  window.location.href = hrefNav;
                }
              }
            });
            return;
          }
        }
      });
    });

    if (this.tabHeader) {
      this.tabHeader.addEventListener('scroll', () => this.updateHeaderMasks(), { passive: true });
      window.addEventListener('resize', () => this.updateHeaderMasks());
      setTimeout(() => this.updateHeaderMasks(), 0);
    }
  }

  // Enable horizontal drag-to-slide behavior for tab header (level 1 menu)
  initializeDragToSlide() {
    if (!this.tabHeader) return;

    // State and temporary variables for drag-to-slide
    // - isPointerDown: whether mouse/touch is pressed
    // - isDragging: whether dragging is active (threshold exceeded)
    // - dragStartX: initial X coordinate when dragging starts
    // - dragStartScrollLeft: initial scrollLeft position of header
    // - hasMoved: whether moved enough to be considered a drag (to block click)
    // - dragBlockUntil: timestamp (ms) until when to block clicks (after drag)
    this.isPointerDown = false;
    this.isDragging = false;
    this.hasMoved = false;
    this.dragPointerType = 'mouse';
    this.dragBlockUntil = 0;
    this.dragStartX = 0;
    this.dragStartScrollLeft = 0;
    this.dragThreshold = 10; // px

    // Use Pointer Events to unify mouse/touch/pen handling
    this.onDragStart = (e) => {
      // Only accept left mouse button when using mouse
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      this.isPointerDown = true;
      this.isDragging = false;
      this.hasMoved = false;
      this.dragPointerType = e.pointerType || 'mouse';
      this.dragStartX = e.clientX;
      this.dragStartScrollLeft = this.tabHeader.scrollLeft;
      // Improve UX for mouse dragging
      if (this.dragPointerType === 'mouse') {
        this.tabHeader.style.cursor = 'grabbing';
        this.tabHeader.style.userSelect = 'none';
      }
    };

    this.onDragMove = (e) => {
      if (!this.isPointerDown) return;
      const deltaX = e.clientX - this.dragStartX;

      if (Math.abs(deltaX) > this.dragThreshold) {
        this.hasMoved = true;
        // Manual dragging only for mouse; touch uses natural scrolling
        if (this.dragPointerType === 'mouse' && !this.isDragging) {
          this.isDragging = true;
          try { this.tabHeader.setPointerCapture(e.pointerId); } catch (_) {}
          this.tabHeader.classList.add('is-dragging');
        }
      }

      if (this.dragPointerType === 'mouse' && this.isDragging) {
        // Prevent text selection and click while dragging with mouse
        try { e.preventDefault(); } catch (_) {}
        // Use consistent drag direction for both LTR and RTL for natural feel
        const adjustedDelta = -deltaX;
        this.tabHeader.scrollLeft = this.dragStartScrollLeft + adjustedDelta;
      }
    };

    this.onDragEnd = (e) => {
      if (!this.isPointerDown) return;
      if (this.dragPointerType === 'mouse' && this.isDragging) {
        try { this.tabHeader.releasePointerCapture(e.pointerId); } catch (_) {}
        this.tabHeader.classList.remove('is-dragging');
        // Restore styles
        this.tabHeader.style.cursor = '';
        this.tabHeader.style.userSelect = '';
      }
      // If moved (mouse drag or touch swipe), block clicks briefly
      if (this.hasMoved) {
        this.dragBlockUntil = Date.now() + 200;
      }
      this.isPointerDown = false;
      this.isDragging = false;
      this.updateHeaderMasks();
    };

    this.tabHeader.addEventListener('pointerdown', this.onDragStart);
    this.tabHeader.addEventListener('pointermove', this.onDragMove);
    this.tabHeader.addEventListener('pointerup', this.onDragEnd, { passive: true });
    this.tabHeader.addEventListener('pointercancel', this.onDragEnd, { passive: true });
    this.tabHeader.addEventListener('pointerleave', this.onDragEnd, { passive: true });
    // Prevent native HTML5 drag (link dragging) from interfering with drag-to-slide
    this.tabHeader.addEventListener('dragstart', (e) => { try { e.preventDefault(); } catch (_) {} });
  }

  isElementFullyVisibleInContainer(element, container) {
    if (!element || !container) return true;
    const elRect = element.getBoundingClientRect();
    const ctRect = container.getBoundingClientRect();
    
    // For both RTL and LTR, an element is fully visible if its left edge is at or to the right of
    // the container's left edge, and its right edge is at or to the left of the container's right edge
    // This is because getBoundingClientRect() always returns coordinates in visual order (left to right)
    return elRect.left >= ctRect.left && elRect.right <= ctRect.right;
  }

  scrollTabHeaderTo(element) {
    if (!this.tabHeader || !element) return Promise.resolve();
    const container = this.tabHeader;

    let targetLeft;
    if (this.isRTL) {
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;
      
      // Get element position relative to container
      const elementRect = element.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      const elementOffsetInContainer = elementRect.left - containerRect.left;
      
      // Calculate target position to center the element
      const elementCenter = elementOffsetInContainer + element.clientWidth / 2;
      const containerCenter = container.clientWidth / 2;
      const scrollAdjustment = elementCenter - containerCenter;
      
      // Current scroll position plus adjustment needed to center the element
      targetLeft = container.scrollLeft + scrollAdjustment;
      
      // Ensure we don't scroll beyond the bounds
      const minScroll = 'scrollLeftMax' in container ? -container.scrollLeftMax : -(scrollWidth - clientWidth);
      const maxScroll = 0;
      targetLeft = Math.max(minScroll, Math.min(maxScroll, targetLeft));
    } else {
      // Standard LTR calculation
      targetLeft = Math.max(0, element.offsetLeft - (container.clientWidth - element.clientWidth) / 2);
      
      // Ensure we don't scroll beyond the bounds
      const maxScroll = container.scrollWidth - container.clientWidth;
      targetLeft = Math.min(targetLeft, maxScroll);
    }

    return new Promise((resolve) => {
      const startTime = Date.now();
      const maxWaitMs = 700;

      const checkDone = () => {
        const nearTarget = Math.abs(container.scrollLeft - targetLeft) < 2;
        const timedOut = Date.now() - startTime > maxWaitMs;
        if (nearTarget || timedOut) {
          resolve();
        } else {
          requestAnimationFrame(checkDone);
        }
      };

      requestAnimationFrame(checkDone);
      container.scrollTo({ left: targetLeft, behavior: 'smooth' });
    });
  }

  revealInHeader(element) {
    if (!this.tabHeader || !element) return;
    if (!this.isElementFullyVisibleInContainer(element, this.tabHeader)) {
      this.scrollTabHeaderTo(element);
    }
    this.updateHeaderMasks();
  }

  updateHeaderMasks() {
    if (!this.tabHeader || !this.tabHeaderWrap) return;
    let atStart, atEnd;
    
    // Get the current scroll position and the maximum possible scroll
    const currentScroll = this.tabHeader.scrollLeft;
    const scrollWidth = this.tabHeader.scrollWidth;
    const clientWidth = this.tabHeader.clientWidth;
    const maxScroll = scrollWidth - clientWidth;
    
    if (this.isRTL) {
      // For RTL, scrollLeft is negative in most browsers
      // atStart means we're at the rightmost edge (scrollLeft is at its minimum value)
      // atEnd means we're at the leftmost edge (scrollLeft is near 0)
      
      if ('scrollLeftMax' in this.tabHeader) {
        // Firefox exposes scrollLeftMax property
        atStart = Math.abs(currentScroll) >= Math.abs(this.tabHeader.scrollLeftMax) - 1;
      } else {
        // Chrome and other browsers
        atStart = Math.abs(currentScroll) >= maxScroll - 1;
      }
      
      // At the end (left side in RTL) when scrollLeft is close to 0
      atEnd = currentScroll >= -1;
    } else {
      // Standard LTR calculation
      // At the start (left edge) when scrollLeft is 0
      atStart = Math.floor(currentScroll) <= 0;
      
      // At the end (right edge) when we've scrolled to the maximum possible position
      atEnd = Math.ceil(currentScroll + clientWidth) >= scrollWidth - 1;
    }
    
    this.tabHeaderWrap.classList.toggle('is-at-start', atStart);
    this.tabHeaderWrap.classList.toggle('is-at-end', atEnd);
  }

  tabPanelMegaMenuPromotionEventHandler(element) {
    if (this.classList.contains("js-mega-menu-drawer-tabs")) {
      const href = element.getAttribute("href");
      const id = href?.replace("#", "");

      const currentPanel = this.$(`[data-tab-content-id="${id}"]`);
      const drawerWrapper = this.closest('.js-drawer-wrapper');

      if (currentPanel && drawerWrapper) {
        const hasMegaMenuPromotion = currentPanel.getAttribute('data-mega-menu-promotion') === 'true';

        if (hasMegaMenuPromotion) {
          drawerWrapper.classList.add('have-promo');
        } else {
          drawerWrapper.classList.remove('have-promo');
        }

        const recenterActiveTab = () => {
          if (this.tabHeader) {
            this.revealInHeader(element);
          }
        };

        try {
          requestAnimationFrame(() => requestAnimationFrame(recenterActiveTab));
        } catch (_) {
          setTimeout(recenterActiveTab, 0);
        }

        try {
          const onTransitionEnd = (ev) => {
            if (ev.propertyName === 'width' || ev.propertyName === 'flex-basis' || ev.propertyName === 'max-width') {
              recenterActiveTab();
            }
          };
          drawerWrapper.addEventListener('transitionend', onTransitionEnd, { once: true });
        } catch (_) {}
      }
    }
  }

  tabLinkEventHandler(element) {
    const href = element.getAttribute("href");
    const id = href && href.startsWith('#') ? href.slice(1) : href;

    this.tabPanels?.forEach((panel) => {
      panel.classList.remove("d-block", "tab__panel--active");
      panel.classList.add("d-none");
    });

    this.tabLinks.forEach((link) => {
      link.classList.remove("tab__link--active");
    });

    const currentPanel = this.$(`[data-tab-content-id="${id}"]`);
    if (currentPanel) {
      currentPanel.classList.remove("d-none");
      currentPanel.classList.add("d-block", "tab__panel--active");
    }

    element.classList.add("tab__link--active");
  }
}
customElements.define("sht-tabs", SHTTabs);

class SHTLoadMedia extends SHTCustomComponent {
  constructor() {
    super();

    this.trigger = this.$(".js-load-media-trigger");
    this.trigger.addEventListener("click", evt => this.loadMedia());
  }

  loadMedia(focus = true, hide_trigger = true) {
    this.pauseAllVideo();
    if (!this.getAttribute("loaded")) {
      const loader = document.createElement("div");
      loader.className = "p-absolute center-middle";
      loader.innerHTML = '<span class="btn btn-secondary btn-large btn-icon"><svg class="icon-spinner" style="animation: spin 1s linear infinite;" width="20" height="20" viewBox="0 0 20 20"><path d="M10 3.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zm0 11a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9z" fill="currentColor"/></svg></span>';
      
      if (!document.getElementById('sht-video-loader-styles')) {
        const style = document.createElement('style');
        style.id = 'sht-video-loader-styles';
        style.textContent = '@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }';
        document.head.appendChild(style);
      }
      
      const playButton = this.trigger.querySelector('.js-btn-play');
      if (playButton) {
        playButton.classList.add('opacity-0');
        this.trigger.appendChild(loader);
      }

      let content = document.createElement("div");
      content.appendChild(this.$("template").content.firstElementChild.cloneNode(true));
      this.setAttribute("loaded", true);
      
      const mediaElement = content.querySelector("video, iframe");
      
      this.trigger.style.transition = 'opacity 0.3s ease-out';
      mediaElement.classList.add('p-absolute', 'inset', 'opacity-0');
      mediaElement.style.transition = 'opacity 0.3s ease-in';
      
      this.appendChild(mediaElement);
      
      if (mediaElement.tagName === 'VIDEO') {
        mediaElement.addEventListener('loadeddata', () => {
          this.onMediaReady(mediaElement, focus, hide_trigger, loader);
        });
        
        mediaElement.load();
      } else if (mediaElement.tagName === 'IFRAME') {
        mediaElement.addEventListener('load', () => {
          setTimeout(() => {
            this.onMediaReady(mediaElement, focus, hide_trigger, loader);
          }, 500);
        });
      }
    }
  }

  onMediaReady(mediaElement, focus, hide_trigger, loader) {
    if (loader && loader.parentNode) {
      loader.remove();
    }
    
    mediaElement.style.opacity = '1';
    
    if (hide_trigger) {
      this.trigger.style.opacity = '0';
      setTimeout(() => {
        this.trigger.classList.replace("d-block", "d-none");
        mediaElement.style.position = 'relative';
      }, 300);
    }
    
    if (focus) mediaElement.focus();
  }

  pauseAllVideo() {
    SHTHelper.qsa(".js-media-item-youtube").forEach(video => {
      video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
    });
    SHTHelper.qsa(".js-media-item-vimeo").forEach(video => {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    });

    SHTHelper.qsa(".js-media-item-video").forEach(video => video.pause());
  }
}

customElements.define("sht-load-media", SHTLoadMedia);

class SHTAnnouncementBar extends SHTCustomComponent {
  constructor() {
    super();
  }

  init() {
    this.items = this.$$(".js-anmb-item");
    this.container = this.$(".js-anmb-items");
    this.linkItems = this.$$(".js-anmb-link-items");
    this.totalItems = this.items.length;
    this.previousButton = this.$(".js-anmb-control-prev");
    this.nextButton = this.$(".js-anmb-control-next");
    this.props = JSON.parse(this.dataset.props);
    this.delayTime = this.props.duration;
    this.interval = null;
    this.currentItemIndex = 1;
    this.lastScrollTimeout = null;
    this.messages = this.container.children;
    this.isScrolling = false;
    this.isRTL = SHTHelper.isRTL;
    this.bindEventHandlers();
    this.updateSort();
    this.autoPlay();
  }

  connectedCallback() {
    this.init();
  }

  updateSort() {
    if (this.totalItems <= 1) return;
    this.isScrolling = true;
    let scrollLeftB = this.container.scrollLeft;
    let scrollLeft = Math.round(scrollLeftB);
    let offsetWidth = this.container.offsetWidth;
    let scrollWidth = this.container.scrollWidth;

    if (this.isRTL) {
      // In RTL mode, scrollLeft is negative and decreases as we scroll right
      // We need to adjust the logic accordingly
      if (Math.abs(scrollLeft) < offsetWidth) {
        this.container.prepend(this.messages[this.totalItems - 1]);
        this.container.scrollLeft = scrollLeft - offsetWidth;
      }
      if (Math.floor(scrollWidth + scrollLeftB) <= offsetWidth) {
        this.container.append(this.messages[0]);
        this.container.scrollLeft = scrollLeft + offsetWidth;
      }
    } else {
      // Original LTR logic
      if (scrollLeft < offsetWidth) {
        this.container.prepend(this.messages[this.totalItems - 1]);
        this.container.scrollLeft = scrollLeft + offsetWidth;
      }
      if (Math.floor(scrollWidth - scrollLeftB) <= offsetWidth) {
        this.container.append(this.messages[0]);
        this.container.scrollLeft = scrollLeft - offsetWidth;
      }
    }
    this.isScrolling = false;
  }

  onScrollEventHandle(e) {
    if (this.lastScrollTimeout) {
      clearTimeout(this.lastScrollTimeout);
    }

    this.lastScrollTimeout = setTimeout(
      function () {
        this.updateSort();
      }.bind(this),
      100
    );
  }

  bindEventHandlers() {
    this.previousButton.addEventListener("click", SHTHelper.debounce(this.onPrevButtonClickHandler.bind(this), 300));

    this.nextButton.addEventListener("click", SHTHelper.debounce(this.onNextButtonClickHandler.bind(this), 300));

    this.onObserverHandler();
    this.container.addEventListener("scroll", SHTHelper.debounce(this.onScrollEventHandle.bind(this), 100));
    this.container.addEventListener(
      "wheel",
      function (evt) {
        SHTHelper.debounce(this.resetAutoPlay.bind(this), 0);
      }.bind(this),
      {
        passive: true,
      }
    );
  }

  onPrevButtonClickHandler() {
    if (this.isScrolling) return;
    this.isScrolling = true;
    this.resetAutoPlay();
    
    // In RTL, "previous" means moving to the right (higher index)
    let index;
    if (this.isRTL) {
      index = this.currentItemIndex + 1;
      if (this.currentItemIndex == this.totalItems) {
        index = 1;
      }
    } else {
      index = this.currentItemIndex - 1;
      if (this.currentItemIndex == 1) {
        index = this.totalItems;
      }
    }
    
    let matchingItem = this.$(`div[data-item-index="${index}"]`);
    this.container.scrollTo({ left: matchingItem.offsetLeft, behavior: "smooth" });
  }

  onNextButtonClickHandler() {
    if (this.isScrolling) return;
    this.isScrolling = true;
    this.resetAutoPlay();
    
    // In RTL, "next" means moving to the left (lower index)
    let index;
    if (this.isRTL) {
      index = this.currentItemIndex - 1;
      if (this.currentItemIndex == 1) {
        index = this.totalItems;
      }
    } else {
      index = this.currentItemIndex + 1;
      if (this.currentItemIndex == this.totalItems) {
        index = 1;
      }
    }
    
    let matchingItem = this.$(`div[data-item-index="${index}"]`);
    this.container.scrollTo({ left: matchingItem.offsetLeft, behavior: "smooth" });
  }

  onMouseOverHandle(evt) {
    this.clearDismissInterval();
  }

  onMouseOutHandle(evt) {
    this.setDismissInterval();
  }

  clearDismissInterval() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  setDismissInterval() {
    this.interval = setInterval(
      function () {
        // Auto-play should always move in the natural reading direction
        // For RTL, this is right-to-left (which is our "previous" button in RTL mode)
        if (this.isRTL) {
          this.onPrevButtonClickHandler();
        } else {
          this.onNextButtonClickHandler();
        }
      }.bind(this),
      this.delayTime
    );
  }
  resetAutoPlay() {
    if (!this.props.autoPlay || this.totalItems < 2) {
      return;
    }
    this.clearDismissInterval();
    setTimeout(() => {
      this.setDismissInterval();
    });
  }
  autoPlay() {
    if (!this.props.autoPlay || this.totalItems < 2) {
      this.clearDismissInterval();
      this.container.setAttribute("aria-live", "polite");
      return;
    }
    this.container.addEventListener("mouseover", this.onMouseOverHandle.bind(this));
    this.container.addEventListener("mouseout", this.onMouseOutHandle.bind(this));
    this.container.setAttribute("aria-live", "off");
    this.setDismissInterval();
  }

  onObserverHandler() {
    let observe = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            let target = entry.target;
            this.linkItems.forEach(e => {
              e.setAttribute("tabindex", "-1");
            });
            window.requestAnimationFrame(() => {
              let activeItem = this.$(".anmb-item--active");
              if (activeItem) {
                activeItem.classList.remove("anmb-item--active");
                activeItem.setAttribute("aria-hidden", "true");
              }
            });
            this.currentItemIndex = parseInt(target.dataset.itemIndex);
            target.setAttribute("aria-hidden", "false");
            window.requestAnimationFrame(() => target.classList.add("anmb-item--active"));
            let linkItem = target.querySelector(".js-anmb-link-items");
            linkItem && linkItem.removeAttribute("tabindex");
          }
        });
      },
      {
        root: this.container,
        rootMargin: "0px",
        threshold: 0.5,
      }
    );
    this.items.forEach(item => {
      observe.observe(item);
    });
  }
}
customElements.define("sht-ann-bar", SHTAnnouncementBar);

class SHTPopup extends SHTCustomComponent {
  constructor() {
    super();

    this.properties = JSON.parse(this.dataset.props);
    this.myStorage = window.sessionStorage;
    this.sessionStorageName = `${Shopify.theme.name.toLowerCase()}-popup-display`;
    this.cartNotification = SHTHelper.qs("sht-cart-noti");

    this.isOpen = false;

    this.buffer = 100;
    this.myScrollHeight = document.body.scrollHeight || SHTHelper.qde.scrollHeight || 0;
    this.myWindowHeight = window.innerHeight || SHTHelper.qde.clientHeight || 0;

    this.elms = {
      close_btn: this.$(".js-popup-close-btn"),
      body: SHTHelper.qs("body"),
    };

    this.triggerOn = this.properties.triggerOn;
    this.scrollEventHandle = this.onScrollEventHandle.bind(this);
    this.onLoadUserAction = this.onUserAction.bind(this);
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.elms.close_btn.addEventListener("click", this.onCloseBtnClickHandle.bind(this));
    window.addEventListener("scroll", this.scrollEventHandle);

    if (this.cartNotification && this.triggerOn === "after-closing-cart-notification") {
      this.cartNotification.addEventListener("closed", e => {
        let sitePopupStatus = this.getPopupStatus();
        if (!sitePopupStatus) {
          this.togglePopup(true);
        }
      });
    }

    [("mouseenter", "touchstart", "mouseover")].forEach(
      function (e) {
        SHTHelper.qs("body").addEventListener(e, this.onLoadUserAction);
      }.bind(this)
    );

    this.popupAttrObserve();
  }

  onUserAction(evt) {
    this.classList.contains("d-none") && this.classList.remove("d-none");
    evt.currentTarget.removeEventListener(evt.type, this.onLoadUserAction);
  }

  onScrollEventHandle(evt) {
    if (this.triggerOn !== "reaching-to-footer") {
      window.removeEventListener("scroll", this.scrollEventHandle);
      return;
    }

    this.myScrollHeight = document.body.scrollHeight || SHTHelper.qde.scrollHeight || 0;

    let scrollTop = window.pageYOffset || SHTHelper.qde.scrollTop || document.body.scrollTop || 0;

    let isOpen = scrollTop + this.buffer + this.myWindowHeight >= this.myScrollHeight ? true : false;

    let sitePopupStatus = this.getPopupStatus();

    if (this.triggerOn === "reaching-to-footer" && isOpen && (this.getAttribute("open") === null || this.getAttribute("open") === "") && !sitePopupStatus) {
      this.togglePopup(true);
    }
  }

  togglePopup(toggle) {
    let isSuccess = this.$(".js-success");

    if (toggle && !isSuccess) {
      this.toggleOpen(true);
    } else {
      this.toggleOpen(false);
      this.setPopupStatus();
    }
  }

  toggleOpen(open) {
    if (open) {
      this.elms.body.classList.add("is-popup-show");
      this.setAttribute("open", true);

    } else {
      this.elms.body.classList.remove("is-popup-show");
      this.removeAttribute("open");
      SHTHelper.removeTrapFocus();
    }
    return;
  }

  onCloseBtnClickHandle(e) {
    e.preventDefault();
    this.togglePopup(false);
  }

  setPopupStatus() {
    this.myStorage.setItem(this.sessionStorageName, false);
  }

  getPopupStatus() {
    if (Shopify.designMode) {
      return "";
    } else {
      return this.myStorage.getItem(this.sessionStorageName);
    }
  }

  popupAttrObserve() {
    let popupAttrObserver = new MutationObserver((mutations, observer) => {
      mutations.forEach(async mutation => {
        if (mutation.attributeName == "open") {
          const isOpen = this.hasAttribute("open");
          if (isOpen) {
            await this.animationsComplete();
            this.dispatchEvent(new Event("opened"));
            SHTHelper.trapFocus(this);
          } else {
            SHTHelper.removeTrapFocus();
            await this.animationsComplete();
            this.dispatchEvent(new Event("closed"));
          }
        }
      });
    });

    popupAttrObserver.observe(this, {
      attributes: true,
    });
  }

  animationsComplete() {
    return Promise.allSettled(this.getAnimations().map(animation => animation.finished));
  }
}

customElements.define("sht-popup", SHTPopup);

class SHTSlideShow extends SHTCustomComponent {
  constructor() {
    super();

    this.slideshow = this.$(".js-slideshow");
    this.slideshowItems = this.$(".js-slideshow-items");
    this.totalElm = this.$(".js-slideshow-total");
    this.currentElm = this.$(".js-slideshow-current");
    this.separatorElm = this.$(".js-slideshow-separator");
    this.prevBtn = this.$(".js-slideshow-prev-btn");
    this.nextBtn = this.$(".js-slideshow-next-btn");
    this.startNStopBtn = this.$(".js-slideshow-start-n-stop-btn");
    this.imageItems = this.$$(".js-slideshow-image");
    this.pauseIcon = this.startNStopBtn.querySelector(".js-slideshow-pause-icon");
    this.playIcon = this.startNStopBtn.querySelector(".js-slideshow-play-icon");
    this.properties = JSON.parse(this.dataset.slideshowProperties);

    this.autoplay = this.properties.autoplay || false;
    this.image = null;
    this.template = null;
    this.current = 1;
    this.anchors = [];
    this.lastScrollTimeout = null;
    this.autoplayInterval = null;
    this.images = this.slideshowItems.children;
    this.total = this.images.length;
    this.slideshowItems.scrollLeft = 0;
    this.observer = null;
    this.isPaused = false;
    this.isRTL = SHTHelper.isRTL;

    // Drag-to-slide properties
    this.isDragging = false;
    this.dragStartX = 0;
    this.dragCurrentX = 0;
    this.dragStartScrollLeft = 0;
    this.dragThreshold = 10;
    this.totalDragDistance = 0;
    this.dragStartTime = 0;
    this.isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    this.draggedLinks = new Set();
  }
  cloneSlideItem() {
    if (this.total == 2) {
      let firstItem = this.slideshowItems.querySelector(`.js-slideshow-item:first-of-type`);
      let lastItem = this.slideshowItems.querySelector(`.js-slideshow-item:last-of-type`);
      if (lastItem) {
        let clonedItem = lastItem.cloneNode(true);
        clonedItem.classList.add("slider-slide--clone");
        this.slideshowItems.append(clonedItem);
      }
      if (firstItem) {
        let clonedItem = firstItem.cloneNode(true);
        clonedItem.classList.add("slider-slide--clone");
        this.slideshowItems.append(clonedItem);
      }
    }
  }
  execute() {
    if (this.total <= 1) return;

    this.cloneSlideItem();
    this.prepare();
    this.bindEventHandlers();
    this.initDragToSlide();
    this.init();
  }
  connectedCallback() {
    this.execute();
  }
  init() {
    if (this.autoplay) {
      this.resumeAutoPlay();
      this.isPaused = true;
    }
    this.updateSort();
  }
  updateSort() {
    if (this.total <= 1) return;

    let scrollLeftB = this.slideshowItems.scrollLeft;
    let scrollLeft = Math.round(scrollLeftB);
    let offsetWidth = this.slideshowItems.offsetWidth;
    let scrollWidth = this.slideshowItems.scrollWidth;
    
    if (this.isRTL) {
      // In RTL mode, scrollLeft is negative and decreases as we scroll right
      // We need to adjust the logic accordingly
      if (Math.abs(scrollLeft) < offsetWidth) {
        this.slideshowItems.prepend(this.images[this.total - 1]);
        this.slideshowItems.scrollLeft = scrollLeft - offsetWidth;
      }
      if (Math.floor(scrollWidth + scrollLeftB) <= offsetWidth) {
        this.slideshowItems.append(this.images[0]);
        this.slideshowItems.scrollLeft = scrollLeft + offsetWidth;
      }
    } else {
      // Original LTR logic
      if (scrollLeft < offsetWidth) {
        this.slideshowItems.prepend(this.images[this.total - 1]);
        this.slideshowItems.scrollLeft = scrollLeft + offsetWidth;
      }
      if (Math.floor(scrollWidth - scrollLeftB) <= offsetWidth) {
        this.slideshowItems.append(this.images[0]);
        this.slideshowItems.scrollLeft = scrollLeft - offsetWidth;
      }
    }
  }

  initDragToSlide() {
    if (this.total <= 1) return;

    this.updateDesktopDetection();
    window.addEventListener('resize', () => {
      this.updateDesktopDetection();
    });

    if (this.isDesktop) {
      this.bindDragEventHandlers();
    }
  }

  updateDesktopDetection() {
    const wasDesktop = this.isDesktop;
    this.isDesktop = window.matchMedia('(min-width: 1024px)').matches;

    if (wasDesktop && !this.isDesktop) {
      // Switched from desktop to mobile - clean up
      this.cleanupLinkPrevention();
      this.slideshowItems.classList.remove('slideshow--dragging');
    } else if (!wasDesktop && this.isDesktop) {
      // Switched from mobile to desktop - init
      this.bindDragEventHandlers();
    }
  }

  bindDragEventHandlers() {
    this.slideshowItems.addEventListener('mousedown', this.onDragStart.bind(this));
    document.addEventListener('mousemove', this.onDragMove.bind(this));
    document.addEventListener('mouseup', this.onDragEnd.bind(this));
    this.slideshowItems.addEventListener('mouseleave', this.onDragCancel.bind(this));

    // Prevent default drag behavior on images
    this.slideshowItems.addEventListener('dragstart', (e) => e.preventDefault());
  }

  onDragStart(e) {
    if (!this.isDesktop || e.button !== 0) return;

    this.isDragging = true;
    this.dragStartX = e.clientX;
    this.dragCurrentX = e.clientX;
    this.dragStartScrollLeft = this.slideshowItems.scrollLeft;
    this.totalDragDistance = 0;
    this.dragStartTime = Date.now();

    // Stop autoplay during drag
    if (this.autoplay) {
      this.stopAutoPlay();
    }

    // Add visual feedback for drag state
    this.slideshowItems.classList.add('slideshow--dragging');
    document.body.style.userSelect = 'none';

    // Prevent text selection during drag
    e.preventDefault();
  }

  onDragMove(e) {
    if (!this.isDragging) return;

    this.dragCurrentX = e.clientX;
    // Calculate drag distance based on direction
    let dragDistance;
    if (this.isRTL) {
      // In RTL, dragging left (negative) should move to next slide
      dragDistance = this.dragCurrentX - this.dragStartX;
    } else {
      // In LTR, dragging left (negative) should move to next slide
      dragDistance = this.dragStartX - this.dragCurrentX;
    }
    this.totalDragDistance = Math.abs(dragDistance);

    // Prevent link clicks if drag threshold exceeded
    if (this.totalDragDistance > this.dragThreshold) {
      this.preventLinksInCurrentSlide();
    }
  }

  onDragEnd(e) {
    if (!this.isDragging) return;

    this.isDragging = false;
    // Calculate drag distance based on direction
    let dragDistance;
    if (this.isRTL) {
      // In RTL, dragging left (negative) should move to next slide
      dragDistance = this.dragCurrentX - this.dragStartX;
    } else {
      // In LTR, dragging left (negative) should move to next slide
      dragDistance = this.dragStartX - this.dragCurrentX;
    }
    
    const slideWidth = this.slideshowItems.offsetWidth;
    const dragPercentage = Math.abs(dragDistance) / slideWidth;
    const dragTime = Date.now() - this.dragStartTime;
    const dragVelocity = this.totalDragDistance / dragTime;

    // Reset visual feedback
    this.slideshowItems.classList.remove('slideshow--dragging');
    document.body.style.userSelect = '';

    // Determine if we should change slides
    const shouldChangeSlide = dragPercentage > 0.1 || (dragVelocity > 0.3 && this.totalDragDistance > 30);

    if (shouldChangeSlide && this.totalDragDistance > this.dragThreshold) {
      // Use the same animation system as prev/next buttons
      this.performSlideTransition(dragDistance > 0 ? 'next' : 'prev');
    }

    // Clean up link prevention after animation completes
    setTimeout(() => {
      this.cleanupLinkPrevention();
    }, 500);
  }

  performSlideTransition(direction) {
    if (!Shopify.designMode) {
      // Use the same animation system as button clicks
      let currentItem = this.$(".js-slideshow-image--current").closest(".slider-slide--active");

      if (currentItem) {
        currentItem.classList.add("slider-slide--active-blur");

        setTimeout(() => {
          // Handle RTL direction
          if (this.isRTL) {
            // In RTL, directions are reversed
            if (direction === 'next') {
              this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft - this.slideshow.scrollWidth;
            } else {
              this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft + this.slideshow.scrollWidth;
            }
          } else {
            // Original LTR behavior
            if (direction === 'next') {
              this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft + this.slideshow.scrollWidth;
            } else {
              this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft - this.slideshow.scrollWidth;
            }
          }
          currentItem.classList.remove("slider-slide--active-blur");
        }, 400);
      }
    } else {
      // Design mode - instant transition
      // Handle RTL direction
      if (this.isRTL) {
        // In RTL, directions are reversed
        if (direction === 'next') {
          this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft - this.slideshow.scrollWidth;
        } else {
          this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft + this.slideshow.scrollWidth;
        }
      } else {
        // Original LTR behavior
        if (direction === 'next') {
          this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft + this.slideshow.scrollWidth;
        } else {
          this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft - this.slideshow.scrollWidth;
        }
      }
    }
  }

  onDragCancel() {
    if (!this.isDragging) return;

    this.isDragging = false;

    // Reset visual feedback
    this.slideshowItems.classList.remove('slideshow--dragging');
    document.body.style.userSelect = '';

    // Clean up link prevention
    setTimeout(() => {
      this.cleanupLinkPrevention();
    }, 100);
  }

  preventLinksInCurrentSlide() {
    const currentSlide = this.getCurrentSlide();
    if (!currentSlide) return;

    const links = currentSlide.querySelectorAll('.js-slideshow-link');
    links.forEach(link => {
      if (!this.draggedLinks.has(link)) {
        link.addEventListener('click', this.preventLinkClick, true);
        this.draggedLinks.add(link);
      }
    });
  }

  preventLinkClick(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  cleanupLinkPrevention() {
    this.draggedLinks.forEach(link => {
      link.removeEventListener('click', this.preventLinkClick, true);
    });
    this.draggedLinks.clear();
  }

  getCurrentSlide() {
    return this.querySelector('.js-slideshow-image--current')?.closest('.js-slideshow-item');
  }
  startAutoPlay() {
    if (this.autoplay) {
      this.autoplayInterval = setInterval(
        function () {
          this.nextSlide();
        }.bind(this),
        this.properties.duration
      );
    }
  }

  bindEventHandlers() {
    this.slideshowItems.addEventListener(
      "wheel",
      function (evt) {
        if (Math.abs(evt.deltaX) == 5) {
          this.stopAutoPlay();
        }
      }.bind(this),
      {
        passive: true,
      }
    );
    this.slideshowItems.addEventListener("scroll", SHTHelper.debounce(this.onScrollEventHandle.bind(this), 100));
    this.nextBtn.addEventListener(
      "click",
      function () {
        this.nextSlide();
        this.stopAutoPlay();
      }.bind(this)
    );
    this.prevBtn.addEventListener(
      "click",
      function () {
        this.prevSlide();
        this.stopAutoPlay();
      }.bind(this)
    );
    this.startNStopBtn.addEventListener("click", this.onStartNStopEventHandle.bind(this));
  }
  onStartNStopEventHandle(e) {
    e.preventDefault();
    if (this.autoplay) {
      this.stopAutoPlay();
    } else {
      this.resumeAutoPlay();
    }
  }
  stopAutoPlay() {
    clearInterval(this.autoplayInterval);

    this.pauseIcon.classList.add("d-none");
    this.playIcon.classList.remove("d-none");

    this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[0]);
    this.slideshowItems.setAttribute("aria-live", "polite");
    this.autoplay = false;
  }
  resumeAutoPlay() {
    this.autoplay = true;

    this.pauseIcon.classList.remove("d-none");
    this.playIcon.classList.add("d-none");

    this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[1]);
    this.slideshowItems.setAttribute("aria-live", "off");
    this.startAutoPlay();
  }
  onScrollEventHandle(e) {
    e.preventDefault();
    if (this.lastScrollTimeout) {
      clearTimeout(this.lastScrollTimeout);
    }
    this.lastScrollTimeout = setTimeout(
      function () {
        this.updateSort();
      }.bind(this),
      100
    );
    this.updateCurrent();
  }
  prepare() {
    this.totalElm.textContent = this.total;
    this.currentElm.textContent = this.current;
    this.separatorElm.textContent = this.properties.separatorText;
    if (this.autoplay) {
      this.startNStopBtn.toggleAttribute("hidden", false);
      this.startNStopBtn.querySelector(".js-slideshow-pause-icon").classList.remove("d-none");

      this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[0]);
      this.slideshowItems.setAttribute("aria-live", "off");
    }
  }
  updateCurrent() {
    let currentItem = this.$(".js-slideshow-image--current");
    if (currentItem) {
      this.current = currentItem.dataset.slideshowIndex;
    }
    this.currentElm.textContent = this.current;
  }
  prevSlide() {
    if (Shopify.designMode) {
      // In RTL mode, "previous" means moving right (increasing scrollLeft)
      if (this.isRTL) {
        this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft + this.slideshow.scrollWidth;
      } else {
        this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft - this.slideshow.scrollWidth;
      }
    } else {
      let currentItem = this.$(".js-slideshow-image--current").closest(".slider-slide--active");
      currentItem && currentItem.classList.add("slider-slide--active-blur");

      setTimeout(() => {
        // In RTL mode, "previous" means moving right (increasing scrollLeft)
        if (this.isRTL) {
          this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft + this.slideshow.scrollWidth;
        } else {
          this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft - this.slideshow.scrollWidth;
        }
        currentItem.classList.remove("slider-slide--active-blur");
      }, 400);
    }
  }
  nextSlide() {
    if (Shopify.designMode) {
      // In RTL mode, "next" means moving left (decreasing scrollLeft)
      if (this.isRTL) {
        this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft - this.slideshow.scrollWidth;
      } else {
        this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft + this.slideshow.scrollWidth;
      }
    } else {
      let currentItem = this.$(".js-slideshow-image--current").closest(".slider-slide--active");
      currentItem && currentItem.classList.add("slider-slide--active-blur");

      setTimeout(() => {
        // In RTL mode, "next" means moving left (decreasing scrollLeft)
        if (this.isRTL) {
          this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft - this.slideshow.scrollWidth;
        } else {
          this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft + this.slideshow.scrollWidth;
        }
        currentItem.classList.remove("slider-slide--active-blur");
      }, 400);
    }
  }
  observerSlideShow() {
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.dataset.viewport = 1;
          }
          this.observer.unobserve(this);

        });
      },
      { threshold: 0.15 }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    // Clean up drag event handlers
    if (this.isDesktop) {
      document.removeEventListener('mousemove', this.onDragMove.bind(this));
      document.removeEventListener('mouseup', this.onDragEnd.bind(this));
    }

    // Clean up link prevention
    this.cleanupLinkPrevention();

    // Clean up autoplay
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }

    // Clean up timeouts
    if (this.lastScrollTimeout) {
      clearTimeout(this.lastScrollTimeout);
    }
  }
}
customElements.define("sht-slideshow", SHTSlideShow);

class SHTSlideshowLazyLoadingImage extends SHTCustomComponent {
  constructor() {
    super();

    this.picture = this.$(".js-slideshow-picture");
    this.image = this.picture ? this.picture.querySelector("img") : null;
    this.spinner = this.$(".js-image-lazy-spinner");
    this.container = this.closest(".js-slideshow-items");
    this.currentItemClass = "js-slideshow-image--current";
    this.slideItem = this.closest(".js-slideshow-item");
    this.sectionId = this.dataset.sectionId;
    this.section = SHTHelper.qs(`#shopify-section-${this.sectionId}`);

    // Detect content type - video or image
    this.videoComponents = this.$$("sht-load-video");
    this.videoComponentDesktop = this.$("sht-load-video.d-block-md, sht-load-video:not(.d-block):not(.d-none-md)");
    this.videoComponentMobile = this.$("sht-load-video.d-block.d-none-md");
    this.isVideoSlide = this.videoComponents.length > 0;
    this.isImageSlide = !!(this.image || this.picture);

    // Cache media query for performance
    this.mediaQuery = window.matchMedia("(max-width: 767px)");
    
    this.bindEventHandlers();
  }

  setSlideItemVisibility(flag) {
    if (!flag) {
      this.slideItem.setAttribute("aria-hidden", "true");
      this.slideItem.setAttribute("tabindex", "-1");

      this.slideItem.classList.remove("slider-slide--active");
    } else {
      this.slideItem.setAttribute("aria-hidden", "false");
      this.slideItem.removeAttribute("tabindex");
      this.slideItem.classList.add("slider-slide--active");
    }
  }

  observeContent(targetElement) {
    let contentObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          let target = entry.target;
          let parentNode = this.parentNode;

          if (entry.isIntersecting && !this.getAttribute("loaded")) {
            // Handle image loading - remove loading attribute from img element
            if (this.isImageSlide && this.image) {
              this.image.removeAttribute("loading");
            }
            
            // Handle video loading
            if (this.isVideoSlide) {
              this.loadResponsiveVideo();
            }
            
            this.setAttribute("loaded", true);
            parentNode.classList.add(this.currentItemClass);
            this.setSlideItemVisibility(true);
          } else if (entry.intersectionRatio == 0) {
            parentNode.classList.remove(this.currentItemClass);
            this.setSlideItemVisibility(false);
          } else {
            if (this.getAttribute("loaded")) {
              parentNode.classList.add(this.currentItemClass);
              this.setSlideItemVisibility(true);
            }
          }
        });
      },
      {
        root: this.container,
        rootMargin: `100px -2px 100px -2px`,
        threshold: 0,
      }
    );

    // Observe the target element (image, picture, or this component for videos)
    if (this.isImageSlide && targetElement) {
      contentObserver.observe(targetElement);
    } else if (this.isVideoSlide) {
      contentObserver.observe(this);
    }
  }

  loadResponsiveVideo() {
    // Use cached media query for better performance
    const isMobile = this.mediaQuery.matches;
    let targetVideoComponent = null;

    if (isMobile && this.videoComponentMobile) {
      // Load mobile video if available and on mobile
      targetVideoComponent = this.videoComponentMobile;
    } else if (!isMobile && this.videoComponentDesktop) {
      // Load desktop video if available and on desktop
      targetVideoComponent = this.videoComponentDesktop;
    } else if (this.videoComponents.length > 0) {
      // Fallback to first available video component
      targetVideoComponent = this.videoComponents[0];
    }

    // Trigger video loading through the appropriate video component
    if (targetVideoComponent && typeof targetVideoComponent.loadVideo === 'function') {
      targetVideoComponent.loadVideo();
    }
  }

  loadContent() {
    // Use shared resize observer for better performance
    if (!SHTSlideshowLazyLoadingImage.sharedResizeObserver) {
      SHTSlideshowLazyLoadingImage.sharedResizeObserver = new ResizeObserver(
        SHTHelper.debounce(() => {
          // Update all registered slideshow components
          SHTSlideshowLazyLoadingImage.instances.forEach(instance => {
            instance.handleResize();
          });
        }, 100)
      );
      SHTSlideshowLazyLoadingImage.instances = new Set();
    }

    // Register this instance
    SHTSlideshowLazyLoadingImage.instances.add(this);
    
    // Observe document body only once
    if (SHTSlideshowLazyLoadingImage.instances.size === 1) {
      SHTSlideshowLazyLoadingImage.sharedResizeObserver.observe(document.body);
    }

    // Initial setup
    this.handleResize();
  }

  handleResize() {
    if (this.isImageSlide) {
      // With picture element, we observe the image element directly
      // The picture element handles responsive loading automatically
      const targetElement = this.image || this.picture;
      if (targetElement) {
        this.observeContent(targetElement);
      }
    } else if (this.isVideoSlide) {
      // For video content, load appropriate video based on screen size
      this.observeContent();
      // Also load the appropriate video when screen size changes
      if (this.getAttribute("loaded")) {
        this.loadResponsiveVideo();
      }
    }
  }

  bindEventHandlers() {}

  execute() {
    this.loadContent();
  }

  connectedCallback() {
    this.execute();
  }

  disconnectedCallback() {
    // Clean up shared observer reference
    if (SHTSlideshowLazyLoadingImage.instances) {
      SHTSlideshowLazyLoadingImage.instances.delete(this);
      
      // If no more instances, cleanup shared observer
      if (SHTSlideshowLazyLoadingImage.instances.size === 0) {
        SHTSlideshowLazyLoadingImage.sharedResizeObserver?.disconnect();
        SHTSlideshowLazyLoadingImage.sharedResizeObserver = null;
      }
    }
  }
}

customElements.define("sht-slideshow-load-img", SHTSlideshowLazyLoadingImage);

class SHTSlideshowCTA extends SHTCustomComponent {
  constructor() {
    super();
    this.ctaButton = this.$$(".js-slideshow-cta");
    this.container = this.closest(".js-slideshow-items");
    this.bindEventHandlers();
  }
  bindEventHandlers() {
    this.observeItem();
  }
  observeItem() {
    let observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.setCTAVisibility(true);
          } else {
            this.setCTAVisibility(false);
          }
        });
      },
      {
        threshold: 0.25,
      }
    );
    observer.observe(this);
  }
  setCTAVisibility(flag) {
    this.ctaButton.forEach((item, index) => {
      if (!flag) {
        item.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
      } else {
        item.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
      }
    });
  }
}
customElements.define("sht-slideshow-cta", SHTSlideshowCTA);

class SHTHotSpotTooltip extends SHTCustomComponent {
  constructor() {
    super();
  }
  init() {
    this.tooltip_content = this.$(".js-tooltip-content");
    this.tooltip_contents = this.$$(".js-tooltip-content");
    this.tooltip_placeholders = this.$$(".js-tooltip-placeholder");
    this.tooltip_container = SHTHelper.qs(`#${this.dataset.containerId}`);
    this.bindEventHandlers();
  }
  bindEventHandlers() {
    for (let i = 0, n = this.tooltip_placeholders.length; i < n; i++) {
      let e = this.tooltip_placeholders[i];
      e.addEventListener("mouseover", elm => {
        this.handleToolTipContentPosition(elm);
      });
      e.addEventListener("mouseout", elm => {
        for (let z = 0, m = this.tooltip_contents.length; z < m; z++) {
          let content = this.tooltip_contents[z];
          content.classList.remove("hotspot-content--right", "hotspot-content--left", "hotspot-content--top", "hotspot-content--bottom", "hotspot-content--show");
        }
      });
    }
  }

  handleToolTipContentPosition(elm) {
    let tooltipPlaceholder = elm.currentTarget;
    let tooltipContent = tooltipPlaceholder.querySelector(".js-tooltip-content");

    let axisX = Math.round(tooltipPlaceholder.offsetLeft + tooltipContent.offsetWidth + tooltipPlaceholder.offsetWidth);

    let axisY = Math.round(tooltipPlaceholder.offsetTop + tooltipContent.offsetHeight + tooltipPlaceholder.offsetHeight);

    if (tooltipPlaceholder.offsetLeft >= 0 && tooltipPlaceholder.offsetLeft < this.tooltip_container.offsetWidth && axisX < this.tooltip_container.offsetWidth) {
      tooltipContent.classList.add("hotspot-content--right", "hotspot-content--show");
    } else if (tooltipPlaceholder.offsetLeft >= 0 && tooltipPlaceholder.offsetLeft < this.tooltip_container.offsetWidth && axisX >= this.tooltip_container.offsetWidth) {
      tooltipContent.classList.add("hotspot-content--left", "hotspot-content--show");
    } else {

    }

    if (tooltipPlaceholder.offsetTop >= 0 && tooltipPlaceholder.offsetTop < this.tooltip_container.offsetHeight && axisY < this.tooltip_container.offsetHeight) {
      tooltipContent.classList.add("hotspot-content--bottom");
    } else if (tooltipPlaceholder.offsetTop >= 0 && tooltipPlaceholder.offsetTop < this.tooltip_container.offsetHeight && axisY >= this.tooltip_container.offsetHeight) {
      tooltipContent.classList.add("hotspot-content--top");
    } else {
      //do nothing
    }
  }

  connectedCallback() {
    if (Shopify.designMode) {
      setTimeout(() => {
        this.init();
      }, 1000);
    } else {
      this.init();
    }
  }
}
customElements.define("sht-hotspot", SHTHotSpotTooltip);

class SHTMarquee extends SHTCustomComponent {
  constructor() {
    super();

    this.playNPauseBtn = this.$(".js-marquee-pause-n-play-btn");
    this.pauseIcon = this.$(".js-marqueen-pause-btn");
    this.playIcon = this.$(".js-marqueen-play-btn");

    this.bindEventHandlers();
  }
  bindEventHandlers() {
    this.playNPauseBtn.addEventListener("click", elm => {
      let toggle = elm.currentTarget.getAttribute("aria-pressed") === "false";

      this.classList.toggle("marquee--animation-pause", toggle);
      this.playIcon.classList.toggle("d-none", !toggle);
      this.pauseIcon.classList.toggle("d-none", toggle);

      elm.currentTarget.setAttribute("aria-pressed", toggle.toString());
    });
  }
}
customElements.define("sht-marquee", SHTMarquee);

class SHTMap extends SHTCustomComponent {
  constructor() {
    super();
    this.iframe = this.$(".js-map-iframe");
    this.bindEventHandlers();
  }
  loadIframeContent() {
    let observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.dispatchEvent(
              new CustomEvent("loadingStart", {
                detail: {
                  ele: this.iframe,
                  parent: this,
                },
              })
            );
            this.execute();
            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: "0px 0px -100px 0px",
      }
    );
    observer.observe(this);
  }

  bindEventHandlers() {
    this.iframe.addEventListener(
      "load",
      function () {
        this.dispatchEvent(
          new CustomEvent("loadingEnd", {
            detail: {
              ele: this.iframe,
              parent: this,
            },
          })
        );
        this.setAttribute("loaded", true);
      }.bind(this)
    );
  }

  execute() {
    this.setIframeSrc();
  }

  setIframeSrc() {
    let url = `https://maps.google.com/maps?z=${this.dataZoom}&t=${this.dataType}&q=${this.dataLocation.replace(/"/g, "")}&ie=UTF8&&output=embed`;
    this.iframe.src = url;
    this.iframe.removeAttribute("srcdoc");
  }

  static get observedAttributes() {
    return ["data-zoom", "data-type", "data-location"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      if (Shopify.designMode) {
        this.execute();
      } else {
        this.loadIframeContent();
      }
    }
  }

  connectedCallback() {}

  disconnectedCallback() {}

  get dataZoom() {
    return this.getAttribute("data-zoom");
  }

  get dataType() {
    return this.getAttribute("data-type");
  }

  get dataLocation() {
    return this.getAttribute("data-location");
  }

  set dataZoom(newValue) {
    this.setAttribute("data-zoom", newValue);
  }

  set dataType(newValue) {
    this.setAttribute("data-type", newValue);
  }

  set dataLocation(newValue) {
    this.setAttribute("data-location", newValue);
  }
}
customElements.define("sht-map", SHTMap);

class SHTLoadDynamicCheckoutButtonDynamicCheckoutButton extends SHTCustomComponent {

  constructor() {
    super();

    this.template = this.$("template");
    this.onLoadDynamicCheckoutButton = this.onHandleLoadDynamicCheckoutButton.bind(this);
    this.bindEventHandlers();
    this.isMouseenter = false;
    this.json = JSON.parse(SHTHelper.qs(`#shopify-features[type="application/json"]`).textContent);
    if (Shopify.designMode) {
      this.loadDynamicCheckoutButton();
    } else {
      window.addEventListener("scroll", this.onLoadDynamicCheckoutButton, false);

      window.addEventListener(
        "load",
        function (event) {
          let timeout = setTimeout(
            function () {
              if (!this.isMouseenter) {
                this.loadDynamicCheckoutButton();
                clearTimeout(timeout);
              }
              this.isMouseenter = true;
            }.bind(this),
            3000
          );
        }.bind(this)
      );

      [("mouseenter", "touchstart", "mouseover")].forEach(
        function (e) {
          SHTHelper.qs("body").addEventListener(e, this.onLoadDynamicCheckoutButton);
        }.bind(this)
      );
    }
  }

  onHandleLoadDynamicCheckoutButton(event) {
    if (!this.isMouseenter) {
      this.loadDynamicCheckoutButton();
    }
    event.currentTarget.removeEventListener(event.type, this.onLoadDynamicCheckoutButton);
    this.isMouseenter = true;
  }

  loadDynamicCheckoutButton() {
    let observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.intersectionRatio === 1 && !this.getAttribute("loaded")) {
            let tmp = this.template.content.firstElementChild.cloneNode(true);
            let script = document.createElement("script");
            script.src = this.json.smart_payment_buttons_url;
            script.setAttribute("data-source-attribute", "shopify.dynamic_checkout.product.init");
            this.parentNode.insertBefore(tmp, this.nextSibling);
            this.parentNode.insertBefore(script, this.nextSibling);
            this.setAttribute("loaded", true);
            observer.unobserve(this);
          }
        });
      },
      {
        root: null,
        rootMargin: "50px 0px",
        threshold: 0,
      }
    );
    observer.observe(this);
  }
  bindEventHandlers() {}
}
customElements.define("sht-load-dyn-co-btn", SHTLoadDynamicCheckoutButtonDynamicCheckoutButton);

class SHTVerticalCarousel extends SHTCustomComponent {
  constructor() {
    super();
    this.sectionID = this.dataset.sectionId;
    this.carousels = this.$$(".js-carousel-item");
    this.container = this.$(".js-carousel-items");
    this.totalItems = this.carousels.length;
    this.prevBtnElement = this.$(".js-carousel-prev-btn");
    this.nextBtnElement = this.$(".js-carousel-next-btn");
    this.currentElement = this.$(".js-carousel-counter-current");
    this.totalElement = this.$(".js-carousel-counter-total");
    this.paginationElement = this.$(".js-carousel-pagination");
    this.init();
    this.bindEventHandlers();
  }
  init() {
    this.itemsToShow = Array.from(this.carousels).filter(element => element.clientWidth > 0);

    if (this.itemsToShow.length < 2) {
      this.togglePagination(false);
      return;
    }

    this.gutter = parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-top")) + parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-bottom"));
    this.itemOffset = this.itemsToShow[1].offsetTop - this.itemsToShow[0].offsetTop;

    this.itemsPerPage = Math.floor((this.container.clientHeight - this.itemsToShow[0].offsetTop) / this.itemOffset);
    this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1;

    this.updateCarousel();
  }
  updateCarousel() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.container.scrollTop / this.itemOffset) + 1;
    if (this.currentPage > 0 && this.totalPages > 0) {
      if (this.totalElement) {
        this.totalElement.textContent = this.totalPages;
      }
      if (this.currentElement) {
        this.currentElement.innerHTML = this.currentPage + `<span class="visually-hidden">${this.currentElement.dataset.accessibilityMessage}</span>`;
      }
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("itemChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.itemsToShow[this.currentPage - 1],
            container: this,
          },
        })
      );
    }
    if (this.isItemVisible(this.itemsToShow[0]) && this.container.scrollTop === 0) {
      this.prevBtnElement.setAttribute("disabled", "disabled");
    } else {
      this.prevBtnElement.removeAttribute("disabled");
    }
    if (this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      this.nextBtnElement.setAttribute("disabled", "disabled");
    } else {
      this.nextBtnElement.removeAttribute("disabled");
    }

    if (this.totalPages > 1) {
      this.togglePagination(true);
    }

    if (this.totalPages <= 1) {
      this.togglePagination(false);
    }
  }
  togglePagination(flag) {
    if (flag) {
      this.paginationElement?.classList.remove("d-none");
      this.paginationElement?.classList.add("d-flex");
    } else {
      this.paginationElement?.classList.remove("d-flex");
      this.paginationElement?.classList.add("d-none");
    }
  }
  isItemVisible(element, offset = 0) {
    const lastVisibleItem = this.container.clientHeight + this.container.scrollTop - offset;
    return element.offsetTop + element.clientHeight - 1 <= Math.ceil(lastVisibleItem) && element.offsetTop >= this.container.scrollTop;
  }
  onButtonClick(event) {
    event.preventDefault();
    let step = 1;
    let gutter = 0;
    const mediaQuery = window.matchMedia("(min-width: 769px)");
    if (mediaQuery.matches) {
      step = event.currentTarget.dataset.step;
    }
    if (this.container.scrollTop == 0 || this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      gutter = this.gutter;
    }
    this.itemScrollPosition = event.currentTarget.name === "next" ? this.container.scrollTop - gutter + step * this.itemOffset : this.container.scrollTop + gutter - step * this.itemOffset;
    window.requestAnimationFrame(() =>
      this.container.scrollTo({
        top: this.itemScrollPosition,
        behavior: "smooth",
      })
    );
  }
  bindEventHandlers() {
    const resizeObserver = new ResizeObserver(entries => this.init());
    resizeObserver.observe(this.container);

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      this.init();
      observer.unobserve(this);
    };
    new IntersectionObserver(handleIntersection.bind(this)).observe(this);

    this.prevBtnElement.addEventListener("click", this.onButtonClick.bind(this));
    this.nextBtnElement.addEventListener("click", this.onButtonClick.bind(this));
    this.container.addEventListener("scroll", SHTHelper.debounce(this.updateCarousel.bind(this), 100));
  }
}
customElements.define("sht-vert-carousel", SHTVerticalCarousel);

class SHTHorizontalCarousel extends SHTCustomComponent {
  constructor() {
    super();
    this.sectionID = this.dataset.sectionId;
    this.carousels = this.$$(".js-carousel-item");
    this.container = this.$(".js-carousel-items");
    this.totalItems = this.carousels.length;
    this.prevBtnElement = this.$(".js-carousel-prev-btn");
    this.nextBtnElement = this.$(".js-carousel-next-btn");
    this.currentElement = this.$(".js-carousel-counter-current");
    this.totalElement = this.$(".js-carousel-counter-total");
    this.init();
    this.bindEventHandlers();
  }
  init() {
    this.itemsToShow = Array.from(this.carousels).filter(element => element.clientWidth > 0);
    if (this.itemsToShow.length < 2) return;
    this.gutter = parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-left")) + parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-right"));

    this.itemOffset = this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft;
    this.itemsPerPage = Math.floor((this.container.clientWidth - this.itemsToShow[0].offsetLeft) / this.itemOffset);
    this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1;
    this.updateCarousel();
  }
  updateCarousel() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.container.scrollLeft / this.itemOffset) + 1;
    if (this.currentPage > 0 && this.totalPages > 0) {
      if (this.totalElement) {
        this.totalElement.textContent = this.totalPages;
      }
      if (this.currentElement) {
        this.currentElement.innerHTML = this.currentPage + `<span class="visually-hidden">${this.currentElement.dataset.accessibilityMessage}</span>`;
      }
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("itemChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.itemsToShow[this.currentPage - 1],
            container: this,
          },
        })
      );
    }
    if (this.isItemVisible(this.itemsToShow[0]) && this.container.scrollLeft === 0) {
      this.prevBtnElement.setAttribute("disabled", "disabled");
    } else {
      this.prevBtnElement.removeAttribute("disabled");
    }
    if (this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      this.nextBtnElement.setAttribute("disabled", "disabled");
    } else {
      this.nextBtnElement.removeAttribute("disabled");
    }
  }
  isItemVisible(element, offset = 0) {
    const lastVisibleItem = this.container.clientWidth + this.container.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleItem && element.offsetLeft >= this.container.scrollLeft;
  }
  onButtonClick(event) {
    event.preventDefault();
    let step = 1;
    let gutter = 0;
    const mediaQuery = window.matchMedia("(min-width: 769px)");
    if (mediaQuery.matches) {
      step = event.currentTarget.dataset.step;
    }
    if (this.container.scrollLeft == 0 || this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      gutter = this.gutter;
    }
    this.itemScrollPosition = event.currentTarget.name === "next" ? this.container.scrollLeft - gutter + step * this.itemOffset : this.container.scrollLeft + gutter - step * this.itemOffset;
    window.requestAnimationFrame(() =>
      this.container.scrollTo({
        left: this.itemScrollPosition,
        behavior: "smooth",
      })
    );
  }
  bindEventHandlers() {
    const resizeObserver = new ResizeObserver(entries => this.init());
    resizeObserver.observe(this.container);

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      this.init();
      observer.unobserve(this);
    };
    new IntersectionObserver(handleIntersection.bind(this)).observe(this);

    if (this.prevBtnElement) {
      this.prevBtnElement.addEventListener("click", this.onButtonClick.bind(this));
    }
    if (this.nextBtnElement) {
      this.nextBtnElement.addEventListener("click", this.onButtonClick.bind(this));
    }
    this.container.addEventListener("scroll", SHTHelper.debounce(this.updateCarousel.bind(this), 100));
  }
}
customElements.define("sht-horiz-carousel", SHTHorizontalCarousel);

class SHTProductSlideShowItem extends SHTCustomComponent {
  constructor() {
    super();
    this.openGalleryButton = this.$(".js-product-media-open-gallery-btn");
    if (this.openGalleryButton) {
      this.openGalleryButton.addEventListener("click", e => {
        this.openDialogGallery(e);
      });
    }
    this.slideshow = this.closest("sht-prd-slideshow");
    this.parent = this.closest("sht-carousel-itm");

    this.prepare();
  }

  openDialogGallery(e) {
    let dialog = SHTHelper.qs(`#${e.currentTarget.dataset.galleryDialogId}`);
    if (dialog) {
      dialog.showModal(e.currentTarget, true);
      this.slideshow.pauseAllVideo();
    }
  }

  prepare() {
    // Skip prepare for quick view modal - it has its own handler
    if (this.closest('.product__quickview')) return;
    
    if (!window.matchMedia("(max-width: 459px)").matches) {
      if (!this.parent.classList.contains("d-block")) {
        this.slideshow.hide_variant == "true" && this.parent.classList.add("d-none");
      }
    } else {
      this.slideshow.hide_variant == "true" && this.parent.classList.remove("d-none");
    }
    let resizeObserver = new ResizeObserver(entries => {
      if (!window.matchMedia("(max-width: 459px)").matches) {
        if (!this.parent.classList.contains("d-block")) {
          this.slideshow.hide_variant == "true" && this.parent.classList.add("d-none");
        }
      } else {
        this.slideshow.hide_variant == "true" && this.parent.classList.remove("d-none");
      }
    });
    resizeObserver.observe(document.body);
  }
}
customElements.define("sht-prd-slideshow-itm", SHTProductSlideShowItem);

class SHTProductSlideShow extends SHTCustomComponent {
  constructor() {
    super();
    this.carousel = SHTHelper.qs(`sht-carousel[data-section-id="${this.dataset.section}"]`);
    this.thumb_carousel = SHTHelper.qs(`sht-vert-carousel[data-section="${this.dataset.section}"]`);
    this.bindEventHandlers();
    this.hide_variant = this.dataset.hideVariantImage;
  }

  bindEventHandlers() {
    // Skip binding for quick view modal - it has its own handler
    if (this.closest('.product__quickview')) return;
    
    this.$$(".js-slideshow-btn-thumb").forEach((e, i) => {
      if (i === 0) {
        e.closest(".js-product-slideshow-thumb").classList.add("is-active-item");
      }
      e.addEventListener("click", this.setActiveMedia.bind(this, e));
    });
  }

  setActiveMedia(e) {
    let activeMedia = this.$(`[data-media-id="${e.dataset.target}"]`);
    let activeThumb = e.closest("sht-vert-carousel-itm");

    if (!activeMedia || !activeThumb) return;

    if (!window.matchMedia("(max-width: 768px)").matches) {
      this.$$(".js-product-slideshow-item").forEach(element => {
        element.classList.remove("d-block");

        this.hide_variant == "true" && element.classList.add("d-none");
      });

      this.$$(".js-product-slideshow-thumb").forEach(element => {
        element.classList.remove("is-active-item");
      });

      activeMedia.classList.add("d-block");
      this.hide_variant == "true" && activeMedia.classList.remove("d-none");

      activeThumb.classList.add("is-active-item");
      this.playActiveVideo(activeMedia);
      this.playActiveModel(activeMedia);
    } else {
      this.pauseAllVideo();
      this.$$(".js-product-slideshow-thumb").forEach(element => {
        element.classList.remove("is-active-item");
      });
      activeThumb.classList.add("is-active-item");

      const carouselItems = this.carousel?.querySelector(".js-carousel-items");
      if (carouselItems && activeMedia) {
        carouselItems.scrollTo({
          left: activeMedia.offsetLeft,
          behavior: "smooth",
        });
      }
    }
  }

  pauseAllModel() {
    SHTHelper.qsa("sht-prd-media-itm-model").forEach(model => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }

  pauseAllVideo() {
    this.$$(".js-media-item-youtube").forEach(video => {
      video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
    });
    this.$$(".js-media-item-vimeo").forEach(video => {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    });

    this.$$(".js-media-item-video").forEach(video => video.pause());
  }

  playActiveVideo(activeItem) {
    this.pauseAllVideo();
    let deferredExternalVideo = activeItem.querySelector(".js-product-media-deferred-video");

    if (deferredExternalVideo) deferredExternalVideo.loadContent();
  }

  playActiveModel(activeItem) {
    let deferredExternalModel = activeItem.querySelector(".js-product-media-deferred-model");
    if (deferredExternalModel) deferredExternalModel.loadContent();
  }
}
customElements.define("sht-prd-slideshow", SHTProductSlideShow);

class SHTProductMediaItemDeferredVideo extends SHTCustomComponent {
  constructor() {
    super();
    this.itemDeferredVideoImageElem = this.$(".js-product-media-item-deferred-video-image");
    if (this.itemDeferredVideoImageElem) {
      this.itemDeferredVideoImageElem.addEventListener("click", event => {
        this.loadContent();
      });
    }
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      let template = this.$("template").content.firstElementChild.cloneNode(true);
      this.appendChild(template);
      this.isLoaded(true);
      this.itemDeferredVideoImageElem && this.itemDeferredVideoImageElem.remove();
      return true;
    }
  }

  isLoaded(loaded) {
    if (loaded) {
      this.setAttribute("loaded", true);
    } else {
      this.removeAttribute("loaded");
    }
  }
}

customElements.define("sht-prd-media-itm-deferred-video", SHTProductMediaItemDeferredVideo);

class SHTProductMediaItemModel extends SHTCustomComponent {
  constructor() {
    super();
    this.itemModelImageElem = this.$(".js-product-media-item-model-image");
    if (this.itemModelImageElem) {
      this.itemModelImageElem.addEventListener("click", event => {
        this.loadContent();
      });
    }
  }

  loadModelViewerUICss() {
    if (!SHTHelper.qs("#model-viewer-ui")) {
      let productModelCssFile = document.createElement("link");
      productModelCssFile.setAttribute("href", `https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css`);
      productModelCssFile.setAttribute("rel", "stylesheet");
      productModelCssFile.setAttribute("media", "all");
      productModelCssFile.setAttribute("id", "model-viewer-ui");
      document.getElementsByTagName("head")[0].appendChild(productModelCssFile);
    }
  }
  loadContent() {
    if (this.getAttribute("loaded")) return;

    let content = document.createElement("div");
    content.appendChild(this.$("template").content.firstElementChild.cloneNode(true));

    this.setAttribute("loaded", true);

    this.itemModelImageElem && this.itemModelImageElem.remove();
    this.appendChild(content.querySelector("model-viewer")).focus();
    this.loadModelViewerUICss();
    Shopify.loadFeatures([
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: this.setupModelViewerUI.bind(this),
      },
    ]);
  }

  setupModelViewerUI(errors) {
    if (errors) return;

    this.modelViewerUI = new Shopify.ModelViewerUI(this.$("model-viewer"));
  }
}

customElements.define("sht-prd-media-itm-model", SHTProductMediaItemModel);

window.SHTProductMediaItemModel = {
  isMouseenter: false,
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: "shopify-xr",
        version: "1.0",
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", () => this.setupShopifyXR());
      return;
    }

    SHTHelper.qsa('[id^="ProductJSON-"]').forEach(modelJSON => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

if (Shopify.designMode) {
  SHTHelper.qsa("[data-shopify-xr-hidden]").forEach(element => element.classList.add("hidden"));
  if (window.SHTProductMediaItemModel) window.SHTProductMediaItemModel.loadShopifyXR();
} else {
  if (window.SHTProductMediaItemModel) {
    window.addEventListener(
      "scroll",
      function (event) {
        if (!window.SHTProductMediaItemModel.isMouseenter) {
          window.SHTProductMediaItemModel.loadShopifyXR();
        }
        window.SHTProductMediaItemModel.isMouseenter = true;
      },
      false
    );
    ["mouseenter", "touchstart", "mouseover"].forEach(function (e) {
      SHTHelper.qs("body").addEventListener(e, function (event) {
        if (!window.SHTProductMediaItemModel.isMouseenter) {
          window.SHTProductMediaItemModel.loadShopifyXR();
        }
        window.SHTProductMediaItemModel.isMouseenter = true;
      });
    });
  }
}

class SHTFeaturedVariantSelector extends SHTCustomComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);

    this.elms = {
      radio_elms: this.$$(".js-featured-variant-radio-item"),
      form: SHTHelper.qs(`#featuredProductForm-${this.dataset.section}`),
      price: SHTHelper.qs(`#featuredProductPrice-${this.dataset.section}`),
      product_form: SHTHelper.qs(`sht-featured-prd-frm[data-section="${this.dataset.section}"]`),
      inventory_tracking: SHTHelper.qs(`#featuredInventoryTracking-${this.dataset.section}`),
      variant_picker: SHTHelper.qs(`#featuredVariantPicker-${this.dataset.section}`),
      quantity_input: SHTHelper.qs(`#featuredProductQuantity-${this.dataset.section}`),
      slideshow: SHTHelper.qs(`sht-prd-slideshow[data-section="${this.dataset.section}"]`),
      thumb_carousel: SHTHelper.qs(`sht-vert-carousel[data-section="${this.dataset.section}"]`),
      carousel: SHTHelper.qs(`sht-carousel[data-section-id="${this.dataset.section}"]`),
      variant_options: this.$$(".js-variant-option-value"),
      sku: SHTHelper.qs(`#featuredSku-${this.dataset.section}`),
    };

    this.price_selector = `#featuredProductPrice-${this.dataset.section}`;
    this.inventory_tracking_selector = `#featuredInventoryTracking-${this.dataset.section}`;
    this.variant_picker_selector = `#featuredVariantPicker-${this.dataset.section}`;
    this.quantity_input_selector = `#featuredProductQuantity-${this.dataset.section}`;

    this.slideshow_selector = `sht-prd-slideshow[data-section="${this.dataset.section}"]`;
    this.sku_selector = `#featuredSku-${this.dataset.section}`;

    this.variantData = this.setSelectedVariants(this);

    this.updateSelectedVariants(this.variantData);
    this.bindEventHandlers();
  }

  updateSelectedVariants(variant) {
    if (!variant?.options) return;

    variant.options.forEach((e, index) => {
      const variantValue = `${e}-${index}`.replace(/"/g, '\\"');
      const selectedElement = this.$(`.js-variant-item[data-variant-value="${variantValue}"]`);
      if (selectedElement) {
        const variantName = selectedElement.getAttribute("data-variant-name") || selectedElement.getAttribute("name");
        const optionValue = selectedElement.dataset.optionVariantValue;
        if (variantName) {
          const targetElement = this.$(`.js-variant-radio-option-name[data-option-name="${variantName.replace(/"/g, '\\"')}"]`);
          if (targetElement) targetElement.innerHTML = e;

          const targetSelectElement = this.$(`.js-variant-select-option-name[data-option-name="${variantName.replace(/"/g, '\\"')}"]`);
          if (targetSelectElement) {
            targetSelectElement.innerHTML = optionValue || e;
          }
        }
      }
    });
  }

  setSelectedVariants(node) {
    return JSON.parse(node.querySelector('[data-selected-variant][type="application/json"]').textContent);
  }
  /**
   * bind event handler to web component elements
   */
  bindEventHandlers() {
    this.addEventListener("change", () => this.onVariantChangeHandle());
  }

  onVariantChangeHandle() {
    this.toggleAddButton(true);
    this.removeErrorMessage();
    this.renderProductInfo();
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    let form = this.elms.form;
    if (!form) return;
    let addBtn = form.querySelector(".js-featured-product-form-submit-btn");
    let addBtnText = addBtn.querySelector(".js-featured-product-form-submit-btn-text");

    if (!addBtn) return;
    if (disable) {
      addBtn.setAttribute("disabled", "disabled");
      if (text) addBtnText.textContent = text;
    } else {
      addBtn.removeAttribute("disabled");
      addBtnText.textContent = SHTLanguage.product.PRODUCT_ADD_TO_CART;
    }

    if (!modifyClass) return;
  }

  removeErrorMessage() {
    if (this.elms.product_form) this.elms.product_form.handleErrorMessage();
  }

  getSelectedVariantValue() {
    return Array.from(this.querySelectorAll('.js-variant-item:checked')).map(el => el.dataset.optionValueId);
  }

  buildRequestUrlWithParams(url, optionValues) {
    const params = new URLSearchParams({ section_id: this.dataset.section });
    if (optionValues.length) params.append("option_values", optionValues.join(","));
    return `${url}?${params.toString()}`;
  }

  async renderProductInfo() {
    const productUrl = this.dataset.url;
    const optionValues = this.getSelectedVariantValue();
    const requestUrl = this.buildRequestUrlWithParams(productUrl, optionValues);

    try {
      const response = await fetch(requestUrl);
      if (!response.ok) throw new Error("Network response was not ok");

      const html = await response.text();
      const markup = new DOMParser().parseFromString(html, "text/html");

      const variant = this.setSelectedVariants(markup);

      if (!variant) return this.setUnavailable();

      this.updateUI(markup, variant);
    } catch (err) {
      console.error("Error fetching product info:", err);
      this.setUnavailable();
    }
  }

  checkInventory(markup) {
    const dest = this.elms.inventory_tracking;
    const src = markup.querySelector(this.inventory_tracking_selector);
    if (dest) dest.innerHTML = src?.innerHTML ?? "";
  }

  updateOptionValues(markup) {
    const src = markup.querySelector('.js-variant-picker');
    const dest = this.elms.variant_picker;
    if (src && dest) dest.innerHTML = src.innerHTML;
  }

  updateUI(markup, variant) {
    this.checkInventory(markup);
    this.updateVariantInput(variant);
    this.updateOptionValues(markup);

    // this.updateURL(variant);

    // if (!this.closest('.js-quick-buy-block') && !this.quickView && !this.closest('.js-bundle-product')) {
    //   this.updateURL(variant);
    // }

    this.setActiveMedia(variant);
    this.updatePrice(markup);
    this.updateSku(markup);
    this.updateQuantity(markup);
    this.updateSelectOptions(markup, variant);
    this.updateSlideshow(markup);
    this.updateAddToCartState(variant);
  }

  updateSelectOptions(markup, variant) {
    const srcItems = markup.querySelectorAll('sht-select .js-variant-select-item');
    const destItems = this.querySelectorAll('sht-select .js-variant-select-item');
    srcItems.forEach((src, i) => {
      if (destItems[i]) destItems[i].innerHTML = src.innerHTML;
    });
    this.updateSelectedVariants(variant);
  }

  updateSku(markup) {
    const src = markup.querySelector(this.sku_selector);
    if (this.elms.sku) this.elms.sku.innerHTML = src?.innerHTML ?? "";
  }

  updatePrice(markup) {
    const src = markup.querySelector(this.price_selector);
    if (src && this.elms.price) {
      this.elms.price.innerHTML = src.innerHTML;
      this.elms.price.classList.remove("d-none-important");
    }
  }

  updateQuantity(markup) {
    const msgDest = this.elms.quantity_input?.querySelector('.js-max-quantity-message');
    const msgSrc = markup.querySelector(this.quantity_input_selector)?.querySelector('.js-max-quantity-message');
    if (msgDest) {
      msgDest.classList.add('d-none-important');
      msgDest.innerHTML = msgSrc?.innerHTML ?? "";
    }
    const inputSrc = markup.querySelector(this.quantity_input_selector);
    if (this.elms.quantity_input) this.elms.quantity_input.innerHTML = inputSrc?.innerHTML ?? "";
  }

  updateAddToCartState(variant) {
    this.toggleAddButton(!variant.available, SHTLanguage.product.PRODUCT_SOLD_OUT);
  }

  updateSlideshow(markup) {
    if (this.elms.slideshow?.hide_variant === "false") {
      const src = markup.querySelector(this.slideshow_selector);
      if (src && this.elms.slideshow) {
        this.elms.slideshow.innerHTML = src.innerHTML;
        this.elms.slideshow.bindEventHandlers();
      }
    }
  }

  updateVariantInput(variant) {
    if (!variant) return;
    const forms = [this.elms.form, this.elms.installment_form];
    const stockStatus = SHTHelper.qs('.js-inventory-tracking');
    stockStatus?.classList.remove('d-none');
    forms.forEach(f => {
      if (f) {
        const input = f.querySelector('input[name="id"]');
        if (input) {
          input.value = variant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    });
  }

  setActiveMedia(variant) {
    if (variant.featured_media) {
      let mediaId = variant.featured_media.id;

      let activeMedia = this.elms.slideshow?.querySelector(`sht-carousel-itm[data-media-id="${this.dataset.section}-${mediaId}"]`);

      let activeThumb = this.elms.slideshow?.querySelector(`sht-vert-carousel-itm[data-media-target-id="${this.dataset.section}-${mediaId}"]`);

      if (!activeMedia) return;

      if (!window.matchMedia("(max-width: 768px)").matches) {
        this.elms.slideshow.querySelectorAll(".js-product-slideshow-item").forEach(element => {
          element.classList.remove("d-block");
          this.elms.slideshow.hide_variant == "true" && element.classList.add("d-none");
        });

        this.elms.slideshow.querySelectorAll(".js-product-slideshow-thumb").forEach(element => {
          element.classList.remove("is-active-item");
        });

        activeMedia.classList.add("d-block");
        this.elms.slideshow.hide_variant == "true" && activeMedia.classList.remove("d-none");
      } else {
        const carouselItems = this.elms.carousel?.querySelector(".js-carousel-items");
        if (carouselItems) {
          carouselItems.scrollTo({
            left: activeMedia.offsetLeft,
            behavior: "smooth",
          });
        }
      }

      if (activeThumb) {
        activeThumb.classList.add("is-active-item");
        const thumbCarouselItems = this.elms.thumb_carousel?.querySelector(".js-carousel-items");
        if (thumbCarouselItems) {
          thumbCarouselItems.scrollTo({
            top: activeThumb.offsetTop,
            behavior: "auto",
          });
        }
      }

      this.elms.slideshow.pauseAllVideo();
    }
  }
  setUnavailable() {
    let form = this.elms.form;
    let inventoryTracking = this.elms.inventory_tracking;
    if (!form) return;
    let addBtn = form.querySelector(".js-featured-product-form-submit-btn");
    let addBtnText = addBtn.querySelector(".js-featured-product-form-submit-btn-text");
    if (!addBtn) return;
    inventoryTracking.setAttribute('hidden','true');
    addBtnText.textContent = SHTLanguage.product.PRODUCT_UNAVAILABLE;
    if (this.elms.price) this.elms.price.classList.add("visibility-hidden");
  }
}

class SHTFeaturedVariantRadios extends SHTFeaturedVariantSelector {
  constructor() {
    super();
    this.select_type = "button";

  }
}

customElements.define("sht-featured-variant-radios", SHTFeaturedVariantRadios);

class SHTFeaturedVariantSelects extends SHTFeaturedVariantSelector {
  constructor() {
    super();
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
    this.select_type = "dropdown";
  }
}
customElements.define("sht-featured-variant-selects", SHTFeaturedVariantSelects);

class SHTFeaturedVariantSwatchSelect extends HTMLElement {
  constructor() {
    super();
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
  }

  init() {
    this.radios = this.$$(".js-variant-radio-item");
    this.select_id = this.dataset.selectId;
    this.select_element = document.querySelector(`#${this.select_id}`);

    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.radios.forEach(radio => {
      radio.addEventListener("click", e => {
        e.preventDefault();
        Array.from(this.radios, input => {
          input.checked = false;
        });

        setTimeout(() => {
          e.target.checked = true;
        });
        if (this.select_element) {
          let option = this.select_element.querySelector(`option[value="${e.target.value.replace(/"/g, '\\"')}"]`);
          option.selected = true;
          this.select_element.dispatchEvent(
            new Event("change", {
              bubbles: true,
            })
          );
        }
      });
    });
  }
  connectedCallback() {
    this.init();
  }
}
customElements.define("sht-featured-variant-swatch-select", SHTFeaturedVariantSwatchSelect);

class SHTFeaturedProductForm extends SHTCustomComponent {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }
  init() {
    //this.$ = this.querySelector.bind(this);

    this.elms = {
      form: this.$("form"),
      submit_btn: this.$('[type="submit"]'),
      error_wrapper: this.$(".js-featured-product-form-error-wrapper"),
      error_message: this.$(".js-featured-product-form-error-message"),
      spinner: this.$(".js-featured-product-form-spinner"),
      quantity_input_container: SHTHelper.qs(`#featuredProductQuantity-${this.dataset.section}`),
      sticky_header: SHTHelper.qs("sht-sticky-header"),
      header: SHTHelper.qs("sht-header"),
      announcement_bar: SHTHelper.qs("sht-ann-bar"),
      header_cart_status: SHTHelper.qs("#headerCartStatus"),
    };

    this.cartNotiType = document.body.getAttribute("data-cart-show-type");
    this.cartType = document.body.getAttribute("data-cart-type");

    this.cartNotification = SHTHelper.qs("sht-cart-noti");

    this.cartDrawer = SHTHelper.qs("sht-cart-drwr");
    this.cartDrawerForm = SHTHelper.qs("sht-cart-drwr-frm");

    if (this.elms.form) {
      this.elms.form.querySelector("[name=id]").disabled = false;
      this.bindEventHandlers();
    }
  }

  /**
   * bind event handler to web component elements
   */
  bindEventHandlers() {
    this.elms.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    // this.cartNotification &&
    //   this.cartNotification.setActiveElement(document.activeElement);
  }
  onSubmitHandler(e) {
    e.preventDefault();

    if (this.elms.submit_btn.classList.contains("loading")) return;
    this.handleErrorMessage();

    this.elms.submit_btn.setAttribute("aria-disabled", true);
    this.elms.submit_btn.setAttribute("disabled", true);
    this.elms.submit_btn.classList.add("loading");

    this.elms.spinner.classList.remove("hidden");

    if (this.elms.header_cart_status) {
      this.elms.header_cart_status.classList.remove("header-cart-status--animate");
    }
    let sections = [];
    if (this.cartNotification) {
      sections = this.cartNotification.getSectionsToRender();
    }

    if (this.cartDrawer) {
      sections = [...sections, ...this.cartDrawer.getSectionsToRender()];
    }

    let formData = new FormData(this.elms.form);
    if (sections.length) {
      formData.append(
        "sections",
        sections.map(section => section.id)
      );
    }

    let elementToFocus = typeof e.submitter != "undefined" ? this.elms.submit_btn : null;

    formData.append("sections_url", window.location.pathname);
    SHTHelper.fetchConfigHTTP.body = formData;

    fetch(`${routes.cart_add_url}`, SHTHelper.fetchConfigHTTP)
      .then(response => response.json())
      .then(response => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        if (this.elms.sticky_header) {
          if (this.elms.sticky_header.dataset.isEnabled) {
            this.elms.sticky_header.reveal();
          }
        }

        switch (this.cartNotiType) {
          case "show_popup_noti":
            this.handleShowNotification(response, elementToFocus);
            break;
          case "show_drawer":
            this.handleShowDrawer(response, elementToFocus);
            break;
        }

        if (this.elms.quantity_input_container && this.elms.quantity_input_container.dataset.show == "add-to-cart") {
          this.elms.quantity_input_container.classList.remove("d-none");
          this.elms.quantity_input_container.querySelector("input").value = 1;
        }

        if (!this.elms.header) {
          window.location.assign(window.routes.cart_url);
        }
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.elms.submit_btn.classList.remove("loading");
        this.elms.submit_btn.removeAttribute("aria-disabled");
        this.elms.submit_btn.removeAttribute("disabled");
        this.elms.spinner.classList.add("hidden");
      });
  }

  handleShowNotification(response, elementToFocus) {
    if (this.cartNotification) {
      this.cartNotification.renderContents(response, true, elementToFocus);
    }
    if (this.cartDrawerForm) {
      this.cartDrawerForm.renderContents(response);
    }
  }

  handleShowDrawer(response, elementToFocus) {
    if (this.cartType === "drawer") {
      this.cartNotification?.renderContents(response, false);
      this.cartDrawerForm?.renderContents(response);
      this.cartDrawer?.querySelector(".js-drawer-message")?.setActiveMessage();
      this.cartDrawer?.openDrawer(elementToFocus);
    } else if (this.cartType === "page") {
      this.cartNotification?.renderContents(response, false);
      window.location.assign(window.routes.cart_url);
    }
  }

  handleErrorMessage(errorMessage = false) {
    this.elms.error_wrapper.toggleAttribute("hidden", !errorMessage);

    if (errorMessage) {
      this.elms.error_message.textContent = errorMessage;
    }
  }
}

customElements.define("sht-featured-prd-frm", SHTFeaturedProductForm);

window.addEventListener("load", function () {
  if (!customElements.get("sht-shape-parallax")) {
    class SHTShapeParallax extends SHTCustomComponent {
      constructor() {
        super();
        // this.$ = this.querySelector.bind(this);
        this.speed = -8;
        this.shape = this.$(".js-shape-parallax-shape");
        this.shape_rotation = this.$(".js-shape-parallax-rotation");
        this.content = this.$(".js-shape-parallax-content");
        this.bound = {};
        this.dataTransformContent = this.dataset.contentTransform;
        this.dataEnableParallaxScrolling = this.dataset.enableParallaxScrolling == "true";

        this.inViewport = false;
      }

      recalculate() {
        const scH = SHTHelper.qde.scrollTop;
        this.top = this.bound.top + scH + this.offsetHeight / 2;
        this.windowH = window.innerHeight;
        this.maxY = this.windowH / 2;
        this.cA = this.top - this.windowH;
      }

      recalculateForEditor() {
        const scH = SHTHelper.qde.scrollTop;
        const bound = this.getBoundingClientRect();
        this.top = bound.top + scH + this.offsetHeight / 2;
        this.windowH = window.innerHeight;
        this.maxY = this.windowH / 2;
        this.cA = this.top - this.windowH;
      }

      bindEventHandlers() {
        document.addEventListener(
          "scroll",
          () => {
            requestAnimationFrame(this.setAnimation.bind(this));
          },
          true
        );

        if (Shopify.designMode) {
          document.addEventListener(
            "shopify:inspector:activate",
            function (event) {
              setTimeout(() => {
                this.recalculateForEditor();
                requestAnimationFrame(this.setAnimation.bind(this));
              });
            }.bind(this)
          );

          document.addEventListener(
            "shopify:section:load",
            function (event) {
              setTimeout(() => {
                this.recalculateForEditor();
                requestAnimationFrame(this.setAnimation.bind(this));
              });
            }.bind(this)
          );
        }
      }

      calculatePercentage() {
        const cH = SHTHelper.qde.scrollTop;
        const dY = cH - this.cA;

        let percent = 0;
        if (this.inViewport) {
          percent = -cH / this.top;
        } else {
          percent = 1 - dY / this.maxY;
        }

        return percent;
      }

      setAnimation() {
        const cH = SHTHelper.qde.scrollTop;
        const percent = this.calculatePercentage();
        const shapeTop = (this.windowH / 12) * percent;
        //chan dau - duoi
        //const shapeTop = Math.min(Math.max((wH / 6) * percent, -50), 50);

        if (this.dataEnableParallaxScrolling) {
          this.shape.style.transform = `translate3d(0px, ${shapeTop}px, 0px)`;
        }

        this.shape_rotation.style.transform = `rotate(${cH / 4}deg)`;
        this.content.style.transform = `${this.dataTransformContent} rotate(-${cH / 4}deg)`;
      }

      onObserverHandler() {
        let observe = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && SHTHelper.qde.scrollTop <= 0) {
              this.inViewport = true;
            }
            observer.unobserve(this.shape);
          });
        });

        observe.observe(this.shape);

        if (!Shopify.designMode) {
          let observer_e = new IntersectionObserver((entries, observer) => {
            this.bound = entries[0].boundingClientRect;
            this.recalculate();
            requestAnimationFrame(this.setAnimation.bind(this));
            observer.disconnect();
          });
          observer_e.observe(this);
        }
      }

      /**
       * When the element is added to the DOM, the connectedCallback method is triggered
       */
      connectedCallback() {
        this.bindEventHandlers();
        this.onObserverHandler();
      }

      /**
       * When the element is removed from the DOM, the disconnectedCallback method is triggered
       */
      disconnectedCallback() {}
    }
    customElements.define("sht-shape-parallax", SHTShapeParallax);
  }
});

var VAR_LOCALIZATION_CACHE = new Map();

class SHTLocalization extends SHTCustomComponent {
  constructor() {
    super();
  }

  async init() {
    if (Shopify.designMode) {
      await this.getSearchResults();
    } else {
      const handleIntersection = async (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        await this.getSearchResults();

        observer.unobserve(this);
      };

      new IntersectionObserver(handleIntersection.bind(this), { threshold: 0.25 }).observe(this);
    }
  }

  async getSearchResults() {
    SHTHelper.loadScript(
      this.dataset.jsFileId,
      this.dataset.jsFile,
      async function () {
        let key = this.dataset.url.replace(/\s/g, "-").toLowerCase();
        let cached = VAR_LOCALIZATION_CACHE.get(key);

        if (!cached) {
          let markup = await this.fetchResults();
          VAR_LOCALIZATION_CACHE.set(key, markup);

          this.innerHTML = markup;
        } else {
          this.innerHTML = cached;
        }
      }.bind(this)
    );
  }

  async fetchResults() {
    let results = fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const languages = html.querySelector(`#${this.dataset.sectionId}`);
        if (languages && languages.innerHTML.trim().length) {

          return languages.innerHTML;
        }
        return "";
      })
      .catch(e => {
        console.error(e);
        return "";
      });

    return results;
  }

  connectedCallback() {
    this.init();
  }
}

customElements.define("sht-localization", SHTLocalization);

class SHTFreeShippingBar extends SHTCustomComponent {
  /**
   * Constructor
   */
  constructor() {
    super();
    //this.$ = this.querySelector.bind(this);

    this.total_price = this.dataset.totalPrice;
    this.threshold = 0;
    this.original_free_shipping_price = this.dataset.freeShippingOriginalPrice;
    this.free_shipping_price = this.dataset.freeShippingPrice;
    this.free_shipping_progress = this.$(`.js-free-shipping-progress`);
    this.free_shipping_progress_content = this.$(`.js-free-shipping-progress-content`);
    this.free_shipping_progress_message = this.$(`.js-free-shipping-message`);

    this.init();
  }

  calculateCurrencyRate() {
    this.threshold = Math.round(this.free_shipping_price * (Shopify.currency.rate || 1));
  }

  init() {
    this.calculateCurrencyRate();
    this.free_shipping_progress.max = this.threshold;
    this.free_shipping_progress.value = this.total_price;
    this.free_shipping_progress_content.innerHTML = SHTHelper.formatMoney(this.threshold, window.theme_variables.settings.money_with_currency_format);

    let remain = this.threshold - this.total_price;
    if (remain <= 0) {
      this.free_shipping_progress_message.innerHTML = SHTLanguage.free_shipping_bar.FULFILLED;
    } else {
      this.free_shipping_progress_message.innerHTML = SHTLanguage.free_shipping_bar.UNFULFILLED.replace("[remaining_amount]", SHTHelper.formatMoney(remain, window.theme_variables.settings.money_with_currency_format));
    }
  }
}
customElements.define("sht-free-shipping-bar", SHTFreeShippingBar);

class SHTCountDown extends SHTCustomComponent {
  constructor() {
    super();
  }

  init() {
    this.isExpired = JSON.parse(this.dataset.isExpired);
    if (this.isExpired) return true;
    this.timeZoneName = this.dataset.timeZoneName;
    this.timeZoneOffset = this.dataset.timeZoneOffset;
    this.endTime = this.dataset.endTime;
    this.endDate = this.dataset.endDate;
    this.hideOnEnd = JSON.parse(this.dataset.hideOnEnd);

    if (!this.validateDateValue(this.endDate)) {
      this.endDate = this.getCurrentDateTime(true);
    }

    if (!this.validateTimeValue(this.endTime)) {
      this.endTime = "23:59:59";
    }

    this.expiredAt = new Date(this.convertDateStringToISOString(`${this.endDate}:${this.endTime}`)).getTime();
    this.currentTime = this.convertDateTimeToSpecificTimeZone(this.getCurrentDateTime());
    this.daysElement = this.$(".js-counter-days");
    this.hoursElement = this.$(".js-counter-hours");
    this.minutesElement = this.$(".js-counter-minutes");
    this.secondsElement = this.$(".js-counter-seconds");
    this.messageElement = this.$(".js-counter-message");
    this.counterElement = this.$(".js-counter");

    const interval = setInterval(() => {
      const diff = this.expiredAt - this.currentTime;
      if (diff <= 0) {
        clearInterval(interval);
        this.setCounter({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        });

        if (this.messageElement.innerHTML != "") {
          this.messageElement.classList.remove("d-none");
        }

        if (this.hideOnEnd) {
          this.counterElement.classList.add("d-none-important");
        }

        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      this.setCounter({ days, hours, minutes, seconds });
      this.currentTime = this.currentTime + 1000;
    }, 1000);
  }

  connectedCallback() {
    this.init();
  }

  getCurrentDateTime(onlyDate = false) {
    const currentDate = new Date();
    const year = currentDate.getFullYear();

    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const hours = String(currentDate.getHours()).padStart(2, "0");
    const minutes = String(currentDate.getMinutes()).padStart(2, "0");
    const seconds = String(currentDate.getSeconds()).padStart(2, "0");
    if (onlyDate) {
      return `${year}-${month}-${day}`;
    } else {
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
  }

  convertDateTimeToSpecificTimeZone(dateString, timestamp = true) {
    const inputDate = new Date(dateString);
    const isNegativeOffset = this.timeZoneOffset[0] === "-";
    const offsetHours = parseInt(this.timeZoneOffset.substring(1, 3));
    const offsetMinutes = parseInt(this.timeZoneOffset.substring(3, 5));
    let timeDifferenceMillis = (offsetHours * 60 + offsetMinutes) * 60 * 1000;
    if (isNegativeOffset) {
      timeDifferenceMillis = -timeDifferenceMillis;
    }
    const targetTime = new Date(inputDate.getTime() + timeDifferenceMillis);

    return timestamp ? targetTime.getTime() : targetTime.toISOString();
  }

  setCounter({ days, hours, minutes, seconds }) {
    this.daysElement.textContent = days < 10 ? `0${days}` : days;
    this.hoursElement.textContent = hours < 10 ? `0${hours}` : hours;
    this.minutesElement.textContent = minutes < 10 ? `0${minutes}` : minutes;
    this.secondsElement.textContent = seconds < 10 ? `0${seconds}` : seconds;
  }

  convertDateStringToISOString(inputDateStr) {
    const reformatDateStr = inputDateStr.replace(/:/, "T");
    return `${reformatDateStr}.000Z`;
  }

  validateDateValue(dateString) {
    const datePattern = /^\d{4}-\d{2}-\d{2}$/;

    if (datePattern.test(dateString)) {
      return true;
    } else {
      return false;
    }
  }

  validateTimeValue(timeString) {
    const timePattern = /^([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/;

    if (timePattern.test(timeString)) {
      return true;
    } else {
      return false;
    }
  }
}

customElements.define("sht-countdown", SHTCountDown);

class SHTHorizoltalCarousel extends SHTCustomComponent {
  constructor() {
    super();

    this.sectionID = this.dataset.sectionId;
    this.carousels = this.$$(".js-carousel-item");
    this.container = this.$(".js-carousel-items");
    this.totalItems = this.carousels.length;
    this.prevBtnElement = this.$(".js-carousel-prev-btn");
    this.nextBtnElement = this.$(".js-carousel-next-btn");
    this.currentElement = this.$(".js-carousel-counter-current");
    this.totalElement = this.$(".js-carousel-counter-total");
    this.paginationElement = this.$(".js-carousel-pagination");

    this.slideshow = SHTHelper.qs(`sht-prd-slideshow[data-section="${this.dataset.section}"]`);
    this.carousel = SHTHelper.qs(`sht-carousel[data-section-id="${this.dataset.section}"]`);
    this.carouselLayout = this.getAttribute("data-layout");
    this.window_width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    this.transform();
    this.bindEventHandlers();
    window.addEventListener("resize", e => {
      let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (this.window_width != windowWidth) {
        this.transform(e);
        this.window_width = windowWidth;
      }
    });
  }

  bindEventHandlers() {
    // Skip binding for quick view modal - it has its own handler
    if (this.closest('.product__quickview')) return;
    
    this.$$(".js-slideshow-btn-thumb").forEach((e, i) => {
      if (i === 0) {
        e.closest(".js-product-slideshow-thumb").classList.add("is-active-item");
      }
      e.addEventListener("click", this.setActiveMedia.bind(this, e));
    });
  }

  setActiveMedia(e) {
    if (!this.slideshow) return;
    
    let activeMedia = this.slideshow.querySelector(`[data-media-id="${e.dataset.target}"]`);
    let activeThumb = e.closest("sht-vert-carousel-itm");

    if (!activeMedia || !activeThumb) return;

    if (window.matchMedia("(max-width: 768px)").matches) {
      this.slideshow.pauseAllVideo();
      this.$$(".js-product-slideshow-thumb").forEach(element => {
        element.classList.remove("is-active-item");
      });
      activeThumb.classList.add("is-active-item");

      const carouselItems = this.carousel?.querySelector(".js-carousel-items");
      if (carouselItems && activeMedia) {
        carouselItems.scrollTo({
          left: activeMedia.offsetLeft,
          behavior: "smooth",
        });
      }
    }
  }

  transform(e) {
    setTimeout(() => {
      this.horizontalInit();
      this.horizontalBindEventHandlers();
      if (typeof e != "undefined") {
        this.horizontalSetActiveMedia();
      }
    }, 200);
  }
  /* horizontal */
  horizontalInit() {
    this.itemsToShow = Array.from(this.carousels).filter(element => element.clientWidth > 0);

    if (this.itemsToShow.length < 2) {
      this.horizontalTogglePagination(false);
      return;
    }
    this.gutter = parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-left")) + parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-right"));

    this.itemOffset = this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft;
    this.itemsPerPage = Math.floor((this.container.clientWidth - this.itemsToShow[0].offsetLeft) / this.itemOffset);
    // this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1;

    this.horizontalUpdateCarousel();
  }
  horizontalUpdateCarousel() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.container.scrollLeft / this.itemOffset) + 1;
    if (this.currentPage > 0 && this.totalPages > 0) {
      if (this.totalElement) {
        this.totalElement.textContent = this.totalPages;
      }
      if (this.currentElement) {
        this.currentElement.innerHTML = this.currentPage + `<span class="visually-hidden">${this.currentElement.dataset.accessibilityMessage}</span>`;
      }
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("itemChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.itemsToShow[this.currentPage - 1],
            container: this,
          },
        })
      );
    }
    if (this.horizontalIsItemVisible(this.itemsToShow[0]) && this.container.scrollLeft === 0) {
      this.prevBtnElement.setAttribute("disabled", "disabled");
    } else {
      this.prevBtnElement.removeAttribute("disabled");
    }
    if (this.horizontalIsItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      this.nextBtnElement.setAttribute("disabled", "disabled");
    } else {
      this.nextBtnElement.removeAttribute("disabled");
    }

    if (this.totalPages > 1) {
      this.horizontalTogglePagination(true);
    }

    if (this.totalPages <= 1) {
      this.horizontalTogglePagination(false);
    }
  }
  horizontalIsItemVisible(element, offset = 0) {
    const lastVisibleItem = this.container.clientWidth + this.container.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleItem && element.offsetLeft >= this.container.scrollLeft;
  }
  horizontalOnButtonClick(event) {
    event.preventDefault();
    let step = 1;
    let gutter = 0;
    // const mediaQuery = window.matchMedia("(min-width: 769px)");
    // if (mediaQuery.matches) {
    //   step = event.currentTarget.dataset.step;
    // }
    if (this.container.scrollLeft == 0 || this.horizontalIsItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      gutter = this.gutter;
    }
    this.itemScrollPosition = event.currentTarget.name === "next" ? this.container.scrollLeft - gutter + step * this.itemOffset : this.container.scrollLeft + gutter - step * this.itemOffset;
    window.requestAnimationFrame(() =>
      this.container.scrollTo({
        left: this.itemScrollPosition,
        behavior: "smooth",
      })
    );
  }
  horizontalBindEventHandlers() {
    if (this.prevBtnElement) {
      this.prevBtnElement.addEventListener("click", this.horizontalOnButtonClick.bind(this));
    }
    if (this.nextBtnElement) {
      this.nextBtnElement.addEventListener("click", this.horizontalOnButtonClick.bind(this));
    }
    this.container.addEventListener("scroll", SHTHelper.debounce(this.horizontalUpdateCarousel.bind(this), 100));
  }
  horizontalTogglePagination(flag) {
    if (flag) {
      this.paginationElement?.classList.remove("d-none-important");
      this.paginationElement?.classList.add("d-flex");
    } else {
      this.paginationElement?.classList.remove("d-flex");
      this.paginationElement?.classList.add("d-none-important");
    }
  }
  horizontalSetActiveMedia() {
    let activeThumb = this.$("sht-vert-carousel-itm.is-active-item");
    if (activeThumb) {
      this.container.scrollTo({
        left: activeThumb.offsetLeft,
        behavior: "auto",
      });

      let activeMedia = this.slideshow.$(`sht-carousel-itm[data-media-id="${activeThumb.dataset.mediaTargetId}"]`);

      this.carousel.querySelector(".js-carousel-items").scrollTo({
        left: activeMedia.offsetLeft,
        behavior: "auto",
      });
    }
  }
  /* horizontal */
}
customElements.define("sht-horizoltal-carousel", SHTHorizoltalCarousel);

class SHTCartDiscount extends SHTCustomComponent {
  // Constants moved to class level for better memory usage
  static ENTER_KEY = 'Enter';
  static CART_UPDATE_DELAY = 500;
  static BIND_BUTTONS_DELAY = 600;
  static ENDPOINTS = {
    DISCOUNT: '/cart/update.js'
  };

  constructor() {
    super();
    this.initializeProperties();
    this.cacheElements();
    this.initializeState();
  }

  initializeProperties() {
    this.sectionId = this.dataset.sectionId;
    this.isUpdating = false;
    this.eventListeners = new Map(); // Better than Set for tracking
    this.debounceTimers = new Map(); // For debouncing operations
  }

  cacheElements() {
    // Cache all DOM elements once
    this.elements = {
      formDiv: this.querySelector('[data-discount-form]'),
      input: null, // Will be set after formDiv
      errorContainer: this.querySelector('#cartDiscountError'),
      successContainer: this.querySelector('#cartDiscountSuccess'),
      errorShipping: null, // Will be set after errorContainer
      errorDiscount: null,  // Will be set after errorContainer
      submitBtn: null, // Will be set after formDiv
      pillsContainer: this.querySelector('.js-discount-pills')
    };

    // Set dependent elements
    if (this.elements.formDiv) {
      this.elements.input = this.elements.formDiv.querySelector('.js-discount-input');
      this.elements.submitBtn = this.elements.formDiv.querySelector('.js-discount-submit');
    }

    if (this.elements.errorContainer) {
      this.elements.errorShipping = this.elements.errorContainer.querySelector('.js-error-shipping');
      this.elements.errorDiscount = this.elements.errorContainer.querySelector('.js-error-discount');
    }
  }

  initializeState() {
    // Bind methods once to avoid repeated binding
    this.boundHandlers = {
      handleDiscountSubmit: this.handleDiscountSubmit.bind(this),
      handleKeydown: this.handleKeydown.bind(this),
      handleFormSubmit: this.handleFormSubmit.bind(this),
      handleCartUpdate: this.handleCartUpdate.bind(this),
      handleDOMReady: this.handleDOMReady.bind(this),
      handleRemoveClick: this.handleRemoveClick.bind(this)
    };
  }

  connectedCallback() {
    this.setupEventListeners();
    this.bindRemoveButtons();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  setupEventListeners() {
    this.setupFormEvents();
    this.setupCartUpdateListener();
    this.setupRemoveButtonsDelegation();
  }

  setupFormEvents() {
    if (!this.elements.formDiv || this.elements.formDiv.dataset.eventBound) return;

    this.elements.formDiv.dataset.eventBound = 'true';

    // Submit button
    if (this.elements.submitBtn) {
      this.addEventListener(this.elements.submitBtn, 'click', this.boundHandlers.handleDiscountSubmit);
    }

    // Input field
    if (this.elements.input) {
      this.addEventListener(this.elements.input, 'keydown', this.boundHandlers.handleKeydown);
    }

    // Form submit prevention
    const mainForm = document.getElementById('cartForm');
    if (mainForm) {
      this.addEventListener(mainForm, 'submit', this.boundHandlers.handleFormSubmit);
    }
  }

  setupCartUpdateListener() {
    this.addEventListener(document, 'cart:update', this.boundHandlers.handleCartUpdate);
    
    // DOM ready handler
    if (document.readyState === 'loading') {
      this.addEventListener(document, 'DOMContentLoaded', this.boundHandlers.handleDOMReady);
    } else {
      this.boundHandlers.handleDOMReady();
    }
  }

  setupRemoveButtonsDelegation() {
    if (!this.elements.pillsContainer || this.elements.pillsContainer.dataset.delegationBound) return;
    
    this.elements.pillsContainer.dataset.delegationBound = 'true';
    this.addEventListener(this.elements.pillsContainer, 'click', this.boundHandlers.handleRemoveClick);
  }

  // Unified event listener management
  addEventListener(element, event, handler) {
    element.addEventListener(event, handler);
    
    const key = `${element.tagName}-${event}`;
    if (!this.eventListeners.has(key)) {
      this.eventListeners.set(key, []);
    }
    this.eventListeners.get(key).push({ element, event, handler });
  }

  removeEventListener(element, event, handler) {
    element.removeEventListener(event, handler);
    
    const key = `${element.tagName}-${event}`;
    const listeners = this.eventListeners.get(key);
    if (listeners) {
      const index = listeners.findIndex(l => l.element === element && l.handler === handler);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    }
  }

  // Event handlers
  handleKeydown(e) {
    if (e.key === SHTCartDiscount.ENTER_KEY) {
      e.preventDefault();
      this.handleDiscountSubmit(e);
    }
  }

  handleFormSubmit(e) {
    const activeElement = document.activeElement;
    if (this.isDiscountInputActive(activeElement)) {
      e.preventDefault();
      this.handleDiscountSubmit(e);
      return false;
    }
  }

  handleCartUpdate(event) {
    if (event.detail?.source === 'discount') {
      this.debounceBindRemoveButtons();
    }
  }

  handleDOMReady() {
    this.debounce('dom-ready', () => this.bindRemoveButtons(), 100);
  }

    handleRemoveClick(e) {
    const removeButton = e.target.closest('.js-remove-discount');
    if (!removeButton) return;

    e.preventDefault();
    e.stopPropagation();

    this.hideMessages();

    const discountCode = removeButton.dataset.removeDiscount;
    if (discountCode) {
      this.processDiscountRemoval(discountCode);
    }
  }

  // Debounce utility
  debounce(key, func, delay) {
    if (this.debounceTimers.has(key)) {
      clearTimeout(this.debounceTimers.get(key));
    }

    const timer = setTimeout(() => {
      func();
      this.debounceTimers.delete(key);
    }, delay);

    this.debounceTimers.set(key, timer);
  }

  debounceBindRemoveButtons() {
    // Single debounced call instead of multiple timeouts
    this.debounce('bind-buttons', () => this.bindRemoveButtons(), SHTCartDiscount.BIND_BUTTONS_DELAY);
  }

  isDiscountInputActive(element) {
    return element?.name === 'discount' && element.closest('[data-discount-form]');
  }

  bindRemoveButtons() {
    // Use more efficient selector and avoid repeated queries
    const removeButtons = document.querySelectorAll('.js-remove-discount:not([data-event-bound-remove])');
    
    if (removeButtons.length === 0) return;

    removeButtons.forEach(button => {
      const clickHandler = (e) => this.handleDiscountRemove(e);
      this.addEventListener(button, 'click', clickHandler);
      button.dataset.eventBoundRemove = 'true';
    });
  }

  async handleDiscountSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    const discountCode = this.getDiscountCodeFromInput();
    if (!discountCode) return;

    await this.processDiscountApplication(discountCode);
  }

  async handleDiscountRemove(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Ẩn thông báo khi xóa mã giảm giá
    this.hideMessages();

    const discountCode = e.currentTarget.dataset.removeDiscount;
    if (!discountCode) return;

    await this.processDiscountRemoval(discountCode);
  }

  getDiscountCodeFromInput() {
    return this.elements.input?.value.trim() || '';
  }

  async processDiscountApplication(discountCode) {
    this.setLoading(true);
    this.hideMessages();

    try {
      const existingDiscounts = this.getExistingDiscountCodes();
      const response = await this.applyDiscount(discountCode);

      if (!response.ok) {
        const errorData = await response.json();
        this.showError(errorData.description || 'discount_code');
        return;
      }

      const data = await response.json();
      const validationResult = this.validateDiscountResponse(data, existingDiscounts, discountCode);

      if (!validationResult.isValid) {
        this.clearInput();
        this.showError(validationResult.errorType);
        return;
      }

      this.handleSuccessfulDiscount();
    } catch (error) {
      console.error('Error applying discount:', error);
      this.showError('general');
    } finally {
      this.setLoading(false);
    }
  }

  async processDiscountRemoval(discountCode) {
    this.setLoading(true);

    this.hideMessages();

    try {
      const remainingCodes = this.getExistingDiscountCodes()
        .filter(code => code !== discountCode);

      const response = await this.sendDiscountUpdateRequest(remainingCodes);

      if (response.ok) {
        this.updateCartDrawer();
      }
    } catch (error) {
      console.error('Error removing discount:', error);
    } finally {
      this.setLoading(false);
    }
  }

  validateDiscountResponse(data, existingDiscounts, discountCode) {
    if (this.isDiscountNotApplicable(data, discountCode)) {
      return { isValid: false, errorType: 'discount_code' };
    }

    if (this.isShippingOnlyDiscount(data, existingDiscounts, discountCode)) {
      return { isValid: false, errorType: 'shipping' };
    }

    return { isValid: true };
  }

  isDiscountNotApplicable(data, discountCode) {
    return data.discount_codes?.some(discount =>
      discount.code === discountCode && discount.applicable === false
    );
  }

  isShippingOnlyDiscount(data, existingDiscounts, discountCode) {
    if (!data.sections?.[this.sectionId]) return false;

    const newDiscountCodes = this.extractDiscountCodesFromHTML(data.sections[this.sectionId]);
    return this.isDiscountAlreadyAppliedButNotVisible(
      newDiscountCodes,
      existingDiscounts,
      data.discount_codes,
      discountCode
    );
  }

  extractDiscountCodesFromHTML(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const section = doc.getElementById(`shopify-section-${this.sectionId}`);

    if (!section) return [];

    return Array.from(section.querySelectorAll('[data-discount-code]'))
      .map(el => el.dataset.discountCode)
      .filter(Boolean);
  }

  isDiscountAlreadyAppliedButNotVisible(newCodes, existingCodes, discountCodesData, discountCode) {
    const codesUnchanged = newCodes.length === existingCodes.length &&
                          newCodes.every(code => existingCodes.includes(code));

    const discountApplicable = discountCodesData?.some(discount =>
      discount.code === discountCode && discount.applicable === true
    );

    return codesUnchanged && discountApplicable;
  }

  async applyDiscount(code) {
    const existingCodes = this.getExistingDiscountCodes();
    const allCodes = [...existingCodes, code];
    return this.sendDiscountUpdateRequest(allCodes);
  }

  async sendDiscountUpdateRequest(codes) {
    return fetch(SHTCartDiscount.ENDPOINTS.DISCOUNT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        discount: codes.join(','),
        sections: this.sectionId
      })
    });
  }

  getExistingDiscountCodes() {
    return Array.from(this.querySelectorAll('[data-discount-code]'))
      .map(el => el.dataset.discountCode)
      .filter(Boolean);
  }

  handleSuccessfulDiscount() {
    this.clearInput();
    this.showSuccess();
    this.updateCartDrawer();
  }

  clearInput() {
    if (this.elements.input) {
      this.elements.input.value = '';
    }
  }

  updateCartDrawer() {
    if (this.isUpdating) return;

    this.isUpdating = true;
    this.dispatchCartUpdateEvent();

    // Single debounced update instead of multiple timeouts
    this.debounce('cart-update', () => {
      this.bindRemoveButtons();
      this.isUpdating = false;
    }, SHTCartDiscount.CART_UPDATE_DELAY);
  }

  dispatchCartUpdateEvent() {
    document.dispatchEvent(new CustomEvent('cart:update', {
      detail: {
        source: 'discount',
        timestamp: Date.now()
      }
    }));
  }

  // UI State Management
  hideMessages() {
    this.hideError();
    this.hideSuccess();
  }

  showSuccess() {
    if (!this.elements.successContainer) return;
    this.hideError();
    this.elements.successContainer.classList.remove('d-none-important');
  }

  hideSuccess() {
    this.elements.successContainer?.classList.add('d-none-important');
  }

  showError(errorType) {
    if (!this.elements.errorContainer) return;

    this.hideSuccess();
    this.elements.errorContainer.classList.remove('d-none-important');
    this.toggleErrorTypes(errorType);
  }

  toggleErrorTypes(errorType) {
    const isShippingError = errorType === 'shipping';

    this.elements.errorShipping?.classList.toggle('d-none-important', !isShippingError);
    this.elements.errorDiscount?.classList.toggle('d-none-important', isShippingError);
  }

  hideError() {
    this.elements.errorContainer?.classList.add('d-none-important');
  }

  setLoading(isLoading) {
    this.toggleAttribute('loading', isLoading);
    this.elements.formDiv?.classList.toggle('loading', isLoading);
    this.elements.submitBtn?.toggleAttribute('disabled', isLoading);
  }

  cleanup() {
    // Clear all timers
    this.debounceTimers.forEach(timer => clearTimeout(timer));
    this.debounceTimers.clear();

    // Remove all event listeners
    this.eventListeners.forEach(listeners => {
      listeners.forEach(({ element, event, handler }) => {
        element.removeEventListener(event, handler);
      });
    });
    this.eventListeners.clear();
  }
}
customElements.define('sht-cart-discount', SHTCartDiscount);

class SHTVariation extends SHTCustomComponent {
  constructor() {
    super();
    this.productVariations = this.$$('.js-variation-item');
    this.sectionId = this.dataset.sectionId;
    this.isQuickView = this.classList.contains('js-variation-quick-view');
    this.cachedData = {};
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    const item = event.target.closest('.js-variation-item');
    if (item) {
      this.handleVariationClick(item.dataset.variationUrl);
    }
  }

  handleVariationClick(url) {
    if (!this.isQuickView) {
      window.history.replaceState(null, '', url);
    }
    this.fetchData(url);
  }

  async fetchData(productUrl) {
    try {
      if (this.cachedData[productUrl]) {
        this.updateDOM(this.cachedData[productUrl], productUrl);
        return;
      }

      const fetchUrl = `${productUrl}?section_id=${this.sectionId}`;
      const response = await fetch(fetchUrl);

      if (!response.ok) {
        throw new Error(`Failed to fetch product: ${response.status} ${response.statusText}`);
      }

      const html = await response.text();

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      this.cachedData[productUrl] = tempDiv;

      await this.preloadImages(tempDiv);
      this.updateDOM(tempDiv, productUrl);
    } catch (error) {
      console.error('Error fetching product variation:', error);
    }
  }

  preloadImages(dom) {
    const images = dom.querySelectorAll('img[src]:not([loading="lazy"])');

    if (images.length === 0) {
      return Promise.resolve();
    }

    const promises = Array.from(images).map(img => {
      return new Promise((resolve) => {
        if (img.complete) {
          resolve();
        } else {
          img.onload = () => resolve();
          img.onerror = () => resolve();
        }
      });
    });

    return Promise.all(promises);
  }

  updateDOM(responseHTML, productUrl) {
    const targetSectionId = this.isQuickView ? 'dialogBodyQuickView' : this.sectionId;
    const currentSection = document.querySelector(`#${targetSectionId}`);

    if (!responseHTML || !currentSection) {
      console.warn('Product elements not found in current or new product');
      return;
    }

    const animateEl = responseHTML.querySelector('.js-main-product');
    if (animateEl) {
      animateEl.removeAttribute('data-animate');
    }

    if (this.isQuickView) {
      const quickViewContainer = responseHTML.querySelector('.js-quick-view-container');
      if (quickViewContainer) {
        currentSection.innerHTML = quickViewContainer.innerHTML;

        const viewFullBtn = document.querySelector('#dialogQuickShop .js-view-full-btn a') || document.querySelector('.js-quick-view-drawer .js-view-full-btn a');
        if (viewFullBtn && productUrl) {
          viewFullBtn.href = productUrl;
        }
      }
    } else {
      currentSection.parentElement.innerHTML = responseHTML.children[0].innerHTML;
    }

    // Simple and efficient payment button enhancement
    if (window.Shopify?.PaymentButton) {
      const updatedSection = document.querySelector(`#${targetSectionId}`);
      
      // Single initialization with proper timing
      requestAnimationFrame(() => {
        Shopify.PaymentButton.init();
        
        // Wait for Shopify to render, then setup observers
        setTimeout(() => {
          const containers = updatedSection.querySelectorAll('.shopify-payment-button');
          containers.forEach(container => {
            // Remove old observer flag
            container.removeAttribute('data-observed');
            
            // Enhance immediately
            SHTCustomComponent.enhancePaymentButtons(container);
            
            // Setup single efficient observer
            if (!container.dataset.observed) {
              const observer = new MutationObserver(() => {
                SHTCustomComponent.enhancePaymentButtons(container);
              });
              observer.observe(container, { childList: true, subtree: true });
              container.dataset.observed = 'true';
            }
          });
        }, 250);
      });
    }
  }
}
customElements.define('sht-variation', SHTVariation);

class SHTMarqueeSection extends SHTCustomComponent {
  constructor() {
    super();
    this.marqueeWrapper = this.$('.js-marquee-container');
    this.marqueeList = this.$('.js-marquee-list');
    this.marqueeListAll = this.$$('.js-marquee-list');
    this.normalSpeed = parseFloat(this.getAttribute('normal-speed')) / 2 || 1;
    this.stopSpeed = 0;
    this.direction = this.getAttribute('direction');
    this.loop = parseInt(this.marqueeWrapper.getAttribute("loop-marquee"));
    this.speed = this.normalSpeed;
    this.isRTL = SHTHelper.isRTL;
    this.init();
  }

  onResize() {
    this.resizeObserver = new ResizeObserver(entries => {
      this.marqueeListWidth = this.marqueeList.offsetWidth;
      this.currentPosition = 0;
      this.currentPositionReverse = this.isRTL ? this.marqueeListWidth : -this.marqueeListWidth;
      this.minWidthValue = window.innerWidth / (this.loop - 1);
      this.checkWidth();
      this.currentPositionReverse = this.isRTL ? this.newWidth : -this.newWidth;
    });
    this.resizeObserver.observe(this);
  }

  init() {
    this.onResize();
    this.startAnimation();
    this.bindHoverEvents();
  }

  checkWidth() {
    if (this.loop * this.marqueeListWidth < window.innerWidth) {
      this.marqueeListAll.forEach(e => {
        e.style.minWidth = this.minWidthValue + "px"
      });
      this.newWidth = this.minWidthValue;
    } else {
      this.marqueeListAll.forEach(e => {
        e.style.minWidth = ""
      });
      this.newWidth = this.marqueeListWidth;
    }
  }

  bindHoverEvents() {
    this.marqueeWrapper.addEventListener('mouseover', () => {
      this.speed = this.stopSpeed;
    });

    this.marqueeWrapper.addEventListener('mouseout', () => {
      this.speed = this.normalSpeed;
    });
  }

  startAnimation() {
    this.animate();
  }

  animate() {
    if (this.direction == 'animation-reverse') {
      if (this.isRTL) {
        this.currentPositionReverse -= this.speed;
        if (this.currentPositionReverse <= 0) {
          this.currentPositionReverse = this.newWidth;
        }
      } else {
        this.currentPositionReverse += this.speed;
        if (this.currentPositionReverse >= 0) {
          this.currentPositionReverse = -this.newWidth;
        }
      }

      this.marqueeWrapper.style.transform = `translateX(${this.currentPositionReverse}px)`;
    } else {
      if (this.isRTL) {
        this.currentPosition += this.speed;
        if (this.currentPosition >= this.newWidth) {
          this.currentPosition = 0;
        }
      } else {
        this.currentPosition -= this.speed;
        if (this.currentPosition <= -this.newWidth) {
          this.currentPosition = 0;
        }
      }

      this.marqueeWrapper.style.transform = `translateX(${this.currentPosition}px)`;
    }

    requestAnimationFrame(this.animate.bind(this));
  }
}
customElements.define("sht-marquee-section", SHTMarqueeSection);

class SHTInfinityScroll extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.renderContainer = SHTHelper.qid("loadMoreContainer");
    this.loadingIndicator = this.querySelector(".js-loading-infinity-scroll");
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.observer = this.registerObserver(this.loadNextPage.bind(this));
    this.observer.observe(this);
  }

  registerObserver(callback) {
    let callbackIsRunning = false;
    return new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !callbackIsRunning) {
        callbackIsRunning = true;
        callback()
          .then(() => (callbackIsRunning = false))
          .catch(() => (callbackIsRunning = false));
      }
    });
  }

  loadNextPage() {
    let { nextUrl, totalPages } = this.dataset;
    let nextPage = parseInt(this.dataset.currentPage) + 1;
    if (nextPage > totalPages) {
      this.observer.disconnect();
      return Promise.resolve();
    }
    this.loadingIndicator.classList.remove("hidden");
    return fetch(nextUrl.replace(/page=[0-9]+/, "page=" + nextPage))
      .then(response => {
        this.loadingIndicator.classList.add("hidden");
        return response.text();
      })
      .then(responseText => {
        const html = responseText;
        let htmlContent = document.createElement("div");
        htmlContent.innerHTML = html;
        let newContent = htmlContent.querySelector("#loadMoreContainer").innerHTML;
        this.renderContainer.insertAdjacentHTML("beforeend", newContent);
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.dataset.currentPage = parseInt(this.dataset.currentPage) + 1;
      });
  }
}
customElements.define("sht-infinity-scroll", SHTInfinityScroll);

class SHTNewsletterPopup extends SHTCustomComponent {
  /**
   * Initialize the newsletter popup component
   */
  constructor() {
    super();

    this.properties = JSON.parse(this.dataset.props || '{}');
    this.myStorage = window.localStorage;
    this.sessionStorageName = `${Shopify.theme.name.toLowerCase()}-newsletter-popup-display`;
    this.cartNotificationSessionKey = `${Shopify.theme.name.toLowerCase()}-cart-notification-popup-shown`;

    // Cache DOM elements early
    this.bodyElement = SHTHelper.qs("body");
    this.cartNotification = SHTHelper.qs("sht-cart-noti");
    this.cartDrawer = SHTHelper.qs("sht-cart-drwr");

    // Get cart show type from body data attribute (show_popup_noti or show_drawer)
    this.cartShowType = this.bodyElement ? this.bodyElement.dataset.cartShowType : "show_popup_noti";

    this.isOpen = false;
    this.buffer = 100;
    this.myScrollHeight = document.body.scrollHeight || SHTHelper.qde.scrollHeight || 0;
    this.myWindowHeight = window.innerHeight || SHTHelper.qde.clientHeight || 0;

    // Deferred content loading properties
    this.contentLoaded = false;
    this.contentContainer = this.$("[data-deferred-content]");
    this.contentTemplate = this.$(".js-newsletter-content-template");

    // Cache all DOM elements
    this.elms = {
      close_btn: this.$(".js-popup-close-btn"),
      body: this.bodyElement,
      trigger_btn: SHTHelper.qs(".js-newsletter-popup-trigger"),
      overlay: this.$(".js-newsletter-popup-overlay")
    };

    // Get settings from section
    this.trigger = this.dataset.trigger || "reaching-to-footer";
    this.delayTime = this.dataset.delayTime || "session";
    this.delayDays = parseInt(this.dataset.delayDays || 30);
    this.delayUntil = parseInt(this.dataset.delayUntil || 0);
    this.showOnlyOnIndex = this.hasAttribute("data-show-only-on-index");
    this.showOnlyForVisitors = this.hasAttribute("data-show-only-for-visitors");

    // Check if sticky popup is enabled (look for sticky popup element in DOM)
    this.stickyPopupEnabled = !!this.elms.trigger_btn;
    this.stickyStorageKey = `${Shopify.theme.name.toLowerCase()}-sticky-popup-dismissed`;

    // Track if popup was manually closed in the current session
    this.manuallyClosedInSession = false;

    // Bind event handlers
    this.boundScrollEventHandle = this.onScrollEventHandle.bind(this);
    this.boundOnLoadUserAction = this.onUserAction.bind(this);
    this.boundCloseBtnClickHandle = this.onCloseBtnClickHandle.bind(this);
    this.boundTriggerBtnClickHandle = this.onTriggerBtnClickHandle.bind(this);
    this.boundStickyCloseBtnClickHandle = this.onStickyCloseBtnClickHandle.bind(this);

    // Initialize
    this.init();
  }

  loadDeferredContent() {
    if (this.contentLoaded || !this.contentTemplate || !this.contentContainer) {
      return;
    }

    try {

      const templateContent = this.contentTemplate.content.cloneNode(true);

      this.contentContainer.innerHTML = '';
      this.contentContainer.appendChild(templateContent);

      this.contentLoaded = true;

      // this.initializeLoadedComponents();

    } catch (error) {
      console.error('Error loading deferred newsletter popup content:', error);
      // Fallback: show some basic content or error message
      this.contentContainer.innerHTML = '<div class="newsletter-popup-error">Content could not be loaded</div>';
    }
  }

  initializeLoadedComponents() {
    // Look for any custom elements that need initialization
    const customElements = this.contentContainer.querySelectorAll('[is], [data-ui-component]');

    customElements.forEach(element => {

      if (element.tagName.toLowerCase().startsWith('sht-')) {

        if (typeof element.init === 'function') {
          element.init();
        }
      }
    });
  }

  init() {
    // Check if we should show the popup based on page type
    if (this.showOnlyOnIndex && !window.location.pathname.match(/^\/$|^\/\?/)) {
      return;
    }

    this.bindEventHandlers();

    // Check if popup was already shown within the delay time
    if (this.getPopupStatus()) {
      // Newsletter popup was already shown, initialize sticky popup logic
      this.initStickyPopup();
      return;
    }

    this.initTrigger();
    this.initStickyPopup();

    // Initialize editor helper if in design mode
    if (Shopify.designMode && this.dataset.sectionId) {
      this.editorHelper = new SHTPopupEditorHelper(this, this.dataset.sectionId);
    }
  }

  /**
   * Bind all event handlers
   */
  bindEventHandlers() {
    // Close button event
    if (this.elms.close_btn) {
      this.elms.close_btn.addEventListener("click", this.boundCloseBtnClickHandle);
    }

    // Overlay click event
    if (this.elms.overlay) {
      this.elms.overlay.addEventListener("click", this.boundCloseBtnClickHandle);
    }

    // Sticky popup trigger button
    if (this.elms.trigger_btn) {
      this.elms.trigger_btn.addEventListener("click", this.boundTriggerBtnClickHandle);

      // Add event handler for sticky popup close button (if exists)
      this.stickyCloseBtn = this.elms.trigger_btn.querySelector('.icon-close, svg');
      if (this.stickyCloseBtn) {
        this.stickyCloseBtn.addEventListener("click", this.boundStickyCloseBtnClickHandle);
      }
    }

    // User interaction events - use cached body element and bound handler
    this.userEventTypes = ["mouseenter", "touchstart", "mouseover"];
    this.userEventTypes.forEach(eventType => {
      this.bodyElement.addEventListener(eventType, this.boundOnLoadUserAction);
    });

    this.popupAttrObserve();
  }
  
  /**
   * Clean up event listeners when component is removed
   */
  disconnectedCallback() {
    // Clean up event listeners to prevent memory leaks
    if (this.elms.close_btn) {
      this.elms.close_btn.removeEventListener("click", this.boundCloseBtnClickHandle);
    }
    
    if (this.elms.overlay) {
      this.elms.overlay.removeEventListener("click", this.boundCloseBtnClickHandle);
    }
    
    if (this.elms.trigger_btn) {
      this.elms.trigger_btn.removeEventListener("click", this.boundTriggerBtnClickHandle);
      
      if (this.stickyCloseBtn) {
        this.stickyCloseBtn.removeEventListener("click", this.boundStickyCloseBtnClickHandle);
      }
    }
    
    // Clean up user interaction events
    if (this.userEventTypes && this.bodyElement) {
      this.userEventTypes.forEach(eventType => {
        this.bodyElement.removeEventListener(eventType, this.boundOnLoadUserAction);
      });
    }
    
    // Remove scroll event listener if it exists
    if (this.trigger === "reaching-to-footer") {
      window.removeEventListener("scroll", this.boundScrollEventHandle);
    }
    
    // Clean up cart notification event
    if (this.cartNotification && this.cartNotificationHandler) {
      this.cartNotification.removeEventListener("closed", this.cartNotificationHandler);
    }
    
    // Clean up cart drawer event
    if (this.cartDrawer && this.cartDrawerHandler) {
      this.cartDrawer.removeEventListener("closed", this.cartDrawerHandler);
    }
    
    // Clear any pending timeouts
    if (this.delayTimeoutId) {
      clearTimeout(this.delayTimeoutId);
    }
    
    // Clean up mutation observer
    if (this.popupAttrObserver) {
      this.popupAttrObserver.disconnect();
      this.popupAttrObserver = null;
    }
    
    // Call parent disconnectedCallback if it exists
    if (super.disconnectedCallback) {
      super.disconnectedCallback();
    }
  }

  /**
   * Initialize the appropriate trigger for showing the popup
   * Supports multiple trigger types:
   * - reaching-to-footer: Shows when user scrolls to the footer
   * - after-closing-cart-notification: Shows after cart notification or drawer closes
   * - delay-after-page-load: Shows after a specified delay
   */
  initTrigger() {
    switch (this.trigger) {
      case "reaching-to-footer":
        // Sử dụng trực tiếp scroll handler để phản ứng ngay lập tức
        window.addEventListener("scroll", this.boundScrollEventHandle);
        break;

      case "after-closing-cart-notification":
        // Kiểm tra loại hiển thị giỏ hàng (popup notification hoặc drawer)
        if (this.cartShowType === "show_popup_noti" && this.cartNotification) {
          // Store the handler so we can remove it later if needed
          this.cartNotificationHandler = e => {
            try {
              // For after-closing-cart-notification, check if popup was already shown in this session
              const cartPopupShown = sessionStorage.getItem(this.cartNotificationSessionKey) === "true";

              // Only show if not already shown in this browser session
              if (!cartPopupShown) {
                this.togglePopup(true);
                // Mark as shown in this session
                sessionStorage.setItem(this.cartNotificationSessionKey, "true");
              }
            } catch (error) {
              console.warn('Error handling cart notification:', error);
            }
          };

          this.cartNotification.addEventListener("closed", this.cartNotificationHandler);
        } 
        // Nếu sử dụng cart drawer
        else if (this.cartShowType === "show_drawer" && this.cartDrawer) {
          // Store the handler so we can remove it later if needed
          this.cartDrawerHandler = e => {
            try {
              // Check if popup was already shown in this session
              const cartPopupShown = sessionStorage.getItem(this.cartNotificationSessionKey) === "true";

              // Only show if not already shown in this browser session
              if (!cartPopupShown) {
                this.togglePopup(true);
                // Mark as shown in this session
                sessionStorage.setItem(this.cartNotificationSessionKey, "true");
              }
            } catch (error) {
              console.warn('Error handling cart drawer:', error);
            }
          };

          this.cartDrawer.addEventListener("closed", this.cartDrawerHandler);
        }
        break;

      case "delay-after-page-load":
        // Store timeout ID so we can clear it if needed
        this.delayTimeoutId = setTimeout(() => {
          try {
            let popupStatus = this.getPopupStatus();
            if (!popupStatus) {
              this.togglePopup(true);
            }
          } catch (error) {
            console.warn('Error in delay trigger:', error);
          }
        }, this.delayUntil * 1000);
        break;
    }
  }

  initStickyPopup() {
    if (!this.stickyPopupEnabled) {
      return; // No sticky popup to manage
    }

    // Always hide sticky popup initially
    this.toggleStickyPopup(false);

    // If sticky popup was manually dismissed and the dismissal hasn't expired, keep it hidden
    if (this.getStickyPopupDismissedStatus()) {
      return;
    }

    // If newsletter popup was already shown/dismissed in previous sessions,
    // and we're not going to show it again in this session, then show sticky popup
    if (this.getPopupStatus()) {
      this.toggleStickyPopup(true);
    }
  }

  onUserAction(evt) {
    this.classList.contains("d-none") && this.classList.remove("d-none");
    evt.currentTarget.removeEventListener(evt.type, this.onLoadUserAction);
  }

  onScrollEventHandle(evt) {
    if (this.trigger !== "reaching-to-footer") {
      window.removeEventListener("scroll", this.boundScrollEventHandle);
      return;
    }

    this.myScrollHeight = document.body.scrollHeight || SHTHelper.qde.scrollHeight || 0;
    let scrollTop = window.pageYOffset || SHTHelper.qde.scrollTop || document.body.scrollTop || 0;
    let isReachingFooter = scrollTop + this.buffer + this.myWindowHeight >= this.myScrollHeight;

    let popupStatus = this.getPopupStatus();

    // Thêm kiểm tra manuallyClosedInSession để tránh hiển thị lại popup sau khi đóng thủ công
    if (isReachingFooter && (this.getAttribute("open") === null || this.getAttribute("open") === "") && !popupStatus && !this.manuallyClosedInSession) {
      this.togglePopup(true);
    }
  }

  onTriggerBtnClickHandle(e) {
    e.preventDefault();
    this.togglePopup(true);
  }

  onStickyCloseBtnClickHandle(e) {
    e.preventDefault();
    e.stopPropagation(); // Prevent triggering the parent button click
    // Hide sticky popup completely when close button is clicked
    this.toggleStickyPopup(false);

    // For after-closing-cart-notification, ensure popup doesn't reappear in this session
    if (this.trigger === "after-closing-cart-notification") {
      // Mark as shown in this session
      sessionStorage.setItem(this.cartNotificationSessionKey, "true");
      // Also set sticky popup dismissed in sessionStorage
      sessionStorage.setItem(this.stickyStorageKey, "true");
    }
    // For days delay option
    else if (this.delayTime === "days") {
      const now = new Date();
      const expiryTime = now.getTime() + (this.delayDays * 24 * 60 * 60 * 1000);

      // Set the same expiryTime for both popup and sticky popup
      this.myStorage.setItem(this.sessionStorageName, expiryTime.toString());
      this.myStorage.setItem(this.stickyStorageKey, expiryTime.toString());
    } else {
      // For other delay types, use the standard dismissal logic
      this.setStickyPopupDismissedStatus(true);
      this.setPopupStatus();
    }
  }

  onCloseBtnClickHandle(e) {
    e.preventDefault();
    // Đánh dấu popup đã được đóng thủ công trong phiên hiện tại
    this.manuallyClosedInSession = true;
    
    // For after-closing-cart-notification, ensure popup doesn't reappear in this session
    if (this.trigger === "after-closing-cart-notification") {
      // Mark as shown in this session
      sessionStorage.setItem(this.cartNotificationSessionKey, "true");
    }
    
    this.togglePopup(false);
  }

  togglePopup(toggle) {
    let isSuccess = this.$(".js-success");

    if (toggle && !isSuccess) {
      // Opening newsletter popup

      // Always hide sticky popup when newsletter popup is opened
      if (this.stickyPopupEnabled) {
        this.toggleStickyPopup(false);
      }

      // Then show the newsletter popup
      this.toggleOpen(true);
    } else {
      // Closing newsletter popup

      // First close the newsletter popup
      this.toggleOpen(false);

      // Set popup status to remember it was shown
      this.setPopupStatus();

      // Then handle sticky popup logic when newsletter popup is closed
      if (this.stickyPopupEnabled && !this.getStickyPopupDismissedStatus()) {
        // Only show sticky popup if:
        // 1. Sticky popup is enabled in settings
        // 2. It wasn't manually dismissed by clicking the close button
        setTimeout(() => {
          this.toggleStickyPopup(true);
        }, 500); // Small delay for better UX after newsletter popup animation completes
      }
    }
  }

  toggleOpen(open) {
    if (open) {
      // Load deferred content before showing the popup
      this.loadDeferredContent();

      // First show the overlay
      if (this.elms.overlay) {
        this.elms.overlay.classList.add("animate-in");
        this.elms.overlay.classList.remove("animate-out");
      }

      // Then show the popup with animation
      this.elms.body.classList.add("is-newsletter-popup-show");
      this.setAttribute("open", true);
      this.classList.remove("is-closing");
    } else {
      // Start the closing animation
      this.classList.add("is-closing");

      // Add animation class to overlay
      if (this.elms.overlay) {
        this.elms.overlay.classList.add("animate-out");
        this.elms.overlay.classList.remove("animate-in");
      }

      setTimeout(() => {
        // First remove the is-closing class to stop the animation
        this.classList.remove("is-closing");
        // Then remove the open attribute and other classes
        this.removeAttribute("open");
        this.elms.body.classList.remove("is-newsletter-popup-show");
        SHTHelper.removeTrapFocus();
      }, 350);
    }
  }

  /**
   * Helper method to set a cookie with no expiry date
   * @param {string} name - Cookie name
   * @param {string} value - Cookie value
   */
  setCookie(name, value) {
    try {
      // Set cookie with path=/ and no expiry date so it persists until manually cleared
      document.cookie = `${name}=${value}; path=/;`;
    } catch (error) {
      console.warn(`Failed to set cookie ${name}:`, error);
    }
  }

  /**
   * Helper method to get a cookie by name
   * @param {string} name - Cookie name
   * @return {string|null} Cookie value or null if not found
   */
  getCookie(name) {
    try {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? match[2] : null;
    } catch (error) {
      console.warn(`Failed to get cookie ${name}:`, error);
      return null;
    }
  }

  /**
   * Remove a cookie by setting its expiry date to the past
   * @param {string} name - Cookie name
   */
  removeCookie(name) {
    try {
      document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    } catch (error) {
      console.warn(`Failed to remove cookie ${name}:`, error);
    }
  }

  /**
   * Store a value using the appropriate storage mechanism based on delayTime
   * @param {string} key - Storage key
   * @param {string|number} value - Value to store
   * @param {string} [storageType] - Override storage type
   */
  setStorageValue(key, value, storageType = null) {
    try {
      const type = storageType || this.delayTime;
      const now = new Date();

      switch (type) {
        case "session":
          sessionStorage.setItem(key, String(value));
          break;

        case "cookies":
          this.setCookie(key, String(value));
          break;

        case "days":
          const expiryTime = now.getTime() + (this.delayDays * 24 * 60 * 60 * 1000);
          this.myStorage.setItem(key, String(expiryTime));
          break;

        default:
          sessionStorage.setItem(key, String(value));
      }
    } catch (error) {
      console.warn(`Failed to set storage for ${key}:`, error);
    }
  }

  removeStorageValue(key, storageType = null) {
    try {
      const type = storageType || this.delayTime;

      switch (type) {
        case "session":
          sessionStorage.removeItem(key);
          break;

        case "cookies":
          this.removeCookie(key);
          break;

        case "days":
        default:
          this.myStorage.removeItem(key);
          break;
      }
    } catch (error) {
      console.warn(`Failed to remove storage for ${key}:`, error);
    }
  }

  /**
   * Get a value from the appropriate storage mechanism
   * @param {string} key - Storage key
   * @param {string} [storageType] - Override storage type
   * @return {string|boolean|null} - Stored value, true/false for boolean values, or null if not found
   */
  getStorageValue(key, storageType = null) {
    if (Shopify.designMode) {
      return null;
    }

    try {
      const type = storageType || this.delayTime;

      switch (type) {
        case "session":
          return sessionStorage.getItem(key);

        case "cookies":
          return this.getCookie(key);

        case "days":
          const storedValue = this.myStorage.getItem(key);
          if (!storedValue) {
            return null;
          }

          const now = new Date().getTime();
          const expiryTime = parseInt(storedValue);

          if (now >= expiryTime) {
            // Expired, remove the item and return null
            this.myStorage.removeItem(key);
            return null;
          }

          return storedValue;

        default:
          return sessionStorage.getItem(key);
      }
    } catch (error) {
      console.warn(`Failed to get storage for ${key}:`, error);
      return null;
    }
  }

  /**
   * Set popup status to remember it was shown
   */
  setPopupStatus() {
    this.setStorageValue(this.sessionStorageName, "true");
  }

  /**
   * Check if popup was already shown
   * @return {boolean} True if popup was already shown
   */
  getPopupStatus() {
    if (Shopify.designMode) {
      return false;
    }

    const value = this.getStorageValue(this.sessionStorageName);

    if (this.delayTime === "days") {
      // For days option, getStorageValue returns the expiry time or null
      return value !== null;
    } else {
      // For other options, check for "true" value
      return value === "true";
    }
  }

  /**
   * Set sticky popup dismissed status
   * @param {boolean} dismissed - Whether sticky popup is dismissed
   */
  setStickyPopupDismissedStatus(dismissed) {
    if (dismissed) {
      this.setStorageValue(this.stickyStorageKey, "true");
    } else {
      this.removeStorageValue(this.stickyStorageKey);
    }
  }

  /**
   * Check if sticky popup was dismissed
   * @return {boolean} True if sticky popup was dismissed
   */
  getStickyPopupDismissedStatus() {
    if (Shopify.designMode) {
      return false; // Always allow sticky popup in design mode
    }

    const value = this.getStorageValue(this.stickyStorageKey);

    if (this.delayTime === "days") {
      // For days option, getStorageValue returns the expiry time or null
      return value !== null;
    } else {
      // For other options, check for "true" value
      return value === "true";
    }
  }

  toggleStickyPopup(show) {
    if (!this.elms.trigger_btn) return;

    if (show) {
      // Use class instead of inline style for better transition
      this.elms.trigger_btn.classList.add('is-visible');
    } else {
      this.elms.trigger_btn.classList.remove('is-visible');
    }
  }

  /**
   * Observe changes to the open attribute to handle popup open/close events
   */
  popupAttrObserve() {
    try {
      // Store observer in instance property so we can disconnect it later
      this.popupAttrObserver = new MutationObserver((mutations, observer) => {
        mutations.forEach(async mutation => {
          try {
            if (mutation.attributeName === "open") {
              const isOpen = this.hasAttribute("open");

              if (isOpen) {
                await this.animationsComplete();
                this.dispatchEvent(new Event("opened"));
                SHTHelper.trapFocus(this);

                // Find and focus on the email input if it exists
                const emailInput = this.querySelector('input[type="email"]');
                if (emailInput) {
                  emailInput.focus();
                }
              } else {
                // Popup is now fully closed (after the delay)
                // No need to wait for animations as we've already delayed in toggleOpen
                this.dispatchEvent(new Event("closed"));
              }
            }
          } catch (error) {
            console.warn('Error handling popup attribute change:', error);
          }
        });
      });

      this.popupAttrObserver.observe(this, {
        attributes: true,
      });
    } catch (error) {
      console.error('Failed to initialize popup attribute observer:', error);
    }
  }

  /**
   * Wait for all animations to complete
   * @return {Promise} Promise that resolves when all animations are complete
   */
  animationsComplete() {
    try {
      return Promise.allSettled(this.getAnimations().map(animation => animation.finished));
    } catch (error) {
      console.warn('Error waiting for animations to complete:', error);
      return Promise.resolve(); // Return resolved promise to continue execution
    }
  }
}

customElements.define("sht-newsletter-popup", SHTNewsletterPopup);

class SHTImageATF extends HTMLElement {
  constructor() {
    super();
    this.imageElement = null;
    this.pictureElement = null;
    this.loadAttempted = false;
    this.intersectionObserver = null;
    this.mutationObserver = null;
  }

  connectedCallback() {
    this.findImage() ? this.init() : this.waitForImage();
    this.setupIntersectionObserver();
  }

  findImage() {
    this.pictureElement = this.querySelector('picture');
    this.imageElement = this.pictureElement?.querySelector('img') || this.querySelector('img');
    return this.imageElement;
  }

  waitForImage() {
    this.mutationObserver?.disconnect();
    this.mutationObserver = new MutationObserver(() => {
      if (this.findImage()) {
        this.mutationObserver.disconnect();
        this.mutationObserver = null;
        this.init();
      }
    });
    this.mutationObserver.observe(this, { childList: true, subtree: true });
  }

  init() {
    if (!this.imageElement) return;

    // Check if already loaded
    if (this.imageElement.src && this.imageElement.complete && this.imageElement.naturalHeight !== 0) {
      this.loadAttempted = true;
      this.handleImageLoad();
      return;
    }

    // Setup load/error handlers
    if (this.imageElement.complete && this.imageElement.naturalHeight !== 0) {
      this.handleImageLoad();
    } else {
      this.imageElement.addEventListener('load', () => this.handleImageLoad(), { once: true });
      this.imageElement.addEventListener('error', () => {
        this.classList.add('image-loader--error');
        console.warn('Image failed to load:', this.imageElement?.src || 'unknown source');
        this.cleanup();
      }, { once: true });
    }
  }

  setupIntersectionObserver() {
    this.intersectionObserver?.disconnect();
    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !this.loadAttempted) {
          this.loadAttempted = true;
          this.loadImage();
        }
      },
      { rootMargin: '50px 0px', threshold: 0.01 }
    );
    this.intersectionObserver.observe(this);
  }

  loadImage() {
    if (!this.imageElement) return;

    this.imageElement.removeAttribute('loading');

    // Handle picture sources
    this.pictureElement?.querySelectorAll('source[data-srcset]').forEach(source => {
      source.srcset = source.getAttribute('data-srcset');
      source.removeAttribute('data-srcset');
    });

    // Handle image src/srcset
    const dataSrc = this.imageElement.getAttribute('data-src');
    if (dataSrc && !this.imageElement.src) {
      this.imageElement.src = dataSrc;
      this.imageElement.removeAttribute('data-src');
    }

    const dataSrcset = this.imageElement.getAttribute('data-srcset');
    if (dataSrcset && !this.imageElement.srcset) {
      this.imageElement.srcset = dataSrcset;
      this.imageElement.removeAttribute('data-srcset');
    }
  }

  handleImageLoad() {
    this.classList.add('image-loader--loaded');
    this.cleanup();
  }

  cleanup() {
    this.intersectionObserver?.disconnect();
    this.mutationObserver?.disconnect();
    this.intersectionObserver = this.mutationObserver = null;
  }

  disconnectedCallback() {
    this.cleanup();
    this.loadAttempted = false;
  }
}

customElements.define("sht-image-atf", SHTImageATF);
// Initialize global features when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => SHTCustomComponent.initGlobalFeatures());
} else {
  SHTCustomComponent.initGlobalFeatures();
}

if (!customElements.get("sht-predictive-srch")) {
  class SHTPredictiveSearch extends SHTCustomComponent {
    constructor() {
      super();
      //this.$ = this.querySelector.bind(this);

      this.cachedRequests = new Map();
      this.resultsPanelMaxHeight = 0;
      this.notificationMessage = this.dataset.noti || 'Quick Search section is currently hidden. Please enable the Quick Search section in the theme editor to use this feature.';
      this.elms = {
        predictive_search_form: this.$(`.js-predictive-search-form`),
        predictive_search_input: this.$(`.js-predictive-search-input`),
        predictive_search_results: this.$(`.js-predictive-search-results`),
        predictive_search_result_panel: this.$(`.js-predictive-search-results-panel`),
        predictive_search_message_placeholder: this.$(`.js-predictive-search-message-placeholder`),
        predictive_search_loading: this.$(".js-predictive-search-loading"),
        predictive_close_button: this.$(".js-predictive-search-close-trigger"),
        predictive_overlay: this.$(".js-predictive-search-results-panel-overlay"),
        header: this.closest("sht-header"),
        header_search_open_trigger: this.closest("sht-header")?.querySelector(".js-search-open-trigger"),
        body: document.body,
        enable_predictive: this.dataset.enablePredictive === "true",
      };

      this.url = {
        searchUrl: routes.predictive_search_url,
        queryParameters: {
          section_id: "sht-predictive-srch",
          resources: {
            limit: 10,
            options: {
              unavailable_products: "last",
              fields: "",
            },
          },
        },
      };

      this.shopifyFeaturesJson = JSON.parse(SHTHelper.qs(`#shopify-features[type="application/json"]`).textContent);

      this.code = "";

      if (!this.elms.enable_predictive) return;

      this.bindEventHandlers();
    }

    bindEventHandlers() {
      this.elms.predictive_search_form.addEventListener("submit", this.onSubmitHandle.bind(this));

      this.elms.predictive_search_input.addEventListener(
        "input",
        SHTHelper.debounce(event => {
          this.onInputHandle(event);
        }, 300).bind(this)
      );

      this.elms.predictive_search_input.addEventListener("focus", this.onInputFocusHandle.bind(this));

      // this.addEventListener("focusout", this.onFocusOutHandle.bind(this));

      this.elms.predictive_close_button.addEventListener("click", this.closeSearchResults.bind(this));

      if (this.elms.predictive_overlay) {
        this.elms.predictive_overlay.addEventListener("click", this.closeSearchResults.bind(this));
      }

      this.addEventListener("keyup", event => {
        this.code = event.code.toUpperCase();

        event.code.toUpperCase() === "ESCAPE" && this.closeSearchResults();
      });

      if (Shopify.designMode && this.dataset.sectionId) {
        this.editorHelper = new SHTPredictiveSearchEditorHelper(this, this.dataset.sectionId);
      }
    }

    onSubmitHandle(e) {
      let searchTerm = this.getSearchTerm();
      if (!searchTerm) {
        e.preventDefault();
      }
    }

    onInputFocusHandle(e) {
      let searchTerm = this.getSearchTerm();
      this.openSearchResults(searchTerm);
    }

    getSearchTerm() {
      return this.elms.predictive_search_input.value.trim();
    }

    openSearchResults(searchTerm) {
      if (!searchTerm.length) {
        this.resetSearchResultPanel();
        this.togglePlaceHolderMessage(true);
        this.toggleLoading(false);
        this.toggleLoadingContainer(false);
        this.toggleResults(false);
      } else {
        this.togglePlaceHolderMessage(false);
      }

      this.toggleOpen(true);
      this.toggleSearchResults(true);
      this.elms.predictive_search_input.setAttribute("aria-expanded", true);
    }

    resetSearchResultPanel() {
      this.elms.predictive_search_result_panel.innerHTML = "";
    }

    toggleResults(results) {
      if (results) {
        this.setAttribute("results", true);
        setTimeout(
          function () {
            this.classList.add("is-result-show");
          }.bind(this),
          300
        );
      } else {
        this.removeAttribute("results");
        this.classList.remove("is-result-show");
      }
      return;
    }

    toggleOpen(open) {
      if (open) {
        this.setAttribute("open", true);
        //this.toggleAttribute("hidden", false);
        document.body.classList.add("header--predictive-search-open");
        this.elms.body.classList.add("o-hidden");
      } else {
        this.removeAttribute("open");
        //this.setAttribute("hidden", true);
        document.body.classList.remove("header--predictive-search-open");
        this.elms.body.classList.remove("o-hidden");
      }
      return;
    }

    async onInputHandle(e) {
      if (!this.shopifyFeaturesJson.predictiveSearch || this.code === "ESCAPE") {
        return;
      }

      let searchTerm = this.getSearchTerm();
      this.openSearchResults(searchTerm);
      this.resetSearchResultPanel();
      if (!searchTerm.length) {
        return;
      }

      let markup = await this.getSearchResults(searchTerm);
      this.renderSearchResultPanel(markup);
    }

    renderSearchResultPanel(markup) {
      this.elms.predictive_search_result_panel.innerHTML = markup;
      this.toggleResults(true);
      this.toggleLoading(false);
      this.toggleLoadingContainer(false);

      // Không trap focus trong designMode để user có thể type vào settings
      if (!Shopify.designMode) {
        SHTHelper.trapFocus(this);
      }
    }

    async getSearchResults(searchTerm) {
      let qKey = searchTerm.replace(/\s/g, "-").toLowerCase();

      let cached = this.cachedRequests.get(qKey);

      if (!cached) {
        let markup = await this.fetchResults(searchTerm);
        this.cachedRequests.set(qKey, markup);
        return markup;
      }
      return cached;
    }

    onSubmitHandle(e) {
      let searchTerm = this.getSearchTerm();
      if (!searchTerm) {
        e.preventDefault();
      }
    }

    async fetchResults(q) {
      let url = `${this.url.searchUrl}?q=${encodeURIComponent(q)}&resources[limit_scope]=each&section_id=predictive-search`;
      this.toggleLoading(true);
      this.toggleLoadingContainer(true);
      let results = await fetch(url)
        .then(response => {
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }
          return response.text();
        })
        .then(text => {
          this.toggleLoading(false);
          this.toggleLoadingContainer(false);
          const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
          return resultsMarkup;
        })
        .catch(error => {
          console.error(error);
          return "";
        });
      return results;
    }

    toggleSearchResults(show) {
      if (!this.shopifyFeaturesJson.predictiveSearch) {
        show = false;
      }

      if (show) {
        this.elms.predictive_search_results.toggleAttribute("hidden", false);
      } else {
        this.elms.predictive_search_results.setAttribute("hidden", true);
      }
      return;
    }

    toggleLoading(loading) {
      if (loading) {
        this.elms.predictive_search_loading.toggleAttribute("hidden", false);
      } else {
        this.elms.predictive_search_loading.setAttribute("hidden", true);
      }
      return;
    }

    togglePlaceHolderMessage(show) {
      if (show) {
        this.elms.predictive_search_message_placeholder.toggleAttribute("hidden", false);
      } else {
        this.elms.predictive_search_message_placeholder.setAttribute("hidden", true);
      }
      return;
    }

    // onFocusOutHandle(e) {
    //   if (Shopify.designMode) {
    //     return;
    //   }

    //   let searchTerm = this.getSearchTerm();
    //   setTimeout(() => {
    //     if (!this.contains(document.activeElement)) {
    //       this.closeSearchResults(true);
    //     }
    //   });
    // }

    toggleLoadingContainer(loading) {
      if (loading) {
        this.setAttribute("loading", true);
      } else {
        this.removeAttribute("loading");
      }
      return;
    }

    closeSearchResults(removeFocus = false) {
      this.toggleOpen(false);
      this.toggleLoading(false);
      this.toggleLoadingContainer(false);
      this.togglePlaceHolderMessage(false);
      this.toggleResults(false);
      this.resetSearchResultPanel();
      this.toggleSearchResults(false);

      if (this.elms.header_search_open_trigger && !removeFocus) {
        SHTHelper.removeTrapFocus(this.elms.header_search_open_trigger);
      }

      this.resultsPanelMaxHeight = 0;
      this.elms.predictive_search_result_panel.removeAttribute("style");
      this.elms.predictive_search_input.value = "";
      this.elms.predictive_search_input.setAttribute("aria-expanded", false);
    }

    calculateResultsPanelMaxHeight() {
      this.resultsPanelMaxHeight = window.innerHeight - SHTHelper.qid("shopify-section-header").getBoundingClientRect().bottom;
      return this.resultsPanelMaxHeight;
    }
  }

  customElements.define("sht-predictive-srch", SHTPredictiveSearch);
}
class SHTMainSearch extends HTMLElement {
  constructor() {
    super();

    this.hasProduct = this.querySelector('.js-main-search-result-product') !== null;
    if(!this.hasProduct) {
      this.querySelector('.filter--vertical').classList.add('d-none-important');
    }
  }
}
customElements.define("sht-srch", SHTMainSearch);